document.addEventListener("DOMContentLoaded", function () {

/* =================================================
   CONSTANTS
================================================= */

const VALID_DAYS = ["monday", "tuesday", "wednesday", "thursday", "friday"];
const main_section_wrapper = document.querySelector('.order-tiffin-main-container')
const next_week_menu_msg = document.querySelector('.new-menu-comming-soon-msg ')
 const global_filter_tagsAll = document.querySelectorAll('.global-filter-value');
 const global_filter_wrapper = document.querySelector('.filter-tag-container');
const clear_filter_tag = document.querySelector('.clear-filter-tag');
const checkoutbtncartpage = document.querySelector('.t4s-btn__checkout_button');
const addanothertiffinButton = document.querySelector('.tiffin-add-anothertiffin-btn');
const gotonextdaybutton = document.querySelector('.tiffin-goto-nextday-btn');
const mobilecartsummaryprice = document.querySelector('.mobile-header-price')
const htloaderwrap = document.querySelector('.ht-loader-main-wrapper');
const checkout_button_cartpage = document.querySelector('.t4s-btn__checkout_button')

const isMobile = window.innerWidth < 768;
const FALLBACK_IMG = "https://www.myhealthytiffin.com/cdn/shop/files/LOGO_600x.png?v=1739165747";
const FALLBACK_IMG_Lunch= "https://cdn.shopify.com/s/files/1/0662/4595/1679/files/healthytiffinimage_2fafe70c-db61-42eb-9510-b33f015df4b6.jpg?v=1775722427";

const DAY_INDEX = {
  sunday: 0,
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6
};


/* =================================================
   SWIPER
================================================= */

function initSwiper() {
  if (window.swiper) {
    window.swiper.update();
    return;
  }
  window.swiper = new Swiper(".swiper-container", {
    slidesPerView: 6,
    spaceBetween: 5,
    loop: false,
    slideToClickedSlide: true,
  });
}

// SWIPER FOR ALA CARTE CATEGORIES ON MOBILE
  new Swiper(".alacarteSwiper", {
  slidesPerView: "4",
  spaceBetween: 12,
  freeMode: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  }
});

// SWIPER FOR ALA CARTE CATEGORIES ON MOBILE
  new Swiper(".lunchcarteSwiper", {
  slidesPerView: "4",
  spaceBetween: 12,
  freeMode: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  }
});

let lunchSwiper;

function initLunchSwiper() {
  if (lunchSwiper) {
    lunchSwiper.destroy(true, true);
  }

  lunchSwiper = new Swiper(".lunchcarteSwiper", {
    slidesPerView: "auto",
    spaceBetween: 12,
    freeMode: true,
    watchOverflow: false,
    navigation: {
      nextEl: ".lunch-sidebar-slider .swiper-button-next",
      prevEl: ".lunch-sidebar-slider .swiper-button-prev",
    },
  });
}

let pantrySwiper;

function initPantrySwiper() {
  if (pantrySwiper) {
    pantrySwiper.destroy(true, true);
  }

  pantrySwiper = new Swiper(".pantrycarteSwiper", {
    slidesPerView: "auto",
    spaceBetween: 12,
    freeMode: true,
    watchOverflow: false,
    navigation: {
      nextEl: ".lunch-sidebar-slider .swiper-button-next",
      prevEl: ".lunch-sidebar-slider .swiper-button-prev",
    },
  });
}



// SWIPER FOR ALA CARTE CATEGORIES ON MOBILE
  new Swiper(".pantrycarteSwiper", {
  slidesPerView: "4",
  spaceBetween: 12,
  freeMode: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  }
});

/* =================================================
  sCROLL TO TOP FUNCTION
================================================= */
function scrollToTop()
{ 
   const selectionWrap = document.querySelector(".order-tiffin-product-wrapper");
   if (selectionWrap) {
    const elementTop = selectionWrap.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ 
         top: elementTop - 200, 
         behavior: "smooth" 
        });
    }
}

/* =================================================
  TOAST MESSAGE
================================================= */

function showToast(msg) {
  if (typeof toastr !== "undefined") {
    toastr.success(msg);
  } else {
    console.log(msg);
  }
}

// 
function pageLoaderChange()
{ 
  if(htloaderwrap) htloaderwrap.style.display='none';
  if(main_section_wrapper) main_section_wrapper.style.display='block';
  if(gotonextdaybutton) gotonextdaybutton.style.display='flex'
}


/* =================================================
   LA TIME
================================================= */

function getTodayLaDateTime() {
  const laTimeString = new Date().toLocaleString("en-US", {
    timeZone: "America/Los_Angeles",
  });
  const laDate = new Date(laTimeString);

  return {
    laDate,
    currentHour: laDate.getHours(),
    day: laDate.toLocaleString("en-US", { weekday: "long" }).toLowerCase()
  };
}

/* =================================================
   UPDATE TIFFIN TYPE SELECTOR BUTTON CLASS TIFFIN OR ALA SELECTOR ON TOP
================================================= */

function updateTypeSelectorButtonClass(type) {
  const buttons = document.querySelectorAll('.order-tiffin-type-btn');
  buttons.forEach(button => {
    const buttonType = button.getAttribute('data-value');
    if (buttonType === type) {
      button.classList.add('active');
    } else {
      button.classList.remove('active');
    }
  });
}


/* =================================================
   DATE HELPERS
================================================= */

function getDateFromWeekday(weekday) {
  const { laDate } = getTodayLaDateTime();
  const diff = DAY_INDEX[weekday] - laDate.getDay();
  const result = new Date(laDate);
  result.setDate(laDate.getDate() + diff);
  return result;
}


function getDayObjByHandle(dayHandle) {
  return window.menuData.find(d => d.handle === dayHandle) || null;
}


/* =================================================
   UPDATE NAVIGATION BUTTON OF CALENDAR
================================================= */

function updateNavigationButtons() {
  const buttons = document.querySelectorAll(".tiffin-calendar-day-btn");
  if (!buttons.length) return;
  const active = document.querySelector(".active-day");
  document.getElementById("prevDay").classList.toggle("disabled", active === buttons[0]);
  document.getElementById("nextDay").classList.toggle("disabled", active === buttons[buttons.length - 1]);
}

/* =================================================
   GET FORMATED WEEK RANGE
================================================= */


function getWeekRangeFromUI() {
  const buttons = document.querySelectorAll("#weekContainer .tiffin-calendar-day-btn");

  if (!buttons.length) return "No menu available";

  const ordinal = (n) =>
    n % 10 === 1 && n % 100 !== 11 ? `${n}st`
    : n % 10 === 2 && n % 100 !== 12 ? `${n}nd`
    : n % 10 === 3 && n % 100 !== 13 ? `${n}rd`
    : `${n}th`;

  const getDate = (btn) => {
    const dayNum = btn.querySelector(".day-number")?.innerText;
    return parseInt(dayNum, 10);
  };

  const getMonth = (btn) => {
    return btn.dataset.date; // example: "May", "June"
  };

  const startBtn = buttons[0];
  const endBtn = buttons[buttons.length - 1];

  const start = getDate(startBtn);
  const end = getDate(endBtn);

  const startMonth = getMonth(startBtn);
  const endMonth = getMonth(endBtn);

  if (start === end && startMonth === endMonth) {
    return `${ordinal(start)} ${startMonth}`;
  }

  return `${ordinal(start)} ${startMonth} - ${ordinal(end)} ${endMonth}`;
}

/* =================================================
   ACTIVE DAY LOGIC START
================================================= */

function computeActiveDaysData(menuData, menuCutOffData, appcontextdata) {
 const { laDate, currentHour, day } = getTodayLaDateTime();
 let todayName = day; 
 let  todayIndex = laDate.getDay();



  let activeDay = null;
  let isSunSat = false;
  let show_out_of_stock_msg = false;
  let show_upcoming_menu_msg = false;
  let no_day_available = false;
  let nextweekday=false  //this is to check if the date is from next week or current week
 if (todayName === 'sunday' || todayName === 'saturday') {
  isSunSat = true;
  if(todayName =='saturday')
  { 
    nextweekday = true;
  }
  todayName = 'monday';
  todayIndex = 1;
  }

  // If not Monday–Friday
  if (!VALID_DAYS.includes(todayName)) {
    window.activeDaysData = {
      activeDay: null,
      show_out_of_stock_msg: false,
      show_upcoming_menu_msg: false,
      no_day_available: true
    };
    return window.activeDaysData;
  }


  const cutOffToday = menuCutOffData?.[todayName];

  // Hide check based on menu type
  const isMenuHidden = (menu) => {
    if (!menu) return true;
    if (appcontextdata === "tiffin" || appcontextdata === "ala") {
       if (menu.menu_missing) return false;
      return menu.hide_tiffin_ala_menu;
    }

     
    if (appcontextdata === "pantry") {
          if(!menu) return false;
      return menu.hide_pantry_menu;
    }

    if (appcontextdata === "lunch") {
          if(!menu) return false;
      return menu.hide_lunch_menu;
    }

    return false;
  };



  const isDayUsable = (day) => {
  const menu = menuData.find(m => m.handle === day);

  console.log('emnu checking with day',day,menu)

   if (appcontextdata === "tiffin") {
    if(!menu) return false;
    if (menu?.menu_missing) return false;
  }

  if (appcontextdata === "lunch") {
        if(!menu) return false;
    if (menu.hide_lunch_menu) return false;
 
    const categories = menu.lunch.categories || [];
    const hasLunchProducts = categories.some(cat =>
      Array.isArray(cat?.products) && cat.products.length > 0
    );

    if (!hasLunchProducts) return false;
  }

  if (appcontextdata === "pantry") {
     if(!menu) return false;
    if (menu.pantry == null ) return false;

    const categories = menu.pantry.categories || [];
    const hasPantryProducts = categories.some(cat =>
      (Array.isArray(cat?.products) && cat.products.length > 0) ||
      (Array.isArray(cat?.subcategories) &&
        cat.subcategories.some(sub =>
          Array.isArray(sub?.products) && sub.products.length > 0
        ))
    );

    if (!hasPantryProducts) return false;
  }

  const dayIndex = DAY_INDEX[day];
  if(isSunSat)
  { 
     if (dayIndex >= todayIndex) return true;
  } else { 
  if (dayIndex > todayIndex) return true;
  if (dayIndex === todayIndex) {
    if (!cutOffToday) return true;
    return currentHour < cutOffToday.cutOff;
  }
  }


  return false;
};

  const findNextUsableDay = () => VALID_DAYS.find(d => isDayUsable(d)) || null;
  const hasAnyUsableDay = () => VALID_DAYS.some(d => isDayUsable(d));

  // NORMAL DAYS (Monday–Thursday)
  if (todayName !== "friday") {
    if (isDayUsable(todayName)) {
      activeDay = todayName;
    } else {
      if (cutOffToday && currentHour >= cutOffToday.cutOff && cutOffToday.disable) {
        show_out_of_stock_msg = true;
      }
      activeDay = findNextUsableDay();
    }
  }

 // FRIDAY SPECIAL LOGIC (HARDCODED)

 if (todayName === 'friday' && cutOffToday) {
  const afterCutoff = currentHour >= cutOffToday.cutOff;
  const nextweekmenuHide = cutOffToday.nextweekmenuHide;
  const nextweekmenuShowTime = cutOffToday.nextweekmenuShowTime

  // BEFORE CUTOFF
  if (!afterCutoff) {

    if (cutOffToday.disable) {
      show_out_of_stock_msg = true;
      activeDay = null;
    } else {
      activeDay = 'friday';
    }

  }

  // AFTER CUTOFF → HIDE NEXT WEEK MENU TEMPORARILY
  else if (
    afterCutoff &&
    nextweekmenuHide &&
    currentHour < nextweekmenuShowTime
  ) {
    activeDay = null;
    show_upcoming_menu_msg = true;

  }

  // AFTER CUTOFF → SHOW NEXT WEEK MENU
  else if (
    afterCutoff &&
    !nextweekmenuHide &&
    currentHour >= nextweekmenuShowTime
  ) {
    const nextWeekDay = VALID_DAYS.find(day => {
  const menu = menuData.find(m => m.handle === day);

  if (!menu || isMenuHidden(menu)) return false;

   if (appcontextdata === "tiffin") {
    if (menu.menu_missing) return false;
  }


  if (appcontextdata === "pantry") {
    if (!menu.pantry) return false;

    const categories = menu.pantry.categories || [];

    const hasData = categories.some(cat =>
      (cat.products?.length > 0) ||
      (cat.subcategories?.some(sub => sub.products?.length > 0))
    );

    if (!hasData) return false;
  }

    if (appcontextdata === "lunch") {
    // if (!menu.lunch) return false;

    const categories = menu.lunch.categories || [];

    const hasData = categories.some(cat =>
      cat.products?.length > 0
    );

    if (!hasData) return false;
  }

  return true;
    });

    activeDay = nextWeekDay || null;
    nextweekday=true;
  }
 }
 
  // If no active day at all
  if (!activeDay && !hasAnyUsableDay()) {
    no_day_available = true;
  }

  window.activeDaysData = {
    activeDay,
    show_out_of_stock_msg,
    show_upcoming_menu_msg,
    no_day_available,
    nextweekday
  };

  return window.activeDaysData;
}

 document.addEventListener("click", function (event) {
    const moreBtn = event.target.closest(".popup-description-more");
    const lessBtn = event.target.closest(".popup-description-less");
   console.log('elooooooooooooo',moreBtn,lessBtn)

    const wrapper = event.target.closest(".popup-description-wrapper");
    console.log('wrapper ',wrapper)
    if (!wrapper) return;

    if (moreBtn) {
      wrapper.classList.add("is-expanded");
    }

    if (lessBtn) {
       wrapper.classList.remove("is-expanded");
    }
  });

/* =================================================
  RETURNS THE SHOWABLE DAYS TO SHOW ON CALENDAR
================================================= */

function getRenderableDays(menuData, menuType) {
  const activeData = window.activeDaysData || {};
  const { laDate, currentHour } = getTodayLaDateTime();
  const todayIndex = laDate.getDay();

  if (activeData.show_upcoming_menu_msg || activeData.no_day_available) {
    return [];
  }

  const isSameTypeUsable = (item) => {
    const handle = item.handle?.toLowerCase();
    if (!VALID_DAYS.includes(handle)) return false;

    if (menuType === "tiffin" || menuType === "ala") {
      if (item.hide_tiffin_ala_menu) return false;
      if (item.menu_missing) return false;
    }

    if (menuType === "pantry") {
      if (item.hide_pantry_menu) return false;
      if (!item.pantry) return false;

      const hasData = item.pantry.categories?.some(
        (cat) =>
          (cat.products?.length > 0) ||
          (cat.subcategories?.some((sub) => sub.products?.length > 0))
      );

      if (!hasData) return false;
    }

    if (menuType === "lunch") {
      if (item.hide_lunch_menu) return false;
      if (!item.lunch) return false;

      const hasData = item.lunch.categories?.some(
        (cat) => cat.products?.length > 0
      );

      if (!hasData) return false;
    }

    return true;
  };

  const validItems = menuData
    .filter(isSameTypeUsable)
    .sort((a, b) => DAY_INDEX[a.handle] - DAY_INDEX[b.handle]);

  // If next week is active, show full Monday-Friday
  if (activeData.nextweekday) {
    return validItems;
  }

  // Otherwise start from activeDay if available
  const startDay = activeData.activeDay;
  if (startDay) {
    const startIndex = validItems.findIndex(
      (item) => item.handle?.toLowerCase() === startDay
    );

    if (startIndex !== -1) {
      return validItems.slice(startIndex);
    }
  }

  // Fallback: use today's filtering
  return validItems.filter((item) => {
    const handle = item.handle?.toLowerCase();
    const dayIndex = DAY_INDEX[handle];

    if (dayIndex < todayIndex) return false;

    if (dayIndex === todayIndex) {
      const cutOff = window.menuCutOffData?.[handle];
      if (cutOff && currentHour > cutOff.cutOff) return false;
    }

    return true;
  });
}

/* =================================================
Mon,tue and date day return function
================================================= */
// function getshortDayandNumberValue(day) {
//   const data = window.activeDaysData || {};
//   const isNextWeekday = !!data.nextweekday;

//   const dayMap = {
//     sunday: 0,
//     monday: 1,
//     tuesday: 2,
//     wednesday: 3,
//     thursday: 4,
//     friday: 5,
//     saturday: 6
//   };

//   const targetDay = dayMap[String(day).toLowerCase()];
//   if (targetDay === undefined) return null;

//   const today = new Date();
//   const currentDay = today.getDay();

//   let diff = targetDay - currentDay;

//   if (isNextWeekday) {
//     // ALWAYS future (next week if needed)
//     if (diff <= 0) diff += 7;
//   }
//   // else → keep current week (do NOT shift forward)

//   const resultDate = new Date(today);
//   resultDate.setDate(today.getDate() + diff);

//   return {
//     shortDay: resultDate.toLocaleDateString("en-US", { weekday: "short" }),
//     date: resultDate.getDate()
//   };
// }

function getshortDayandNumberValue(day) {
  const data = window.activeDaysData || {};
  const isNextWeekday = !!data.nextweekday;

  const dayMap = {
    sunday: 0,
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6
  };

  const targetDay = dayMap[String(day).toLowerCase()];
  if (targetDay === undefined) return null;

  const today = new Date();
  const currentDay = today.getDay();

  let diff = targetDay - currentDay;

  if (isNextWeekday) {
    if (diff <= 0) diff += 7;
  }

  const resultDate = new Date(today);
  resultDate.setDate(today.getDate() + diff);

  return {
    shortDay: resultDate.toLocaleDateString("en-US", { weekday: "short" }),
    date: resultDate.getDate(),
    month: resultDate.toLocaleDateString("en-US", { month: "long" }),
    formatted: `${resultDate.getDate()} ${resultDate.toLocaleDateString("en-US", { month: "long" })}`
  };
}

/* =================================================
  MAIN FUNCTION TO RENDER CALENDARY DAYS
================================================= */

function renderDays(appcontextdata) {
  const days = getRenderableDays(window.menuData, appcontextdata?.menuType);
  const container = document.getElementById("weekContainer");
  const weekRangeEl = document.getElementById("weekRange");
  container.innerHTML = "";

  if (!days.length) {
    weekRangeEl.innerText = "No menu available";
    return;
  }

  const activeDay =
    window.activeDaysData.activeDay &&
    days.some(d => d.handle === window.activeDaysData.activeDay)
    ? window.activeDaysData.activeDay
    : days[0].handle;

  const startDate = days[0].handle;
  const endDate = days[days.length - 1];
  days.forEach(item => {
    if (!VALID_DAYS.includes(item.handle)) return false;
    const dayformatedValue = getshortDayandNumberValue(item.handle)
    container.innerHTML += `
      <button class="tiffin-calendar-day-btn swiper-slide ${item.handle === activeDay ? "active-day" : ""}"
         data-date='${dayformatedValue.month}'     data-day="${item.handle}" data-tiffin-type="${appcontextdata.menuType}">
        <div class="day-item">
          <strong>${dayformatedValue.shortDay}</strong>
          <span class="day-number">${dayformatedValue.date}</span>
        </div>
      </button>`;
  });
  weekRangeEl.innerText = getWeekRangeFromUI();

  initSwiper();
  updateNavigationButtons();
}

/* =================================================
 Initialize or load Tiffin data from localStorage
 ================================================= */

function initializeTiffinData() {
  const existingData = localStorage.getItem("selectedTiffins");

  if (existingData) {
    const parsed = JSON.parse(existingData);

    // MIGRATION FIX (old structure → new structure)
    if (!parsed.days) parsed.days = {};
    if (!parsed.currentDay) parsed.currentDay = null;
    if (!parsed.currentTiffinSize) parsed.currentTiffinSize = 1;

    localStorage.setItem("selectedTiffins", JSON.stringify(parsed));
    return parsed;
  }

  const initialData = {
    days: {},
    currentDay: null,
    currentTiffinSize: 1
  };

  localStorage.setItem("selectedTiffins", JSON.stringify(initialData));
  return initialData;
}

/* =================================================
SET CURRENT DAY DATA TO LOCALSTORAGE
 ================================================= */
function setCurrentDay(dayDate, dayName) {
  if (!selectedTiffins.days) selectedTiffins.days = {};

  selectedTiffins.currentDay = dayDate;

  // if new day create
  if (!selectedTiffins.days[dayDate]) {
    selectedTiffins.days[dayDate] = {
      dayName: dayName,
      currentTiffinSize: 1,
      tiffins: {}
    };
  }

  // restore last used tiffin for that day
  selectedTiffins.currentTiffinSize = selectedTiffins.days[dayDate].currentTiffinSize || 1;

  // ensure current tiffin exists
  if (!selectedTiffins.days[dayDate].tiffins[selectedTiffins.currentTiffinSize]) {
    selectedTiffins.days[dayDate].tiffins[selectedTiffins.currentTiffinSize] = {
      proteins: null,
      veggies: null,
      sides: null,
      probiotics: null
    };
  }

  updateTiffinData();
}

/* =================================================
   UPDATE TIFFIN DATA TO LOCALSTORAGE
================================================= */

function updateTiffinData() {
  localStorage.setItem('selectedTiffins', JSON.stringify(selectedTiffins));
}

async function fetchProductDetailsHTML(handle) {
  if (!handle) {
    return `<p>Product details are not available.</p>`;
  }

  if (productDetailsCache[handle]) {
    return productDetailsCache[handle];
  }

  try {
    const response = await fetch(`/products/${handle}?section_id=product-popup-details`);

    if (!response.ok) {
      throw new Error("Failed to fetch product details");
    }

    const html = await response.text();

    productDetailsCache[handle] = html;

    return html;
  } catch (error) {
    console.error(error);
    return `<p>Product details are not available.</p>`;
  }
}


const productDetailsCache = {};

/* =================================================
 open product poptup 
================================================= */
async function openProductPopup(productId, dayDate, category,type,extraprice,productHandle) {
  const prod = findProductDetails(productId, dayDate, category,type);
  if (!prod) return;

  const popup = document.querySelector(".desktop-product-popup-holder");
  popup.innerHTML = `
    <div class="popupdata-productt-info-wrapper">
      <div class="popupdata-product-title">
        <div class="popupdata-header-wrapper">
          <span class="popupdata-close-icon">
          <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-narrow-left"  >
             <path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M5 12l14 0" /><path d="M5 12l4 4" /><path d="M5 12l4 -4" />
          </svg>
          </span>
          <span class="tiffin-prod-title maintiffin-prod-title">
            ${prod.title}
             ${type != 'main_tiffin' ? `` : (extraprice > 0 ? `+ $${extraprice}` : '')}
          </span>
         <span class="product-price-threshold">
           ${type != 'main_tiffin' ? `$${prod.price}` : ''}
          </span>
        </div>
      </div>

      <div class='popup-product-image-content'>

      <div class="popupdata-product-image">
        <img src="${prod.image}" alt="${prod.title}">
      </div>
    <div class="popupdata-product-content">
         ${
            Array.isArray(prod.tags)
              ? prod.tags
                  .map((t,i)=>`<span class="tiffin-day-tags tiffin-prod-tags-${i+1}">${t.toLowerCase() === 'vg' ? 'vgn' : t}</span>`)
                  .join("")
              : ""
          }
          <div class="popupdata-product-content-inner">

          </div>
      </div>
      </div>

    </div>
  `;
  popupClassedToggle()

  // document.querySelector(".product-popup-info").classList.remove("hidden");
  const detailsHTML = await fetchProductDetailsHTML(productHandle);

  const content = popup.querySelector(".popupdata-product-content-inner");
  if (content) {
    content.innerHTML = detailsHTML;
  }
}


/* =================================================
 Go to next day - calendar and go to next day button click 
================================================= */
function goToNextDay() {
  const active = document.querySelector(".tiffin-calendar-day-btn.active-day");
  if (!active) return;
  const next = active.nextElementSibling;
  if (next && next.classList.contains("tiffin-calendar-day-btn")) {
    next.click(); 
  }
  scrollToTop()
}


/* =================================================
 Go to prv day - calendar prev button
================================================= */
function goToPrevDay() {
  const active = document.querySelector(".tiffin-calendar-day-btn.active-day");
  if (!active) return;
  const prev = active.previousElementSibling;
  if (prev && prev.classList.contains("tiffin-calendar-day-btn")) {
    prev.click(); 
  }
}



// ------------------------------
// The function to toggle class when popup is opened
// --------------------------------
function popupClassedToggle()
{ 
  const desktoppopupholder = document.querySelector('.desktop-product-popup-holder');
  const mobilepopupholder = document.querySelector('.mobile-product-popup-holder');
  const cartsummarycontainer = document.querySelector('.cart-summary-container ');
  const cartSummarypopoverInfo = document.querySelector('.cart-summary-popover-info')
  if(cartSummarypopoverInfo) cartSummarypopoverInfo.style.display='none'
    if (desktoppopupholder) {
      if(isMobile){ 
         document.body.classList.add('mobile-cart-summary')
           document.body.classList.add('popup-description')
           if(cartsummarycontainer) cartsummarycontainer.classList.add('cart-summary-swipe');
           if(desktoppopupholder) desktoppopupholder.style.display='block'
      }
    }
}

/* =================================================
   PRODUCT RENDER
================================================= */

function renderProductData(type, category) {
  const dayHandle = window.activeDaysData.activeDay;
  if(window.activeDaysData.no_day_available)
  { 
    if(main_section_wrapper) main_section_wrapper.style.display='none'
    if(next_week_menu_msg) next_week_menu_msg.style.display ='block'
  }
  if (!dayHandle) return;

  // const dayObj = getDayObjByHandle(dayHandle);
  const dayObj = window.menuData.find(d => d.handle === dayHandle) || null;
  if (!dayObj) return;
       updateTypeSelectorButtonClass(type)

  if (type === "tiffin") loadMainProduct(dayObj, category);
  if(type == 'ala') loadAlaProudcts(dayObj, category);
   if(type == 'pantry') loadPantryProducts(dayObj, category);
   if(type == 'lunch') loadlunchProducts(dayObj, category);
}



/* =================================================
   RETURN CURRENT DAY TIFFIN SIZE , TIFFIN 1 OR 2 ETC
================================================= */

function getCurrentTiffin() {
  const dayDate = selectedTiffins.currentDay;
  const tiffinId = selectedTiffins.currentTiffinSize;

  if (!selectedTiffins.days[dayDate]) return null;

  if (!selectedTiffins.days[dayDate].tiffins[tiffinId]) {
    selectedTiffins.days[dayDate].tiffins[tiffinId] = {
      proteins: null,
      veggies: null,
      sides: null,
      probiotics: null
    };
  }

  return selectedTiffins.days[dayDate].tiffins[tiffinId];
}





function restoreAlaSelectionsForDay(dayKey) {
  if (!dayKey) return;

  const dayData = selectedTiffins.days?.[dayKey];
  if (!dayData?.ala) return;

  Object.entries(dayData.ala).forEach(([category, items]) => {

    const titles = [];

    Object.entries(items).forEach(([variantId, item]) => {

      if (!item || item.quantity <= 0) return;

      titles.push(item.title);

      // find wrapper ONLY by variantId + category (because your day-date is undefined sometimes)
      const wrapper = document.querySelector(
        `.ala-cart-quanity-wrapper[data-prod-variant="${variantId}"][data-category-name="${category}"][data-day-name='${dayKey}']`
      );
      if (!wrapper) return;

      // Add active class when restored
      wrapper.classList.add("ala-selected-product");

      const addBtn = wrapper.querySelector(".ala-addto-cart");
      const inputAla = wrapper.querySelector('.tiffinday-input-ala')
      if(item.quantity > 0)
      { 
      if (addBtn) { 
      addBtn.textContent = item.quantity;
      addBtn.setAttribute("data-quantity",item.quantity)
      } 
      if(inputAla) inputAla.value = item.quantity;

      }
    });

    // update header (comma separated)
    const header = document.querySelector(
      `.ala-selected-items-title[data-selectedtitle-name="${category}"]`
    );

    if (header) {
      header.innerHTML = titles.join(", ");
    }
  });
}

function handleProductSelect(event, category) {
  const selectedProduct = event.target.closest(".maintiffin-products-select");
  if (!selectedProduct) return;

  const productTitle = selectedProduct.getAttribute("data-prod-title");
  const productPrice = selectedProduct.getAttribute("data-prod-price");
  const productImage = selectedProduct.getAttribute("data-prod-img");
  const variantId = selectedProduct.getAttribute("data-prod-variant");
  const dayName = selectedProduct.getAttribute("data-day-name")?.toLowerCase();
  const wrapper = selectedProduct.closest(".tiffin-prods-and-title-wrapper");
  const extraprice = selectedProduct.getAttribute("data-extra-price");

  const currentlabel = document.querySelector(`label[for="${selectedProduct.id}"]`);
  const selected_tiffin_main_wrapper = selectedProduct.closest(".tiffin-prods-and-title-wrapper");
  const selecteItemmsg = selected_tiffin_main_wrapper.querySelector(".select-item-message");
  const tiffindayAccordian = selected_tiffin_main_wrapper.querySelector(".tiffinday-cat-accordian");
  const wrapperTiffinSize = selected_tiffin_main_wrapper?.getAttribute("data-tiffin-size");

  if (!selectedTiffins.days) {
    selectedTiffins.days = {};
  }

  if (!selectedTiffins.days[dayName]) {
    selectedTiffins.days[dayName] = {
      dayName,
      currentTiffinSize: 1,
      tiffins: {
        "1": {
          proteins: null,
          veggies: null,
          sides: null,
          probiotics: null
        }
      }
    };
  }

  const dayObj = selectedTiffins.days[dayName];

  selectedTiffins.currentDay = dayName;

  const tiffinId = String(
    wrapperTiffinSize ||
    dayObj.currentTiffinSize ||
    selectedTiffins.currentTiffinSize ||
    1
  );

  selectedTiffins.currentTiffinSize = Number(tiffinId);
  dayObj.currentTiffinSize = Number(tiffinId);

  if (!dayObj.tiffins[tiffinId]) {
    dayObj.tiffins[tiffinId] = {
      proteins: null,
      veggies: null,
      sides: null,
      probiotics: null
    };
  }

  dayObj.tiffins[tiffinId][category] = {
    title: productTitle,
    price: productPrice,
    img: productImage,
    variantId,
    extraprice
  };

  updateHeader(wrapper, category, "tiffin");
  selecteItemmsg.style.display = "none";
  tiffindayAccordian.style.display = "block";

  const selectmsgwrapper = selecteItemmsg.closest(".selected-item-accordian");

  const sameCategoryInputs = document.querySelectorAll(
    `.maintiffin-products-select[data-category-name="${category}"]`
  );

  if (selectmsgwrapper) selectmsgwrapper.classList.add("select-msg-hidden");

  sameCategoryInputs.forEach((el) => {
    const sameWrapper = el.closest(".tiffin-prods-and-title-wrapper");
    const sameWrapperTiffinId = sameWrapper?.getAttribute("data-tiffin-size");

    if (String(sameWrapperTiffinId) === tiffinId) {
      const lbl = document.querySelector(`label[for="${el.id}"]`);
      if (lbl) lbl.classList.remove("active");
    }
  });

  if (currentlabel) currentlabel.classList.add("active");

  const current_category_wrapper = selectedProduct.closest(".maintiffin-category-prdlists");
  const currentIndex = parseInt(current_category_wrapper.dataset.categoryIndex, 10);
  const upcomingIndex = currentIndex + 1;

  const upcomingmenuwrapperMain = document.querySelector(
    `.maintiffin-category-prdlists[data-main-tiffinday='${dayName}'][data-category-index='${upcomingIndex}']`
  );

  // if (upcomingIndex == 5) {
  //   const addon_collapsible = document.querySelector(
  //     `.addon-select-title[data-day-name='${dayName}']`
  //   );
  //   if (addon_collapsible) addon_collapsible.click();
  // }

  setTimeout(() => {
    if (upcomingmenuwrapperMain) upcomingmenuwrapperMain.classList.remove("hidden");
    if (current_category_wrapper) current_category_wrapper.classList.add("hidden");
  }, 500);

  updateTiffinData();
  renderCartSummary();
}



function resetMainTiffinUI(dayKey) {
  if (!dayKey) return;

  const categories = ["proteins", "veggies", "sides", "probiotics"];

  categories.forEach(cat => {
    // RESET HEADER TITLE
    const header = document.querySelector(
      `.maintiffin-selected-items-title[data-selectedtitle-name="${cat}"][data-day-name="${dayKey}"]`
    );

    const wrapper = header?.closest(".main-tiff-type-prod-and-title-wrapper");
    const selectMsg = wrapper?.querySelector(".select-item-message");
    const accordianIcon = wrapper?.querySelector(".tiffinday-cat-accordian");
    const categoryprdlist = wrapper?.querySelector('.maintiffin-category-prdlists')

    if(categoryprdlist) categoryprdlist.classList.remove('hidden')
    if (header) header.innerHTML = "";
    // SHOW SELECT MESSAGE
    if (selectMsg) selectMsg.style.display = "block";

    // HIDE ACCORDION ICON
    if (accordianIcon) accordianIcon.style.display = "none";

    // RESET INPUTS + LABELS
    document.querySelectorAll(
      `.maintiffin-products-select[data-category-name="${cat}"][data-day-date="${dayKey}"]`
    ).forEach(input => {
      input.checked = false;
      const lbl = document.querySelector(`label[for="${input.id}"]`);
      if (lbl) lbl.classList.remove("active");
    });
  });

  // ALSO HIDE ADD NEXT TIFFIN BTN
  document.querySelectorAll(".tiffin-add-anothertiffin-btn").forEach(btn => {
    btn.style.display = "none";
  });
}


function addAnotherTiffin() {
  const dayKey = selectedTiffins.currentDay;
  if (!dayKey) return;

  const dayObj = selectedTiffins.days[dayKey];
  if (!dayObj) return;

  const tiffins = dayObj.tiffins || {};

  // ✅ find max existing tiffin
  const existingKeys = Object.keys(tiffins).map(Number);
  const maxTiffin = existingKeys.length ? Math.max(...existingKeys) : 0;

  const nextTiffinId = maxTiffin + 1;

  // ✅ set new current
  selectedTiffins.currentTiffinSize = nextTiffinId;
  dayObj.currentTiffinSize = nextTiffinId;

  // ✅ create new tiffin
  dayObj.tiffins[nextTiffinId] = {
    proteins: null,
    veggies: null,
    sides: null,
    probiotics: null
  };

  resetMainTiffinUI(dayKey);
  updateTiffinSizeAttribute(nextTiffinId);

  document.querySelectorAll(".tiffin-add-anothertiffin-btn")
    .forEach(btn => btn.style.display = "none");

  updateTiffinData();
  initializeActiveTiffinUI();
  scrollToTop()
}


/* =================================================
 update header of each category ala,lunch,pantry,tiffin - all have same header style
================================================= */
function updateHeader(wrapper, category, type) {
  if (!wrapper) return;

  const headerTitle = wrapper.querySelector(
    `.tiffinday-selected-items-title[data-selectedtitle-name="${category}"]`
  );

  if (!headerTitle) return;

  const dayKey = selectedTiffins.currentDay;

  // ===== TIFFIN (single selection per category) =====
  if (type === "tiffin") {
    const tiffinId = selectedTiffins.currentTiffinSize;
    const product = selectedTiffins.days?.[dayKey]?.tiffins?.[tiffinId]?.[category];
    headerTitle.innerHTML = product ? product.title : "";
  }

  // ===== ALA / LUNCH / PANTRY (multiple items per category) =====
  if (type === "ala" || type === "lunch" || type === "pantry") {
    const addons = selectedTiffins.days?.[dayKey]?.ala?.[category];
    if (!addons) {
      headerTitle.innerHTML = "";
      return;
    }

    // Convert object to array
    const titles = Object.values(addons)
      .filter(item => item.quantity > 0)
      .map(item => item.title);

    headerTitle.innerHTML = titles.length ? titles.join(", ") : "";
  }
}


function toggleNextDayButton(dayObj) {
  if (!dayObj?.handle) return;
  const btns = document.querySelectorAll(".tiffin-goto-nextday-btn");
  if (!btns.length) return;
  console.log('tiffin day checking togle ',dayObj.handle)
  const isFriday = dayObj.handle.toLowerCase() === "friday";

document.querySelectorAll(".tiffin-goto-nextday-btn").forEach((btn) => {
  btn.style.display = isFriday ? "none" : "flex";
});
}


function toggleAddNextTiffinBtn() {
  const dayKey = selectedTiffins.currentDay;
  if (!dayKey) return;

  const tiffinId = selectedTiffins.currentTiffinSize;
  const tiffin = selectedTiffins.days?.[dayKey]?.tiffins?.[tiffinId] || {};

  const requiredCats = ["proteins", "veggies", "sides", "probiotics"];

  const isComplete = requiredCats.every(cat => tiffin?.[cat]);

 document.querySelectorAll(".tiffin-add-anothertiffin-btn").forEach(btn => {
    btn.style.display = isComplete ? "flex" : "none";
  });
}


function updateTiffinSizeAttribute(size) {
  const wrappers = document.querySelectorAll(".main-tiff-type-prod-and-title-wrapper");
  wrappers.forEach(w => {
    w.setAttribute("data-tiffin-size", size);
  });
}



function renderCartSummary(activeTab = "dinner") {
  if(activeTab == 'ala') activeTab = 'dinner'
  let warnings = [];
   const data = selectedTiffins?.days || {};
    warnings = getDayWarnings(selectedTiffins.days);
    // if(checkout_button_cartpage) checkout_button_cartpage.disabled = warnings.length > 0;
    // console.log('checkout button cartpage',checkout_button_cartpage)
    if(warnings.length && checkoutbtncartpage)
  { 
    checkoutbtncartpage.setAttribute('disabled',true);
    checkoutbtncartpage.textContent ='Complete Required Items '
  } else if ( warnings.length <= 0)
  { 
       if(checkoutbtncartpage) checkoutbtncartpage.removeAttribute('disabled');

  }

  const summary = document.querySelector(".cart-summary-product-info");
  if (!summary) return;

  toggleAddNextTiffinBtn();

  let grandBaseTotal = 0;
  let grandExtraTotal = 0;
  let grandlunchTotal = 0;
  let grandpantryTotal = 0;
  let anyMissingGlobal = false;

  let hasDinnerGlobal = false;
  let hasPantryGlobal = false;
  let hasLunchGlobal = false;


  Object.values(data).forEach(day => {
    if (
      Object.values(day.tiffins || {}).some(t => Object.values(t || {}).some(i => i)) ||
      Object.values(day.ala || {}).some(cat => Object.keys(cat || {}).length)
    ) {
      hasDinnerGlobal = true;
    }

    if (day.pantry && Object.keys(day.pantry).length) {
      hasPantryGlobal = true;
    }

    if (day.lunch && Object.keys(day.lunch).length) {
      hasLunchGlobal = true;
    }
  });

  // ===========================
  // FIX ACTIVE TAB
  // ===========================
  if (!activeTab) activeTab = "dinner";

  if (activeTab === "dinner" && !hasDinnerGlobal) {
    if (hasLunchGlobal) activeTab = "lunch";
    else if (hasPantryGlobal) activeTab = "pantry";
  }

  if (activeTab === "lunch" && !hasLunchGlobal) {
    if (hasDinnerGlobal) activeTab = "dinner";
    else if (hasPantryGlobal) activeTab = "pantry";
  }

  if (activeTab === "pantry" && !hasPantryGlobal) {
    if (hasDinnerGlobal) activeTab = "dinner";
    else if (hasLunchGlobal) activeTab = "lunch";
  }

  // ===========================
  // INIT UI
  // ===========================
  summary.innerHTML = `
    <div class="cart-summary-tabs">
      ${hasDinnerGlobal ? `<button class="cartsumary-tab tab-btn ${activeTab === "dinner" ? "active" : ""}" data-tab="dinner">Dinner</button>` : ""}
      ${hasLunchGlobal ? `<button class="cartsumary-tab tab-btn ${activeTab === "lunch" ? "active" : ""}" data-tab="lunch">Lunch</button>` : ""}
      ${hasPantryGlobal ? `<button class="cartsumary-tab tab-btn ${activeTab === "pantry" ? "active" : ""}" data-tab="pantry">Pantry</button>` : ""}
    </div>
    <div class="cart-summary-content"></div>
  `;

  const content = summary.querySelector(".cart-summary-content");

  // ===========================
  // LOOP DAYS
  // ===========================
  Object.keys(data)
  .sort((a, b) => VALID_DAYS.indexOf(a.toLowerCase()) - VALID_DAYS.indexOf(b.toLowerCase()))
  .forEach(dayKey => {
    const dayObj = data[dayKey];
    const formatedCapday = getFormattedDateForDay(dayKey);
    warnings = getDayWarnings(selectedTiffins.days);


    

    let dayBaseTotal = 0;
    let lunchTotal = 0;
    let pantryTotal = 0;
    let dayExtraTotal = 0;
    let dinnerHtml = "";
    let pantryHtml = "";
    let lunchHtml = "";
    let dayHasError = false;

    let hasDinnerContent = false;
    let hasPantryContent = false;
    let hasLunchContent = false;

    // ===========================
    // TIFFINS
    // ===========================
    Object.keys(dayObj.tiffins || {}).forEach(tt => {
      const tiffin = dayObj.tiffins[tt];
      const categories = ["proteins", "veggies", "sides", "probiotics"];
      if (!categories.some(cat => tiffin?.[cat])) return;

      hasDinnerContent = true;
      let tiffinSubtotal = 0;
      let totalExtraPrice = 0;
      let missingCats = [];

      categories.forEach(cat => {
        const item = tiffin?.[cat];
        if (!item) {
          missingCats.push(cat);
          return;
        }

        const price = parseFloat(item.price || 0);
        const extra = parseFloat(item.extraprice || 0);
        tiffinSubtotal += price;
        totalExtraPrice += extra;
      });

      const filledCategories = categories.length - missingCats.length;
      const basePrice = tiffinSubtotal - totalExtraPrice;

      dayBaseTotal += basePrice;
      dayExtraTotal += totalExtraPrice;

      let displayPrice = "";
      if (filledCategories === categories.length) {
        displayPrice = ` - $${basePrice.toFixed(2)}${
     totalExtraPrice > 0 ? ` + $${totalExtraPrice.toFixed(2)}` : ""
        }`;
      }

      let tiffinHtml = `
        <div class="main-tiffin-section dinner-item-section">
          <div class="tiffin-toggle section-header-cartsummary">
            <span>Tiffin ${tt}${displayPrice}</span>
          </div>
      `;

      categories.forEach(cat => {
        const item = tiffin?.[cat];
        if (!item) return;

        tiffinHtml += `
          <div class="added-category-wrapper added-maintiffin-wrapper">
            <div class='added-category-titles-content'>
              <div class='added-cat-imgtitle-mainwrap'> 
                <div class="category-img category-img-main">
                  <span class='added-category-title'>${cat}</span>
                  <div class='added-category-img-wrapper'>
                    <img src="${item.img || FALLBACK_IMG}" width="50" />
                  </div>
                </div>
              </div>
              <div class='added-cat-imgtitle-wrap'> 
                <span>${item.title}</span>
                ${item.extraprice > 0 ? `+ $${parseFloat(item.extraprice).toFixed(2)}` : ""}
              </div>
            </div>
              
            <button class="remove-btn main-remove-btn"
              data-type="main"
              data-day="${dayKey}"
              data-tt="${tt}"
              data-variant="${item.variantId}"
              data-cartline="${item.fromCartLine}"
              data-key="${item.cartKey}"
              data-cat="${cat}">
            </button>
          </div>
        `;
      });

      if (filledCategories > 0 && missingCats.length > 0) {
        dayHasError = true;
        anyMissingGlobal = true;

        tiffinHtml += `<p class="missing-warning" data-day="${dayKey}" data-tt="${tt}">Please add ${missingCats.join(", ")}</p>`;
      }

      tiffinHtml += `</div>`;
      dinnerHtml += tiffinHtml;
    });

    // ===========================
    // ALA CARTE
    // ===========================
    const ala = dayObj.ala || {};
    const alaCategories = Object.keys(ala);

    if (alaCategories.length) {
      hasDinnerContent = true;

      let alaHtml = `
        <div class="addons-section dinner-item-section">
          <div class="section-header-cartsummary">
            <span>Ala Carte</span>
          </div>
      `;

      alaCategories.forEach(cat => {
        const items = ala[cat];
        const variants = Object.keys(items || {});
        if (!variants.length) return;

        alaHtml += `
          <div class="category-group-title ala-category-group">
            <div class="category-title"><strong>${cat}</strong></div>
        `;

        variants.forEach(variant => {
          const item = items[variant];
          const total = item.quantity * (item.price || 0);

          dayBaseTotal += total;

          alaHtml += `
            <div class="added-category-wrapper added-alatiffin-wrapper">
              <div class='added-cat-imgtitle-wrap ala-imgtitle-wrap'> 
                <div class='added-category-img-wrapper'>
                  <img src="${item.img || FALLBACK_IMG}" width="50" />
                </div>

                <div class="added-category-wrapper-titles alawrapper-title-price">
                  <span class="added-title">${item.title}</span>
                  <span class="added-price">( $${item.price}) x ${item.quantity}</span>
                </div>
              </div>
              <button class="remove-btn ala-remove-btn"
                data-type="ala"
                data-day="${dayKey}"
                data-variant="${variant}"
                data-key="${item.cartKey}"
                data-cartline="${item.fromCartLine}"
                data-cat="${cat}">
              </button>
            </div>
          `;
        });

        alaHtml += `</div>`;
      });

      alaHtml += `</div>`;
      dinnerHtml += alaHtml;
    }

// ===========================
// PANTRY
// ===========================
const pantry = dayObj.pantry || {};
const pantryCategories = Object.keys(pantry);

let pantryInnerHtml = "";

pantryCategories.forEach(cat => {
  const items = pantry[cat] || {};

  const validVariants = Object.keys(items).filter(variant => {
    const item = items[variant];
    return item && Number(item.quantity || 0) > 0;
  });

  if (!validVariants.length) return;

  pantryInnerHtml += `
    <div class="category-group-title pantry-category-group">
      <div class="category-title"><strong>${cat}</strong></div>
  `;

  validVariants.forEach(variant => {
    const item = items[variant];
    const total = Number(item.quantity || 0) * Number(item.price || 0);

    pantryTotal += total;

    pantryInnerHtml += `
      <div class="added-category-wrapper pantry-item">
        <div class='added-cat-imgtitle-wrap pantry-cat-imgtitle-wrap'> 
          <div class='added-category-img-wrapper'>
            <img src="${item.img || FALLBACK_IMG}" width="50" />
          </div>

          <div class="added-category-wrapper-titles pantry-title-price">
            <span class="added-title">${item.title}</span>
            <span class="added-price">( $${item.price}) x ${item.quantity}</span>
          </div>
        </div>
        
        <button class="remove-btn remove-pantry-btn"
          data-day="${dayKey}"
          data-cat="${cat}"
          data-key="${item.cartKey}"
          data-cartline="${item.fromCartLine}"
          data-type="pantry"
          data-variant="${variant}">
        </button>
      </div>
    `;
  });

  pantryInnerHtml += `</div>`;
});

if (pantryInnerHtml.trim()) {
  hasPantryContent = true;

  pantryHtml += `
    <div class="addons-section pantry-item-section">
      <div class="collapse-body-pantry">
        ${pantryInnerHtml}
      </div>
    </div>
  `;
}

    // ===========================
    // LUNCH
    // ===========================
    const lunch = dayObj.lunch || {};
    const lunchCategories = Object.keys(lunch);

    if (lunchCategories.length) {
      hasLunchContent = true;

      lunchHtml += `
        <div class="addons-section lunch-item-section">
          <div class="collapse-body-lunch">
      `;

      lunchCategories.forEach(cat => {
        const items = lunch[cat];
        const variants = Object.keys(items || {});
        if (!variants.length) return;

        lunchHtml += `
          <div class="category-group-title lunch-category-group">
            <div class="category-title"><strong>${cat}</strong></div>
        `;

        variants.forEach(variant => {
          const item = items[variant];
          const total = item.quantity * (item.price || 0);

          // dayBaseTotal += total;
          lunchTotal += total;

          lunchHtml += `
            <div class="added-category-wrapper lunch-item">
              <div class='added-cat-imgtitle-wrap lunch-cat-imgtitle-wrap'> 
                <div class='added-category-img-wrapper'>
                  <img src="${item.img || FALLBACK_IMG}" width="50" />
                </div>
                <div class="added-category-wrapper-titles lunch-title-price">
                  <span class="added-title">${item.title}</span>
                  <span class="added-price">( $${item.price}) x ${item.quantity}</span>
                </div>
              </div>
              
              <button class="remove-btn remove-lunch-btn"
                data-day="${dayKey}"
                data-cat="${cat}"
                data-key="${item.cartKey}"
                data-cartline="${item.fromCartLine}"
                data-type="lunch"
                data-variant="${variant}">
              </button>
            </div>
          `;
        });

        lunchHtml += `</div>`;
      });

      lunchHtml += `</div></div>`;
    }

    // ===========================
    // DAY DISPLAY
    // ===========================
    let dayDisplay = "";



const baseValue = Number(dayBaseTotal) || 0;
const extraValue = Number(dayExtraTotal) || 0;
const lunchValue = Number(lunchTotal) || 0;
const pantryValue = Number(pantryTotal) || 0;


let dinnerDayDisplay = "";
let lunchDayDisplay = "";
let pantryDayDisplay = "";

if (!dayHasError) {
  if (baseValue > 0 || extraValue > 0) {
    dinnerDayDisplay = `<span>$${baseValue.toFixed(2)}${
      extraValue > 0 ? ` + $${extraValue.toFixed(2)}` : ""
    }</span>`;
  }
}


  if (lunchValue > 0) {
    lunchDayDisplay = `<span>$${lunchValue.toFixed(2)}</span>`;
  }

  if (pantryValue > 0) {
    pantryDayDisplay = `<span>$${pantryValue.toFixed(2)}</span>`;
  }

    const buildDayBlock = (innerHtml, sectionClass, displayHtml = "") => `
      <div class="day-cart-summary ${sectionClass}">
        <div class="collapse-toggle day-toggle">
          ${formatedCapday}
          <div class='total-price-icon-wrapper'>
            ${displayHtml ? `<span class='day-total-header'>${displayHtml}</span>` : ""}
            <div class="collpsible-icon">
              <span class="collapsible-down hidden">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.66675 6.66699L8.00008 10.0003L11.3334 6.66699" stroke="#127E51" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </span>
              <span class="collapsible-up">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.66675 6.66699L8.00008 10.0003L11.3334 6.66699" stroke="#127E51" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </span>
            </div>
          </div>
        </div>
        <div class="collapse-body">
          ${innerHtml}
        </div>
      </div>
    `;

if (hasDinnerContent) {
  content.innerHTML += buildDayBlock(dinnerHtml, "dinner-section", dinnerDayDisplay);
}

if (hasLunchContent) {
  content.innerHTML += buildDayBlock(lunchHtml, "lunch-section", lunchDayDisplay);
}

if (hasPantryContent) {
  content.innerHTML += buildDayBlock(pantryHtml, "pantry-section", pantryDayDisplay);
}

    grandBaseTotal += dayBaseTotal;
    grandExtraTotal += dayExtraTotal;
    grandlunchTotal += lunchTotal;
    grandpantryTotal += pantryTotal;
  });

  // ===========================
  // TAB SWITCH
  // ===========================
  function toggleSections(tab) {
    document.querySelectorAll(".dinner-section").forEach(el => {
      el.style.display = tab === "dinner" ? "block" : "none";
    });

    document.querySelectorAll(".lunch-section").forEach(el => {
      el.style.display = tab === "lunch" ? "block" : "none";
    });

    document.querySelectorAll(".pantry-section").forEach(el => {
      el.style.display = tab === "pantry" ? "block" : "none";
    });

  }

  document.querySelectorAll(".tab-btn").forEach(btn => {
    btn.addEventListener("click", () => {
      document.querySelectorAll(".tab-btn").forEach(b => b.classList.remove("active"));
      btn.classList.add("active");
      toggleSections(btn.dataset.tab);
    });
  });

  // ===========================
  // DEFAULT VIEW
  // ===========================
  toggleSections(activeTab);

  // ===========================
  // BOTTOM LOGIC
  // ===========================
  let hasAnyProduct = false;

  Object.values(selectedTiffins.days || {}).forEach(day => {
    // TIFFINS
    if (day.tiffins && Object.keys(day.tiffins).length) {
      Object.values(day.tiffins).forEach(tiffin => {
        if (Object.values(tiffin || {}).some(item => item)) {
          hasAnyProduct = true;
        }
      });
    }

    // ALA
    if (day.ala && Object.keys(day.ala).length) {
      Object.values(day.ala).forEach(cat => {
        if (Object.keys(cat || {}).length) {
          hasAnyProduct = true;
        }
      });
    }

    // PANTRY
    if (day.pantry && Object.keys(day.pantry).length) {
      Object.values(day.pantry).forEach(category => {
        if (Object.keys(category || {}).length) {
          hasAnyProduct = true;
        }
      });
    }

    // LUNCH
    if (day.lunch && Object.keys(day.lunch).length) {
      Object.values(day.lunch).forEach(category => {
        if (Object.keys(category || {}).length) {
          hasAnyProduct = true;
        }
      });
    }
  });

  const bottomInfo = document.querySelector(".cart-summary-bottom-info");
  const noproudctInfo = document.querySelector(".no-product-msg-info");
  const cartSummaryContainer = document.querySelector(".cart-summary-container");

  if (bottomInfo) bottomInfo.classList.toggle("no-products", !hasAnyProduct);
  if (cartSummaryContainer) cartSummaryContainer.classList.toggle("no-products", !hasAnyProduct);
  if (noproudctInfo) noproudctInfo.classList.toggle("hidden", hasAnyProduct);

  updateGrandTotal(grandBaseTotal, grandExtraTotal, grandlunchTotal,grandpantryTotal,anyMissingGlobal, warnings);
}

function getCartWarningSummaryMessage(warnings) {
  if (!warnings || !warnings.length) return "";

  return warnings.map(day => {
    const dayName = day.dayKey
      ? day.dayKey.charAt(0).toUpperCase() + day.dayKey.slice(1)
      : day.dayLabel.split("|")[1]?.trim() || day.dayLabel;

    const tiffins = [];
    const otherIssues = [];

    day.dinner?.forEach(item => {
      if (item.type === "tiffin") {
        tiffins.push(item.title);
      }

      if (item.type === "ala") {
        otherIssues.push(`Minimum $29 for Ala Carte ${dayName}`);
      }
    });

    if (day.lunch) {
      otherIssues.push(`Minimum $20 for Lunch ${dayName}`);
    }

    const messages = [];

    if (tiffins.length) {
      messages.push(`Complete ${tiffins.join(", ")} ${dayName}`);
    }

    messages.push(...otherIssues);

    return messages.join("; ");
  }).join("; ");
}


// function getDayWarnings(daysObj) {
//   const requiredCats = ["proteins", "veggies", "sides", "probiotics"];
//   const warnings = [];

//   Object.entries(daysObj || {}).forEach(([dayKey, dayObj]) => {
//     const formatDay = dayKey.charAt(0).toUpperCase() + dayKey.slice(1);
//     const dayWarning = {
//       dayKey,
//       dayLabel: getFormattedDateForDay(dayKey) || formatDay,
//       dinner: [],
//       lunch: null,
//       issueCount: 0
//     };

//     // Tiffin bundle missing category check
//     Object.entries(dayObj.tiffins || {}).forEach(([ttNo, tiffin]) => {
//       const hasAnyItem = requiredCats.some(cat => tiffin?.[cat]);

//       if (!hasAnyItem) return;

//       const missingCats = requiredCats.filter(cat => !tiffin?.[cat]);

//       if (missingCats.length) {
//         dayWarning.dinner.push({
//           type: "tiffin",
//           title: `Tiffin ${ttNo}`,
//           message: `${missingCats.join(", ")} missing`,
//           missingCats
//         });

//         dayWarning.issueCount += missingCats.length;
//       }
//     });

//     // Check if any complete tiffin exists
//     const hasCompleteTiffin = Object.values(dayObj.tiffins || {}).some(tiffin =>
//       requiredCats.every(cat => tiffin?.[cat])
//     );

//     // Ala + Pantry minimum check
//     let dinnerAlaTotal = 0;
//     let hasAlaOrPantry = false;

//     Object.values(dayObj.ala || {}).forEach(cat => {
//       Object.values(cat || {}).forEach(item => {
//         hasAlaOrPantry = true;
//         dinnerAlaTotal += (item.quantity || 0) * parseFloat(item.price || 0);
//       });
//     });

//     Object.values(dayObj.pantry || {}).forEach(cat => {
//       Object.values(cat || {}).forEach(item => {
//         hasAlaOrPantry = true;
//         dinnerAlaTotal += (item.quantity || 0) * parseFloat(item.price || 0);
//       });
//     });

//     if (!hasCompleteTiffin && hasAlaOrPantry && dinnerAlaTotal < 29) {
//       dayWarning.dinner.push({
//         type: "ala",
//         title: "Ala Carte Dinner",
//         message: `Minimum $29 required. You have $${dinnerAlaTotal.toFixed(2)}`
//       });

//       dayWarning.issueCount += 1;
//     }

//     // Lunch minimum check
//     let lunchTotal = 0;
//     let hasLunch = false;

//     Object.values(dayObj.lunch || {}).forEach(cat => {
//       Object.values(cat || {}).forEach(item => {
//         hasLunch = true;
//         lunchTotal += (item.quantity || 0) * parseFloat(item.price || 0);
//       });
//     });

//     if (hasLunch && lunchTotal < 20) {
//       dayWarning.lunch = {
//         title: "Lunch",
//         message: `Minimum $20 required. You have $${lunchTotal.toFixed(2)}`
//       };

//       dayWarning.issueCount += 1;
//     }

//     if (dayWarning.issueCount > 0) {
//       warnings.push(dayWarning);
//     }
//   });

//   return warnings;
// }


function getDayWarnings(daysObj) {
  const requiredCats = ["proteins", "veggies", "sides", "probiotics"];
    const DAY_ORDER = ["monday", "tuesday", "wednesday", "thursday", "friday"];

  const warnings = [];

  Object.entries(daysObj || {})
  .sort(([dayA], [dayB]) => {
      const indexA = DAY_ORDER.indexOf(dayA.toLowerCase());
      const indexB = DAY_ORDER.indexOf(dayB.toLowerCase());

      return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
    })
  .forEach(([dayKey, dayObj]) => {
    const formatDay = dayKey.charAt(0).toUpperCase() + dayKey.slice(1);

    const dayWarning = {
      dayKey,
      dayLabel: getFormattedDateForDay(dayKey) || formatDay,
      dinner: [],
      lunch: null,
      issueCount: 0
    };

    // Tiffin bundle missing category check
    Object.entries(dayObj.tiffins || {}).forEach(([ttNo, tiffin]) => {
      const hasAnyItem = requiredCats.some(cat => tiffin?.[cat]);

      if (!hasAnyItem) return;

      const missingCats = requiredCats.filter(cat => !tiffin?.[cat]);

      if (missingCats.length) {
        dayWarning.dinner.push({
          type: "tiffin",
          title: `Tiffin ${ttNo}`,
          message: `${missingCats.join(", ")} missing`,
          missingCats
        });

        dayWarning.issueCount += missingCats.length;
      }
    });

    // Check if any complete tiffin exists
    const hasCompleteTiffin = Object.values(dayObj.tiffins || {}).some(tiffin =>
      requiredCats.every(cat => tiffin?.[cat])
    );

    // Ala total
    let dinnerAlaTotal = 0;
    let hasAla = false;

    Object.values(dayObj.ala || {}).forEach(cat => {
      Object.values(cat || {}).forEach(item => {
        hasAla = true;
        dinnerAlaTotal += (item.quantity || 0) * parseFloat(item.price || 0);
      });
    });

    // Pantry total
    let pantryTotal = 0;
    let hasPantry = false;

    Object.values(dayObj.pantry || {}).forEach(cat => {
      Object.values(cat || {}).forEach(item => {
        hasPantry = true;
        pantryTotal += (item.quantity || 0) * parseFloat(item.price || 0);
      });
    });

    // Lunch total
    let lunchTotal = 0;
    let hasLunch = false;

    Object.values(dayObj.lunch || {}).forEach(cat => {
      Object.values(cat || {}).forEach(item => {
        hasLunch = true;
        lunchTotal += (item.quantity || 0) * parseFloat(item.price || 0);
      });
    });

    // Ala dinner minimum check
    if (!hasCompleteTiffin && hasAla && dinnerAlaTotal < 29) {
      dayWarning.dinner.push({
        type: "ala",
        title: "Ala Carte Dinner",
        message: `Minimum $29 required. You have $${dinnerAlaTotal.toFixed(2)}`
      });

      dayWarning.issueCount += 1;
    }

    // Pantry-only minimum check
    if (
      !hasCompleteTiffin &&
      hasPantry &&
      !hasAla &&
      !hasLunch &&
      pantryTotal < 29
    ) {
      dayWarning.dinner.push({
        type: "pantry",
        title: "Pantry",
        message: `Minimum $29 required. You have $${pantryTotal.toFixed(2)}`
      });

      dayWarning.issueCount += 1;
    }

    // Lunch minimum check
    if (hasLunch && lunchTotal < 20) {
      dayWarning.lunch = {
        title: "Lunch",
        message: `Minimum $20 required. You have $${lunchTotal.toFixed(2)}`
      };

      dayWarning.issueCount += 1;
    }

    if (dayWarning.issueCount > 0) {
      warnings.push(dayWarning);
    }
  });

  return warnings;
}

document.addEventListener("click", function (e) {
  const toggle = e.target.closest(".collapse-toggle");
  if (!toggle) return;

  const collapsibledown = toggle.querySelector('.collapsible-down');
  const collapsibleup = toggle.querySelector('.collapsible-up');

  const section = toggle.closest(".addons-section, .day-cart-summary");
  if (!section) return;

  const body = section.querySelector(":scope > .collapse-body");
  if (!body) return;

  // toggle body
  body.classList.toggle("hidden");

  const isHidden = body.classList.contains("hidden");

  // toggle icons
 if (collapsibledown && collapsibleup) {
  collapsibledown.classList.toggle("hidden", !isHidden);
  collapsibleup.classList.toggle("hidden", isHidden);
}
});

/* =================================================
 remove tiffin ui on delete
================================================= */
function removeTiffinUIState({ day, tt, cat, variantId }) {
  const wrapper = document.querySelector(`.main-tiff-type-prod-and-title-wrapper[data-tiffin-size='${tt}'][data-day-name='${day}'][data-day-category='${cat}']`);
  if(wrapper){ 
  const headerTitle = wrapper.querySelector('.maintiffin-selected-items-title')
  const accordianicon = wrapper?.querySelector('.tiffinday-cat-accordian')
  const selectMsg = wrapper?.querySelector(".select-item-message");
  const prdlistwraper = wrapper?.querySelector('.category-prdlist-wrapper')
  if (selectMsg) selectMsg.style.display = "block";
  if(accordianicon) accordianicon.style.display='none'
  if(wrapper) wrapper.classList.remove('accord-active');
  if(prdlistwraper) prdlistwraper.classList.remove('hidden')

  if (headerTitle) {
    headerTitle.innerHTML = "";
  }
  if (variantId) {
    const input = document.querySelector(
      `.maintiffin-products-select[data-prod-variant="${variantId}"][data-category-name="${cat}"]`
    );

    if (input) {
      input.checked = false;

      const label = document.querySelector(`label[for="${input.id}"]`);
      if (label) label.classList.remove("active");
    }
  }
}
}



function resetDeleteAlaUI( day, cat, variantId ) {
  const wrapper = document.querySelector(
    `.ala-cart-quanity-wrapper[data-day-name="${day}"][data-category-name="${cat}"][data-prod-variant="${variantId}"]`
  );
  if (!wrapper) return;
  const allproductwrapper = wrapper.closest('.tiffin-prods-and-title-wrapper')
  const qtyWrapper = wrapper.querySelector(".tiffinday-quantity-selectors");
  const addBtn = wrapper.querySelector(".ala-addto-cart");
  const input = wrapper.querySelector(".tiffinday-input-ala");

  // RESET UI
  if (qtyWrapper) qtyWrapper.style.display = "none";   
  if (addBtn) 
    { 
      addBtn.style.display = "flex"; 
      addBtn.textContent = '+'
     }          

  if (input) input.value = 1;                          

  const minusIcon = wrapper.querySelector(".minus-quanity-minus-ala");
  const removeIcon = wrapper.querySelector(".minus-quantity-remove");

  if (minusIcon) minusIcon.classList.add("hidden");
  if (removeIcon) removeIcon.classList.remove("hidden");
   updateHeader(allproductwrapper,cat, "ala");

}







/* -----------------------------
 Delete if all category from bundle get deleted
------------------------------------------*/
function maybeDeleteMainBundle({ day, tt,cartKey }) {
  const tiffin = selectedTiffins.days?.[day]?.tiffins?.[tt];
  if (!tiffin) return;

  const requiredCats = ["proteins", "veggies", "sides", "probiotics"];
  const allRemoved = requiredCats.every(cat => !tiffin?.[cat]);

  if (!allRemoved) return;
   initializeActiveTiffinUI() 
  if (cartKey) {
    removeCartItemByKey(cartKey,'dinner')
      .then(() => updateCartCount())
      .catch(console.error);
  }
}


async function removeCartItemByKey(cartKey, type) {
  if (!cartKey || cartKey === "undefined") return null;

  const overlaydivCartSummary = document.querySelector(".cart-summary-wrapper");

  if (overlaydivCartSummary) {
    overlaydivCartSummary.classList.add("cart-summary-overlay");
  }

  try {
    const res = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: cartKey,
        quantity: 0
      })
    });

    if (!res.ok) {
      throw new Error("Failed to remove cart item");
    }

    const cart = await res.json();

    await updateCartCount();

    return cart;
  } catch (error) {
    console.error("Remove cart item failed:", error);
    return null;
  } finally {
    if (overlaydivCartSummary) {
      overlaydivCartSummary.classList.remove("cart-summary-overlay");
    }
  }
}


// function removeCartItemByKey(cartKey,type) {
//   const overlaydivCartSummary = document.querySelector('.cart-summary-wrapper');

//   if (overlaydivCartSummary) {
//     overlaydivCartSummary.classList.add('cart-summary-overlay');
//   }

//   return fetch('/cart/change.js', {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({
//       id: cartKey,
//       quantity: 0
//     })
//   })
//   .then(res => res.json())
//   .then(async () => {
//     selectedTiffins = await syncCartToLocalStorage();
//     renderCartSummary(type);
//   })
//   .finally(() => {
//     if (overlaydivCartSummary) {
//       overlaydivCartSummary.classList.remove('cart-summary-overlay');
//     }
//   });
// }


async function updateCartCount() {
  try {
    const r = await fetch("/cart.js", { cache: "no-store" });
    const cart = await r.json();

    document.querySelectorAll(".t4s-count-box-custom").forEach((icon) => {
      icon.textContent = cart.item_count;
    });

    const htcartcount = document.querySelector(".ht-cart-count");
    if (htcartcount) htcartcount.textContent = cart.item_count;

    return cart;
  } catch (err) {
    console.error("Cart fetch failed", err);
    return null;
  }
}



  function refreshMiniCart(el,initialRender) {
    fetch("/?sections=mini_cart")
      .then((res) => res.json())
      .then((data) => {
        const cartDrawerEl = document.querySelector("#t4s-mini_cart");

       updateCartCount()

        if (cartDrawerEl && data["mini_cart"]) {
          const bottomCartdrawer = cartDrawerEl.querySelector(
            ".t4s-drawer__wrap"
          );

          // Create a temporary DOM element to parse returned HTML
          const tempContainer = document.createElement("div");
          tempContainer.innerHTML = data["mini_cart"];

          const sectionDiv = tempContainer.querySelector(
            "#shopify-section-mini_cart"
          );
          const bottomcontainertemp = sectionDiv.querySelector(
            ".t4s-drawer__wrap"
          );

          if (sectionDiv) {
            bottomCartdrawer.innerHTML = bottomcontainertemp.innerHTML; // replace inner HTML
          } else {
            console.warn(
              "Returned HTML does not contain expected section div."
            );
          }
    
       
        } else {
          console.warn(
            "Could not refresh cart drawer: drawer element or section data not found."
          );
        }
      })
      .catch((error) => console.error("Error refreshing cart drawer:", error));
  }




// document.addEventListener("click", function(e) {

//   const btn = e.target.closest(".remove-btn");
//   if (!btn) return;

//   const { day, tt, cat, variant, type ,cartline} = btn.dataset;
//   let deletetype='dinner'

//   const dayData = selectedTiffins.days[day];

//   if (!dayData) return;

//   // ===========================
//   // MAIN TIFFIN
//   // ===========================
//   if (type === "main") {
//     if (dayData.tiffins?.[tt]?.[cat]) {
//      let  item = dayData.tiffins[tt][cat]; 
//       delete dayData.tiffins[tt][cat];
//       removeTiffinUIState({ day, tt, cat, variantId: variant});
      
//       maybeDeleteMainBundle({ day, tt,cartKey: item?.cartKey });
//     }
//   }

//   // ===========================
//   // ALA CARTE
//   // ===========================
//   if (type === "ala") {
//     if (dayData.ala?.[cat]?.[variant]) {
//         const item = dayData.ala?.[cat]?.[variant];
//       delete dayData.ala[cat][variant];
//      resetDeleteAlaUI(day,cat,variant)
//       // cleanup empty category
//       if (!Object.keys(dayData.ala[cat]).length) {
//         delete dayData.ala[cat];
//       }
//         if (item.cartKey) {
//       removeCartItemByKey(item?.cartKey,'dinner')
//         .then(() => refreshMiniCart());
//     }
//     }
//   }

//   // ===========================
//   // PANTRY
//   // ===========================
//   if (type === "pantry") {
//     if (dayData.pantry?.[cat]?.[variant]) {
//        const item = dayData.pantry?.[cat]?.[variant];
//       delete dayData.pantry[cat][variant];

//       if (!Object.keys(dayData.pantry[cat]).length) {
//         delete dayData.pantry[cat];
//       }

//      if (item?.cartKey) {
//       removeCartItemByKey(item?.cartKey,'pantry')
//       .then(() => refreshMiniCart());
//     }

//       updatePantryUI(day, cat ,variant);
//       deletetype = 'pantry'
//     }
//   }

//     // ===========================
//   // lunch
//   // ===========================
//   if (type === "lunch") {
//     if (dayData.lunch?.[cat]?.[variant]) {
//        const item = dayData.lunch?.[cat]?.[variant];
//       delete dayData.lunch[cat][variant];

//       // cleanup empty category
//       if (!Object.keys(dayData.lunch[cat]).length) {
//         delete dayData.lunch[cat];
//       }
//         updateLunchUI(day,cat,variant)

//       if (item?.cartKey) {
//       removeCartItemByKey(item?.cartKey,'lunch')
//         .then(() => refreshMiniCart());
//     }
//       deletetype = 'lunch'
//     }
//   }

//   // ===========================
//   // UPDATE UI
//   // ===========================
//   updateTiffinData();
//   renderCartSummary(deletetype);

// });

document.addEventListener("click", async function(e) {
  const btn = e.target.closest(".remove-btn");
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  const { day, tt, cat, variant, type } = btn.dataset;

  let deletetype = "dinner";
  let item = null;

  const dayData = selectedTiffins.days?.[day];
  if (!dayData) return;

  // ===========================
  // MAIN TIFFIN
  // ===========================
  if (type === "main") {
    item = dayData.tiffins?.[tt]?.[cat];

    if (item) {
      delete dayData.tiffins[tt][cat];

      removeTiffinUIState({
        day,
        tt,
        cat,
        variantId: variant
      });

      const requiredCats = ["proteins", "veggies", "sides", "probiotics"];
      const allRemoved = requiredCats.every(c => !dayData.tiffins?.[tt]?.[c]);

      if (allRemoved && item.cartKey) {
        await removeCartItemByKey(item.cartKey, "dinner");
      }
    }
  }

  // ===========================
  // ALA CARTE
  // ===========================
  if (type === "ala") {
    item = dayData.ala?.[cat]?.[variant];

    if (item) {
      delete dayData.ala[cat][variant];

      if (!Object.keys(dayData.ala[cat]).length) {
        delete dayData.ala[cat];
      }

      resetDeleteAlaUI(day, cat, variant);

      if (item.cartKey) {
        await removeCartItemByKey(item.cartKey, "dinner");
      }
    }
  }

  // ===========================
  // PANTRY
  // ===========================
  if (type === "pantry") {
    item = dayData.pantry?.[cat]?.[variant];
    deletetype = "pantry";

    if (item) {
      delete dayData.pantry[cat][variant];

      if (!Object.keys(dayData.pantry[cat]).length) {
        delete dayData.pantry[cat];
      }

      updatePantryUI(day, cat, variant);

      if (item.cartKey) {
        await removeCartItemByKey(item.cartKey, "pantry");
      }
    }
  }

  // ===========================
  // LUNCH
  // ===========================
  if (type === "lunch") {
    item = dayData.lunch?.[cat]?.[variant];
    deletetype = "lunch";

    if (item) {
      delete dayData.lunch[cat][variant];

      if (!Object.keys(dayData.lunch[cat]).length) {
        delete dayData.lunch[cat];
      }

      updateLunchUI(day, cat, variant);

      if (item.cartKey) {
        await removeCartItemByKey(item.cartKey, "lunch");
      }
    }
  }

  if (!item) return;

  updateTiffinData();
  renderCartSummary(deletetype);
  refreshMiniCart();
});

document.addEventListener("click", function(e) {

  const btn = e.target.closest(".remove-addon-btn");
  if (!btn) return;

  const { day, cat, variant } = btn.dataset;

  delete selectedTiffins.days[day].ala[cat][variant];

  updateTiffinData();
  renderCartSummary();

  // ✅ If active day → reload ALA products
  if (selectedTiffins.currentDay === day) {
    const dayObj = getDayObjByHandle(day);
    loadAlaProudcts(dayObj);
  }

});



document.addEventListener("click", function (e) {
  const addonHeader = e.target.closest(".addon-select-title");
      const alacontainer = document.getElementById("alaProductContainer");

  if (!addonHeader) return;

  const dayName = addonHeader.dataset.dayName;
  if (!dayName) return;

  const dayObj = getDayObjByHandle(dayName);
  if (!dayObj) return;

  // ===========================
  // TOGGLE STATE
  // ===========================
  let isOpen = addonHeader.dataset.open === "true";
  isOpen = !isOpen;
  addonHeader.dataset.open = isOpen;

  // ===========================
  // SWITCH VIEW
  // ===========================
  if (isOpen) {
    // 👉 LOAD ALA
    loadAlaProudcts(dayObj, null, true);
  } else {
    // 👉 BACK TO MAIN
    if(alacontainer) alacontainer.innerHTML =''
  }

  // ===========================
  // UI TOGGLE
  // ===========================
  const wrapper = addonHeader.closest(".tiffin-prods-and-title-wrapper");
  if (wrapper) {
    wrapper.classList.toggle("active", isOpen);
  }
});


// document.addEventListener("click", function(e) {

//   const btn = e.target.closest(".remove-pantry-btn");
//   if (!btn) return;

//   const { day, variant, cat } = btn.dataset;

//   if (
//     selectedTiffins.days?.[day]?.pantry?.[cat]?.[variant]
//   ) {
//     delete selectedTiffins.days[day].pantry[cat][variant];

//     // ✅ remove empty category
//     if (Object.keys(selectedTiffins.days[day].pantry[cat]).length === 0) {
//       delete selectedTiffins.days[day].pantry[cat];
//     }
//   }

//   updateTiffinData();
//   renderCartSummary('pantry');
// });


document.addEventListener("click", function(e){

  const warn = e.target.closest(".missing-warning");
  if (!warn) return;

  const { day, tt } = warn.dataset;
  // ✅ Update state
  selectedTiffins.currentDay = day;
  selectedTiffins.currentTiffinSize = parseInt(tt);
  window.activeDaysData.activeDay = day;

  updateTiffinData();

  // ✅ Make calendar button active
  document
    .querySelectorAll(".tiffin-calendar-day-btn")
    .forEach(btn => btn.classList.remove("active-day"));

  const activeBtn = document.querySelector(
    `.tiffin-calendar-day-btn[data-day="${day}"]`
  );

  if (activeBtn) {
    activeBtn.classList.add("active-day");
  }

  // ✅ Update navigation buttons
  updateNavigationButtons();

  // ✅ Load products
  const dayObj = getDayObjByHandle(day);
  loadMainProduct(dayObj);

});


function getCartWarningSummaryHTML(warnings) {
  if (!warnings || !warnings.length) return "";

  const dinnerDays = [];
  const lunchDays = [];
  const pantryDays = [];

  warnings.forEach(day => {
    const dayName = day.dayKey
      ? day.dayKey.charAt(0).toUpperCase() + day.dayKey.slice(1)
      : day.dayLabel?.split("|")[1]?.trim() || day.dayLabel;

    const dinnerWarnings = day.dinner || [];

    const hasDinnerIssue = dinnerWarnings.some(item =>
      item.type === "tiffin" || item.type === "ala"
    );

    const hasPantryIssue = dinnerWarnings.some(item =>
      item.type === "pantry"
    );

    if (hasDinnerIssue) {
      dinnerDays.push(dayName);
    }

    if (hasPantryIssue) {
      pantryDays.push(dayName);
    }

    if (day.lunch) {
      lunchDays.push(dayName);
    }
  });

  let html = "";

  if (dinnerDays.length) {
    html += `<p>Dinner missing for ${dinnerDays.join(", ")}</p>`;
  }

  if (lunchDays.length) {
    html += `<p>Lunch missing for ${lunchDays.join(", ")}</p>`;
  }

  if (pantryDays.length) {
    html += `<p>Pantry missing for ${pantryDays.join(", ")}</p>`;
  }

  return html;
}


function updateGrandTotal(baseTotal, extraTotal,lunchtotal,pantryTotal, hasError,warnings) {

  const checkoutWrapper = document.querySelector('.cart-summary-checkout-btn');
  const totalEl = document.querySelector(".cart-summary-total-info");

  if (!totalEl) return;

  const finalTotal = baseTotal + extraTotal;
  console.log('1111111111111111111111111111111',warnings)

  if (warnings.length) {
   const warningMessage = getCartWarningSummaryMessage(warnings);
     const warningMessageHTML = getCartWarningSummaryHTML(warnings);

  totalEl.innerHTML = `
    <div class='total-price-info'>
    <div class="warning-review-required">
  <div class="review-required-left">
    <div class="review-required-icon">!</div>

    <div class="review-required-content">
      <h2>Review your order</h2>
       ${warningMessageHTML}
    </div>
  </div>

  <div class="review-required-arrow">
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
   <path d="M6.66699 11.3333L10.0003 7.99992L6.66699 4.66659" stroke="#127E51" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
     </svg>
  </div>
</div>
      
    </div>
  `;
} else {

    let totalDisplay = "";
const baseValue = Number(baseTotal) || 0;
const extraValue = Number(extraTotal) || 0;
const lunchValue = Number(lunchtotal) || 0;
const pantryValue = Number(pantryTotal) || 0;

const totalParts = [];

if (baseValue > 0) {
  totalParts.push(`$${baseValue.toFixed(2)}`);
}

if (extraValue > 0) {
  totalParts.push(`$${extraValue.toFixed(2)}`);
}

if (lunchValue > 0) {
  totalParts.push(`$${lunchValue.toFixed(2)}`);
}

if (pantryValue > 0) {
  totalParts.push(`$${pantryValue.toFixed(2)}`);
}

totalDisplay = totalParts.length
  ? totalParts.join(" + ")
  : `$${baseValue.toFixed(2)}`;

    totalEl.innerHTML = `
      <div class='total-price-info'>Total: <span>${totalDisplay}</span></div>
    `;
  }

  if (checkoutWrapper) {
    checkoutWrapper.innerHTML = `
      <div class='loader-buttons-wrapper'>
        <button class="tiffin-add-to-cart healthy-tiffin-button button">
          ${warnings.length ? 'Complete Required Items' : 'Place an Order'}
        </button>
        <div class="loading-tiffin-checkout hidden"></div>
      </div>
    `;
  }

}

function setSideBarCategory(sections, dayObj, type) {

  const mainWrapper = document.querySelector(".main-tiffin-side-cat-select");
  const alaWrapper = document.querySelector(".alacarte-tiffin-side-cat-select");

  let sidebarWrapper;
  let dataKey;
  let mobilealaswiper;

  const firstSection = sections?.[0];

  // ===========================
  // TYPE SWITCH
  // ===========================
  if (type === "tiffin") {
    dataKey = "main_tiffin";
    sidebarWrapper = mainWrapper?.querySelector(".tiffin-sidebar-inner");

    if (mainWrapper) mainWrapper.style.display = "block";
    if (alaWrapper) alaWrapper.style.display = "none";
  } 
  else if (type === "ala") {
    dataKey = "ala_carte";
    sidebarWrapper = alaWrapper?.querySelector(".tiffin-sidebar-inner");
    mobilealaswiper = alaWrapper?.querySelector(".alaswiperwrapper");

    if (alaWrapper) alaWrapper.style.display = "block";
    if (mainWrapper) mainWrapper.style.display = "none";
  }

  if (!sidebarWrapper) return;

  // reset
  sidebarWrapper.innerHTML = "";
  if (mobilealaswiper) mobilealaswiper.innerHTML = "";

  // ===========================
  // LOOP SECTIONS
  // ===========================
  sections.forEach((section, index) => {

    const items = dayObj?.[dataKey]?.[section.key];
    if (!items || !items.length) return;

    const formattedName =
      section.category.charAt(0).toUpperCase() + section.category.slice(1);

    // ===========================
    // DESKTOP SIDEBAR
    // ===========================
    sidebarWrapper.innerHTML += `
      <span class="sidebar-cat-name sidebar-cat-name-maintiffin ${index === 0 ? "active" : ""}"
            data-section-type="${type}"
            data-cat-name="${section.category}">
        ${formattedName}
      </span>
    `;

    // ===========================
    // MOBILE SWIPER (ONLY FOR ALA)
    // ===========================
    if (type === "ala" && mobilealaswiper) {
      mobilealaswiper.innerHTML += `
        <div class="swiper-slide sidebar-cat-name sidebar-cat-name-alacarte "
        data-section-type="${type}"
            data-cat-name="${section.category}">
          <span class="alacarte-sidebar-text"
                data-section-type="${type}"
                data-cat-name="${section.category}">
            ${formattedName}
          </span>
        </div>
      `;
    }
  });

  // ===========================
  // SCROLL TO FIRST
  // ===========================
  if (firstSection?.category) {
    scrollToProductSection(type, firstSection.category);
  }
}


document.addEventListener("click", function(e) {

  const sidebarItem = e.target.closest(".sidebar-cat-name");
  if (!sidebarItem) return;

  const category = sidebarItem.dataset.catName;
  const type = sidebarItem.dataset.sectionType;

  scrollToProductSection(type, category);

});


function scrollToProductSection(type, category = null) {
  const sections = document.querySelectorAll(
    `.tiffin-prods-and-title-wrapper[data-section-type="${type}"]`
  );

  if (!sections.length) return;

  let targetSection;

  // =========================
  // If category provided
  // =========================
  if (category) {
    targetSection = Array.from(sections).find(section =>
      section.dataset.dayCategory === category
    );
  }

  // =========================
  // If no category → first section (NO SCROLL)
  // =========================
  if (!targetSection) {
    targetSection = sections[0];
  }

  if (!targetSection) return;

  const finalCategory = targetSection.dataset.dayCategory;

  // =========================
  // Sidebar Active Handling
  // =========================
  document.querySelectorAll(
    `.sidebar-cat-name[data-section-type="${type}"]`
  ).forEach(el => el.classList.remove("active"));

  const activeSidebar = document.querySelector(
    `.sidebar-cat-name[data-section-type="${type}"][data-cat-name="${finalCategory}"]`
  );

  if (activeSidebar) {
    activeSidebar.classList.add("active");
  }

  // =========================
  // Scroll ONLY if category passed
  // =========================
  if (category) {
    targetSection.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }
}
/* =================================================
   MAIN TIFFIN
================================================= */

function loadMainProduct(dayObj, category) {
  const container = document.getElementById("mainProductContainer");
   const alcontainer = document.getElementById("alaProductContainer");

   container.style.display = 'block'
  container.innerHTML = "";
  if(alcontainer) alcontainer.innerHTML = ""
  appcontextdata.menuType = 'tiffin'
  if (!dayObj || !dayObj.main_tiffin) {
    container.innerHTML = `<div class="no-items-message-products">No items available for this day.</div>`;
    if(gotonextdaybutton) gotonextdaybutton.style.display='none';
    if(global_filter_wrapper) global_filter_wrapper.style.display='none'
  } else { 
    if(gotonextdaybutton) gotonextdaybutton.style.display='flex';
    if(global_filter_wrapper) global_filter_wrapper.style.display='flex'
  }

  setCurrentDay(dayObj.handle, dayObj.handle);
  

toggleAddNextTiffinBtn()
  const dayHandle = dayObj.handle;
  const d = getDateFromWeekday(dayHandle);
  const dayName = d.toLocaleString("en-US", { weekday: "long" });
  const priceInfo = window.priceThresholdsAndTitles;

  const sections = [
    { key: "proteins", title: priceInfo.main_protein_title, threshold: priceInfo.proteins ,category:"proteins" },
    { key: "veggies", title: priceInfo.main_veggies_title, threshold: priceInfo.veggies,category:"veggies" },
    { key: "sides", title: priceInfo.main_sides_title, threshold: priceInfo.sides,category:"sides" },
    { key: "probiotics", title: priceInfo.main_probiotics_title, threshold: priceInfo.probiotics,category:"probiotics" }
  ];

  setSideBarCategory(sections,dayObj,'tiffin')
  let any = false;

  sections.forEach((section, i) => {
    const items = dayObj.main_tiffin[section.key];
    if (!items || !items.length) return;
    any = true;

    let html = `
       <div class="tiffin-prods-and-title-wrapper main-tiff-type-prod-and-title-wrapper " data-section-type='tiffin' data-day-date="${dayObj.handle}" data-day-name="${dayObj.handle}" data-day-category="${section.key}" data-category-index='${i + 1}'>
      <div class='tiffin-accord-title main-tiff-type-cat-accord-tittle' data-tiffin-cat="${section.key}"> 
       <div class=" tiffinday-selected-item-headers  main-tiffday-selected-items "> 
          <div class='title-selected-items main-tiffday-title-selected-items'>
            <h3>${section.title}</h3>
              <div class='selected-item-accordian'>
                <span class='select-item-message'> 
                Choose your ${section.key} to continue
                </span>
              <span class='tiffinday-cat-accordian' style='display:none'> 
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none"  xmlns="http://www.w3.org/2000/svg">
                <path d="M4.66675 6.66699L8.00008 10.0003L11.3334 6.66699" stroke="#127E51" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
               </svg>
               </span>
            </div>
         </div>
         <span class='tiffinday-selected-items-title maintiffin-selected-items-title' data-main data-selectedtitle-date='${dayObj.date}' data-day-name='${dayObj.handle}' data-selectedtitle-name='${section.key}' data-category-index='${i + 1}'> </span>
       </div>
      </div>
        <ul class="category-prdlist-wrapper maintiffin-category-prdlists " data-main-tiffinday='${dayObj.handle}'data-category-index='${i + 1}' data-tiffin-cat='${section.category}'>`;

    items.forEach(item => {
      const extra = parseFloat(item.price) > section.threshold
        ? `+ $${(item.price - section.threshold).toFixed(2)}`
        : "";
      const extraRaw = item.price > section.threshold ? `${Math.max(0, (item.price - section.threshold).toFixed(2))}` : "";

        html += `
        <li class="category-product-detail maintiffin-category-product-li"
          data-product-handle="${item.p_handle}"
            data-main-category="${section.category}"
            data-day-date="${dayObj.handle}"
            data-day="${dayHandle}"
            data-tags-list="${item.tags?.length > 0 ? item.tags.join(', ') : ''}"
            data-day-name="${dayName}">
          <div class='tiffin-day-prod-wrapper maintiffin-category-prod-wrapper'>
            <div class='maintiffin-input-label'
                 data-prod-title="${item.title}"
                 data-day-date='${dayObj.handle}'
                 data-category-name="${section.key}">
              <input
                id="tiffin-product-${item.id}-${dayObj.handle}-${section.key}"
                type='radio'
                class='maintiffin-products-select'
                data-main-category
                data-prod-img="${item.image}"
                data-prod-date='${item.computedDate}'
                data-category-name="${section.key}"
                data-day-date="${dayObj.handle}"
                data-prod-price="${item.price}"
                data-prod-title="${item.title}"
                data-prod-variant="${item.variant_id}"
                data-extra-price ='${extraRaw}'
                name="tiffin-product"
                value="main"
                data-day-name="${dayName}">
              <label class='maintiffin-prod-radio-label' for="tiffin-product-${item.id}-${dayObj.handle}-${section.key}">
                <div class='maintiffin-prod-img tiffin-prod-img'>
                <div class="tiffindays-tags-container tiffindays-tags-container-main">
                 ${Array.isArray(item.tags)
                  ? item.tags
                 .slice(0, 3)
                   .map((t, i) =>
                `<span class="tiffin-day-tags tiffin-prod-tags-${i + 1} diet-tag" data-tag='${t.toLowerCase()}'>${t.toLowerCase() === 'vg' ? 'vgn' : t}</span>`
                )
                .join("")
              : ""}
             </div>
                  <span class="icon-hoveer-description icon-hover-main-desc">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                      <path d="M11.9999 21.594C17.3024 21.594 21.5999 17.2965 21.5999 11.994C21.5999 6.69154 17.3024 2.39404 11.9999 2.39404C6.6974 2.39404 2.3999 6.69154 2.3999 11.994C2.3999 17.2965 6.6974 21.594 11.9999 21.594ZM10.7999 8.39404C10.7999 7.73029 11.3362 7.19404 11.9999 7.19404C12.6637 7.19404 13.1999 7.73029 13.1999 8.39404C13.1999 9.05779 12.6637 9.59404 11.9999 9.59404C11.3362 9.59404 10.7999 9.05779 10.7999 8.39404ZM10.4999 10.794H12.2999C12.7987 10.794 13.1999 11.1953 13.1999 11.694V14.994H13.4999C13.9987 14.994 14.3999 15.3953 14.3999 15.894C14.3999 16.3928 13.9987 16.794 13.4999 16.794H10.4999C10.0012 16.794 9.5999 16.3928 9.5999 15.894C9.5999 15.3953 10.0012 14.994 10.4999 14.994H11.3999V12.594H10.4999C10.0012 12.594 9.5999 12.1928 9.5999 11.694C9.5999 11.1953 10.0012 10.794 10.4999 10.794Z" fill="white"></path>
                                                    </svg>
                                                  </span>
                  <div class="prod-featured-img">
                    <img src="${item.image|| FALLBACK_IMG}" alt="${item.title || ''}"/>
                  </div>
                </div>
                <div class="tiffin-prod-content maintiffin-prod-content ">
                  <span class="tiffin-prod-title maintiffin-prod-title">${item.title}</span>
                  <span class="product-price-threshold"
                        data-threshold-diff="${extraRaw}">
                    ${extra}
                  </span>
                </div>
              </label>
            </div>
          </div>
        </li>
      `;
    });

       html += `</ul></div>`;

    container.innerHTML += html;
     pageLoaderChange()
      toggleNextDayButton(dayObj)
    
  });

  // ===========================
// ADDONS COLLAPSIBLE (BOTTOM)
// ===========================
if (any) {
  const addonHTML = `
    <div class="tiffin-prods-and-title-wrapper select-addon-collapsible"
         data-select-day="${dayObj.handle}">

      <div class="main-tiff-type-cat-accord-tittle tiffin-accord-title addon-select-title" data-day-name='${dayObj.handle}'>
        <div class="main-tiffday-selected-items tiffinday-selected-item-headers">
          
          <div class="main-tiffday-title-selected-items title-selected-items ">
            <h3>Select Add Ons</h3>

            <span class="tiffinday-cat-accordian">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M4.66675 6.66699L8.00008 10.0003L11.3334 6.66699"
                  stroke="#127E51"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"/>
              </svg>
            </span>

          </div>

        </div>
      </div>

    </div>
  `;

  container.insertAdjacentHTML("beforeend", addonHTML);
}

  if (!any) {
    container.innerHTML = `<div class="no-items-message-products">No items available for this day.</div>`;
  }
initializeActiveTiffinUI();
loadAlaProudcts(dayObj,null,true)
 
}



function updateAddonUI(wrapper, quantity) {
  const qtyBox = wrapper.querySelector(".tiffinday-input-ala");
  const toggleWrapper = wrapper.querySelector(".quanityselectortoggle");
  const addBtn = wrapper.querySelector(".ala-addto-cart");
  const inputala = wrapper.querySelector('.tiffinday-input-ala')

  const minusBtn = wrapper.querySelector(".minus-quanity-minus");
  const deleteBtn = wrapper.querySelector(".minus-quantity-remove");

  if (qtyBox) qtyBox.value = quantity;

  if (quantity > 0 ) {
    if (addBtn) addBtn.style.display = "none";
    if (toggleWrapper) toggleWrapper.style.display = "flex";
   

    if (quantity === 1) {
      if (minusBtn) minusBtn.classList.add("hidden");
      if (deleteBtn) deleteBtn.classList.remove("hidden");
    } else {
      if (minusBtn) minusBtn.classList.remove("hidden");
      if (deleteBtn) deleteBtn.classList.add("hidden");
    }
  } else {
    if (addBtn) { 
      addBtn.style.display = "block";
      addBtn.textContent = '+'
    }
    if (toggleWrapper) toggleWrapper.style.display = "none";
     if(inputala) inputala.value = 1;
  }
}


function getAddonWrapper(btn) {
  return btn.closest(".ala-cart-quanity-wrapper");
}



function getAddonData(wrapper) {
  return {
    dayDate: wrapper.dataset.dayDate,
    dayName: wrapper.dataset.dayName,
    categoryName: wrapper.dataset.categoryName,
    variantId: wrapper.dataset.prodVariant,
    prodImg: wrapper.dataset.prodImg
  };
}




function ensureAddonStorage(dayDate, categoryName) {
  if (!selectedTiffins.days[dayDate]) return;

  if (!selectedTiffins.days[dayDate].ala) {
    selectedTiffins.days[dayDate].ala = {};
  }

  if (!selectedTiffins.days[dayDate].ala[categoryName]) {
    selectedTiffins.days[dayDate].ala[categoryName] = {};
  }

}
function addAddonProduct(wrapper) {
  const data = getAddonData(wrapper);
  ensureAddonStorage(data.dayName, data.categoryName);
  const qtyInput = wrapper.querySelector(".tiffinday-input-ala");
  const title = qtyInput.dataset.prodTitle;
  const price = qtyInput.dataset.prodPrice || 0;
  const categorywrapper = wrapper.closest(".tiffin-prods-and-title-wrapper");
  const quanityraw = parseInt(qtyInput.value);
  const actualQuantity = quanityraw == 0 ? 1 : quanityraw;

  // Ensure selectedTiffins.days[data.dayName] and selectedTiffins.days[data.dayName].ala are initialized
  if (!selectedTiffins.days[data.dayName]) {
    selectedTiffins.days[data.dayName] = {};
  }
  if (!selectedTiffins.days[data.dayName].ala) {
    selectedTiffins.days[data.dayName].ala = {};
  }

  selectedTiffins.days[data.dayName].ala[data.categoryName] = selectedTiffins.days[data.dayName].ala[data.categoryName] || {};

  selectedTiffins.days[data.dayName].ala[data.categoryName][data.variantId] = {
    title: title,
    price: price,
    img: data.prodImg,
    quantity: actualQuantity,
  };

  const activeQuantitySelector = document.querySelectorAll('.ala-cart-quanity-wrapper');
  activeQuantitySelector.forEach((item) => {
    const input = item.querySelector('input');
    if (!input) return;
    const inputValue = input.value;

    const quanittySelctor = item.querySelector('.tiffinday-quantity-selectors');
    const mainPlusIcon = item.querySelector('.addtotiffin-mainbtn');
    mainPlusIcon.style.display = 'block';
    quanittySelctor.style.display = 'none';

    if (inputValue >= 1) {
      mainPlusIcon.innerHTML = inputValue;
      mainPlusIcon.classList.add('inputvalue');
    }
  });

  updateTiffinData();
  updateAddonUI(wrapper, actualQuantity);
  updateHeader(categorywrapper, data.categoryName, "ala");
  renderCartSummary();
  closePopup();
}

//   function addAddonProduct(wrapper) {
//   const data = getAddonData(wrapper);
//   ensureAddonStorage(data.dayName, data.categoryName);
//   const qtyInput = wrapper.querySelector(".tiffinday-input-ala");
//   const title = qtyInput.dataset.prodTitle;
//   const price = qtyInput.dataset.prodPrice || 0;
//   const categorywrapper = wrapper.closest(".tiffin-prods-and-title-wrapper");
//   const quanityraw = parseInt(qtyInput.value)
//   const actualQuantity = quanityraw == 0 ? 1 : quanityraw

//     if (!selectedTiffins.days[data.dayName]) {
//     selectedTiffins.days[data.dayName] = {};
//   }
//   if (!selectedTiffins.days[data.dayName].ala) {
//     selectedTiffins.days[data.dayName].ala = {};
//   }

//   selectedTiffins.days[data.dayName].ala[data.categoryName][data.variantId] = {
//     title: title,
//     price: price,
//     img: data.prodImg,
//     quantity: actualQuantity
//   };



//     const activeQuantitySelector = document.querySelectorAll('.ala-cart-quanity-wrapper');
//            activeQuantitySelector.forEach((item) => {
//                const input = item.querySelector('input');
//                if (!input) return;
//                const inputValue = input.value;

//                const quanittySelctor = item.querySelector('.tiffinday-quantity-selectors');

//                const mainPlusIcon = item.querySelector('.addtotiffin-mainbtn');
//                mainPlusIcon.style.display='block'
//                 quanittySelctor.style.display='none'
//                if (inputValue >= 1) {
//                    mainPlusIcon.innerHTML = inputValue;
//                    mainPlusIcon.classList.add('inputvalue')
//                }
//            });

//   updateTiffinData();
//   updateAddonUI(wrapper, actualQuantity);
//   updateHeader(categorywrapper, data.categoryName, "ala");
//   renderCartSummary()
//   closePopup()
// }



function increaseAddonQty(wrapper) {
  const data = getAddonData(wrapper);
  const item =selectedTiffins.days?.[data.dayName]?.ala?.[data.categoryName]?.[data.variantId];
  const categorywrapper = wrapper.closest(".tiffin-prods-and-title-wrapper");
  if (!item) return;
  item.quantity += 1;
  updateTiffinData();
  updateAddonUI(wrapper, item.quantity);
   renderCartSummary()
   closePopup()
}

function decreaseAddonQty(wrapper) {
  const data = getAddonData(wrapper);

  const dayData = selectedTiffins.days?.[data.dayName];
  const item = dayData?.ala?.[data.categoryName]?.[data.variantId];
  const categorywrapper = wrapper.closest(".tiffin-prods-and-title-wrapper");

  if (!item) return;

  if (item.quantity > 1) {
    item.quantity -= 1;
    updateAddonUI(wrapper, item.quantity);
  } else {
    delete dayData.ala[data.categoryName][data.variantId];

    if (!Object.keys(dayData.ala[data.categoryName]).length) {
      delete dayData.ala[data.categoryName];
    }

    updateAddonUI(wrapper, 0);
  }

  updateTiffinData();
  updateHeader(categorywrapper, data.categoryName, "ala");
  renderCartSummary();
  closePopup();
}



/* =================================================
  RENDER ALA PRODUCTS
================================================= */

function loadAlaProudcts(dayObj, category,renderfromMain=false){ 
const container = document.getElementById("alaProductContainer");
const maincontainer = document.getElementById('mainProductContainer');
if(!renderfromMain)
{ 
  appcontextdata.menuType = 'ala'
  if(addanothertiffinButton) addanothertiffinButton.style.display='none'
} else { 
    appcontextdata.menuType = 'main'

}
appcontextdata.menuType = 'ala'
if(maincontainer && !renderfromMain) maincontainer.style.display='none'
  container.innerHTML = "";

  if (!dayObj || !dayObj.ala_carte) {
    container.innerHTML = `<div class="no-items-message-products">No items available for this day.</div>`;
     if(gotonextdaybutton) gotonextdaybutton.style.display='none';
    if(global_filter_wrapper) global_filter_wrapper.style.display='none'
  } else { 
    if(gotonextdaybutton) gotonextdaybutton.style.display='flex';
    if(global_filter_wrapper) global_filter_wrapper.style.display='flex'
  }

  const dayHandle = dayObj.handle;
    setCurrentDay(dayObj.handle, dayObj.handle);
    toggleNextDayButton(dayObj)
    setTimeout(() => {
    restoreAlaSelectionsForDay(dayHandle);
  }, 50);
  const d = getDateFromWeekday(dayHandle);
  const dayName = d.toLocaleString("en-US", { weekday: "long" });
  const priceInfo = window.priceThresholdsAndTitles;
  console.log('price info',priceInfo)

 const sections = [
    { key: "proteins", title: priceInfo.alacarte_protein_title, category: 'proteins' },
    { key: "veggies", title: priceInfo.alacarte_veggies_title, category: "veggies" },
    { key: "sides", title: priceInfo.alacarte_sides_title, category: "sides" },
    { key: "probiotics", title: priceInfo.alacarte_probiotics_title, category: "probiotics" },
    { key: "paranthas", title: priceInfo.alacarte_paranthas_title, category: "paranthas" },
    { key: "global_cuisine", title: priceInfo.alacarte_global_cuisine_title,category: "global cuisine" },
     { key: "extra_condiments", title: priceInfo.alacarte_extra_condiments_title, category: "extra condiments" },
    { key: "drinks", title: priceInfo.alacarte_drinks_title, category: "drinks" },
    { key: "kids", title: priceInfo.alacarte_kids_title, category: "kids" },
    { key: "desserts", title: priceInfo.alacarte_desserts_title, category: "desserts" },
    { key: "oatmeals", title: priceInfo.alacarte_oatmeals_title, category: "oatmeals" },

  ];

  console.log('sections checking',sections)
  if(!renderfromMain) setSideBarCategory(sections,dayObj,'ala')
  let any = false;

  sections.forEach((section, i) => {
    const items = dayObj.ala_carte[section.key];
    if (!items || !items.length) return;
    any = true;

    let html = `
       <div class="tiffin-prods-and-title-wrapper ala-tiff-type-prod-and-title-wrapper " data-section-type='ala' data-day-name="${dayObj.handle}" data-day-date="${dayObj.date}" data-day-category="${section.category}" data-category-index='${i + 1}'>
      <div class='tiffin-accord-title ala-tiff-type-cat-accord-tittle' data-tiffin-cat="${section.category}"> 
       <div class=" tiffinday-selected-item-headers  ala-tiffday-selected-items "> 
          <div class='title-selected-items ala-tiffday-title-selected-items'>
            <h3>${section.title}</h3>
              <div class='selected-item-accordian'>
              <span class='tiffinday-cat-accordian'> 
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none"  xmlns="http://www.w3.org/2000/svg">
                <path d="M4.66675 6.66699L8.00008 10.0003L11.3334 6.66699" stroke="#127E51" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
               </svg>
               </span>
            </div>
         </div>
         <span class='tiffinday-selected-items-title ala-selected-items-title' data-ala data-selectedtitle-date='${dayObj.date}' data-selectedtitle-name='${section.category}' data-category-index='${i + 1}'> </span>
       </div>
      </div>
        <ul class="category-prdlist-wrapper ala-category-prdlists " data-tiffin-cat='${section.category}'>`;

    items.forEach(item => {
      const extra = parseFloat(item.price) > section.threshold
        ? `+ $${(item.price - section.threshold).toFixed(2)}`
        : "";

        html += `
        <li class="category-product-detail alacarte-category-product-li" data-addon-category='${section.category}' data-date-name="${dayObj.handle}" data-prod-name="${item.title}"  data-product-handle="${item.p_handle}" data-tags-list="${item.tags?.length > 0 ? item.tags.join(', ') : ''}">
          <div class='tiffin-day-prod-wrapper alacarte-category-prod-wrapper'>
            <div class='tiffin-prod-img alacarte-prod-img'>
              <div class="tiffindays-tags-container tiffindays-tags-container-main">
               ${Array.isArray(item.tags)
                 ? item.tags
                     .slice(0, 3)
                       .map((t, i) =>
                       `<span class="tiffin-day-tags tiffin-prod-tags-${i + 1} diet-tag" data-tag='${t.toLowerCase()}'>${t.toLowerCase() === 'vg' ? 'vgn' : t}</span>`
                      )
                  .join("")
              : ""}
            </div>
              <span class="icon-hoveer-description icon-hover-alacarte">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                     <path d="M11.9999 21.594C17.3024 21.594 21.5999 17.2965 21.5999 11.994C21.5999 6.69154 17.3024 2.39404 11.9999 2.39404C6.6974 2.39404 2.3999 6.69154 2.3999 11.994C2.3999 17.2965 6.6974 21.594 11.9999 21.594ZM10.7999 8.39404C10.7999 7.73029 11.3362 7.19404 11.9999 7.19404C12.6637 7.19404 13.1999 7.73029 13.1999 8.39404C13.1999 9.05779 12.6637 9.59404 11.9999 9.59404C11.3362 9.59404 10.7999 9.05779 10.7999 8.39404ZM10.4999 10.794H12.2999C12.7987 10.794 13.1999 11.1953 13.1999 11.694V14.994H13.4999C13.9987 14.994 14.3999 15.3953 14.3999 15.894C14.3999 16.3928 13.9987 16.794 13.4999 16.794H10.4999C10.0012 16.794 9.5999 16.3928 9.5999 15.894C9.5999 15.3953 10.0012 14.994 10.4999 14.994H11.3999V12.594H10.4999C10.0012 12.594 9.5999 12.1928 9.5999 11.694C9.5999 11.1953 10.0012 10.794 10.4999 10.794Z" fill="white"></path>
                         </svg>
                    </span>
              <div class="prod-featured-img alacarte-prod-img-main">
                <img class="t4s-obj-eff logo-image lazyautosizes ls-is-cached lazyloadt4sed" src="${item.image|| FALLBACK_IMG}" alt="${item.title || ''}" />
              </div>
            </div>
            <div class="alacarte-prod-content tiffin-prod-content">
              <div class="addon-prod-content tiffin-day-prod-content">
                <span class="tiffin-prod-title alacarte-prod-title"> ${item.title} </span>
                <span class="alacarte-prod-price tiffin-prod-price"> $${item.price} </span>
              </div>
              <div class="tiffinday-quantity-addtocartbtn ala-cart-quanity-wrapper addonwrapper" data-type='main' data-day-name="${dayObj.handle}" data-category-name="${section.category}" data-prod-price='${item.price}' data-day-date="${dayObj.date}" data-prod-variant="${item.variant_id}" data-prod-img="${item.image}" data-prod-date='${item.computedDate}'>
                <div class="tiffinday-quantity-selectors tiffinday-maincategory-quanity-selectors quanityselectortoggle" data-day="${dayName}" data-cat="${section.category}" data-title="${item.title}" data-prod-id="${item.variant_id}">
                  <span class="minus-quantity-selector-ala remove-product" data-addon="true" data-date="${dayObj.date}" data-day="${dayName}" data-cat="${section.category}" data-title="${item.title}" data-quantity="1">
                    <span class="minus-quanity-minus minus-quanity-minus-ala hidden"> -</span>
                    <span class="minus-qutiffin-add-to-cartantity-remove minus-quantity-remove">
                      <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.5 3H3M13.5 3H3M4 1C6.34315 1 7.65685 1 10 1M3 3V13.5H11V3" stroke="#202020" stroke-width="1.1"></path>
                      </svg>
                    </span>
                  </span>
                  <input type="number" class="tiffinday-input-ala" min="1" step="1" value="0" data-day="${dayName}" readonly data-prod-price='${item.price}' data-prod-real-id='${item.id}' data-prod-id="${item.variant_id}" data-prod-title="${item.title}" data-prod-category="${section.category}" data-date="${dayObj.date}" data-menu="addon">
                  <span class="plus-quantity-selector-ala"> incr </span>
                </div>
                <div class="addtotiffin-mainbtn ala-addto-cart" data-quantity="1">+</div>
              </div>
            </div>
          </div>
        </li>
      `;
    });

    html += `</ul></div>`;
    container.innerHTML += html;
  });


  if (!any) {
    if(renderfromMain) return
    container.innerHTML = `<div class="no-items-message-products">No items available for this day.</div>`;
  }
}




/* =================================================
  RENDER LUNCH PRODUCTS
================================================= */
function loadlunchProducts(dayObj) {
  const container = document.getElementById("lunchProductContainer");
  container.innerHTML = "";
  if (!dayObj || !dayObj.lunch || !dayObj.lunch.categories) {
    container.innerHTML = `<div class="no-items-message-products">No items available for this day.</div>`;
    return;
  }

  appcontextdata.menuType = 'lunch'

  const categories = dayObj.lunch.categories;



  let html = `<div class="lunchmainwrapper">`;

  categories.forEach((cat) => {
    if (!cat || (!cat.products?.length )) return;

    // =====================
    // CATEGORY TITLE
    // =====================
    if (cat.title) {
      html += `
        <div class='tiffin-prods-and-title-wrapper lunch-prods-and-title-wrapper' data-target='${cat.title}'  data-day-name="${dayObj.handle}">
      <div class='tiffin-accord-title lunch-tiff-type-cat-accord-tittle tiffin-accord-title' data-tiffin-cat="${cat.title}"> 
        <div class="tiffinday-selected-item-headers lunch-tiffday-selected-items"> 
          <div class='title-selected-items lunch-tiffday-title-selected-items'>
            <h3>${cat.title}</h3>
            <div class='selected-item-accordian'>          
              <span class='tiffinday-cat-accordian'> 
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M4.66675 6.66699L8.00008 10.0003L11.3334 6.66699"
                    stroke="#127E51" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
            </div>
          </div>
          <span class='tiffinday-selected-items-title lunchtiffin-selected-items-title'
            data-lunch
            data-selectedtitle-day='${dayObj.handle}'
            data-selectedtitle-name='${cat.title.toLowerCase()}'>
          </span>
        </div>
      </div>
      `;
    }

    // =====================
    // MAIN CATEGORY PRODUCTS
    // =====================
    if (cat.products?.length) {
      html += `<ul class="category-prdlist-wrapper lunch-category-prdlists" data-tiffin-cat='${cat.title}'>`;

      cat.products.forEach((item) => {
        html += renderLunchItem(item, cat.title,dayObj);
      });

      html += `</ul> </div>`;
    }
  });

  html += `</div>`;
  container.innerHTML = html;
   pageLoaderChange()
     toggleNextDayButton(dayObj)
  renderLunchSidebar(categories)
  restoreLunchData(dayObj.handle)
}

function renderLunchItem(item, categoryName,dayObj) {
  return `
    <li class="category-product-detail lunchcategory-product-li "
      data-category-name="${categoryName || ''}"
      data-day-name='${dayObj.handle}'
      data-tags-list="${item.tags?.length > 0 ? item.tags.join(', ') : ''}"
      data-prod-real-id='${item.variant_id}'
       data-product-handle="${item.p_handle}"
      data-prod-name="${item.title}">

      <div class='category-prod-wrapper lunch-prod-wrapper'>
      <div class='category-prod-img-wrapper lunch-prod-img-wrapper'> 
      <div class='category-prod-img pantry-prod-img'>
          <img class='lunch-prod-img-main'  src="${item.image|| FALLBACK_IMG_Lunch}" alt="${item.title || ''}" />
           
        </div>
        <div class="addtocart-lunchpantry lunch-addto-cart"
          data-day-name="${dayObj.handle}"
          data-prod-title="${item.title}"
           data-prod-price="${item.price}"
           data-category-name="${categoryName.toLowerCase() || ''}"
              data-prod-date='${item.computedDate}'
              data-prod-img='${item.image|| FALLBACK_IMG_Lunch }'
            data-prod-variant="${item.variant_id || ''}">

           <span class='lunchpantry-plusicon-main lunch-plus-icon-main lunch-plus-icon'> +</span>
           <div class='lunchpantryquanitity-selector lunch-quantity-selector hidden'> 
             <span class='lunchpantryminus-icon-wrap lunch-minus-icon-wrap'>
              <span class='prod-dlt-icon lunch-delete-icon '> 
                <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.5 3H3M13.5 3H3M4 1C6.34315 1 7.65685 1 10 1M3 3V13.5H11V3" stroke="#202020" stroke-width="1.1"></path>
                </svg>
              </span>
              <span class='prod-minus-icon lunch-quantity-minus-icon hidden'>-</span>
            </span>
            <input class='prod-input-main lunch-prod-input' readonly  min='1' value='1'/>
            <span class='prod-plus-icon lunch-quantity-plus-icon'>
            plus
            </span>
           </div>
          </div>
         <div class="tiffindays-tags-container tiffindays-tags-container-main">
              ${Array.isArray(item.tags)
                ? item.tags
                 .slice(0, 3)
                  .map((t, i) =>
                `<span class="tiffin-day-tags tiffin-prod-tags-${i + 1} diet-tag" data-tag='${t.toLowerCase()}'>${t.toLowerCase() === 'vg' ? 'vgn' : t}</span>`
                 )
                 .join("")
                 : ""}
          </div>
         <span class="icon-hoveer-description icon-hover-lunch-desc">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
               <path d="M11.9999 21.594C17.3024 21.594 21.5999 17.2965 21.5999 11.994C21.5999 6.69154 17.3024 2.39404 11.9999 2.39404C6.6974 2.39404 2.3999 6.69154 2.3999 11.994C2.3999 17.2965 6.6974 21.594 11.9999 21.594ZM10.7999 8.39404C10.7999 7.73029 11.3362 7.19404 11.9999 7.19404C12.6637 7.19404 13.1999 7.73029 13.1999 8.39404C13.1999 9.05779 12.6637 9.59404 11.9999 9.59404C11.3362 9.59404 10.7999 9.05779 10.7999 8.39404ZM10.4999 10.794H12.2999C12.7987 10.794 13.1999 11.1953 13.1999 11.694V14.994H13.4999C13.9987 14.994 14.3999 15.3953 14.3999 15.894C14.3999 16.3928 13.9987 16.794 13.4999 16.794H10.4999C10.0012 16.794 9.5999 16.3928 9.5999 15.894C9.5999 15.3953 10.0012 14.994 10.4999 14.994H11.3999V12.594H10.4999C10.0012 12.594 9.5999 12.1928 9.5999 11.694C9.5999 11.1953 10.0012 10.794 10.4999 10.794Z" fill="white"></path>
              </svg>
            </span>
      </div>
        
        <div class=" category-prod-content lunch-prod-content">
    ${item.vendor ? `  <span class='category-prod-vendor'> ${item.vendor} </span>` : ''}
         
   <div class='category-prod-desc-content lunch-desc-content' > 
          <span class=" category-prod-title lunch-prod-title">${item.title || ''}</span>
  
    <div class='category-prod-wtprice'> 
     <span class="category-prod-price lunch-prod-perweightprice">$${item.price ?? '0'}</span> 
     </div>
    </div>
         
        </div>
      </div>
    </li>
  `;
}


function renderLunchSidebar(categories, type = "lunch") {
  const sidebar = document.querySelector(".lunchcarte-sidebar");
  const mobileSidebarLunch = document.querySelector(".lunchswiperwrapper");

  let desktopHtml = "";
  let mobileHtml = "";

  categories.forEach((cat, index) => {
    if (!cat || !cat.title || !cat.products?.length) return;

    desktopHtml += `
      <div class="sidebar-group">
        <div 
          class="sidebar-cat-name sidebar-main ${index === 0 ? "active" : ""}" 
          data-target="${cat.title}">
          ${cat.title}
        </div>
      </div>
    `;

    mobileHtml += `
      <div 
        class="swiper-slide sidebar-cat-name sidebar-cat-name-alacarte ${index === 0 ? "active" : ""}"
        data-section-type="${type}"
        data-target="${cat.title}">
        <span class="alacarte-sidebar-text lunch-sidebar-text" data-cat-name="${cat.title}"  data-target="${cat.title}">
          ${cat.title}
        </span>
      </div>
    `;
  });

  if (sidebar) {
    sidebar.innerHTML = desktopHtml;
  }

if (mobileSidebarLunch) {
  mobileSidebarLunch.innerHTML = mobileHtml;

  setTimeout(() => {
    initLunchSwiper();
  }, 50);
}

  attachSidebarEvents();
}


function renderPantrySidebar(categories, type = "pantry") {
  const sidebar = document.querySelector(".pantrycarte-sidebar");
  const mobileSidebarLunch = document.querySelector(".pantryswiperwrapper");

  let html = "";
 let mobileHtml = "";
  categories.forEach((cat, index) => {
    if (
      !cat ||
      !cat.title ||
      (!cat.products?.length && !cat.subcategories?.length)
    ) return;

    const hasSub = cat.subcategories?.some(
      (sub) => sub?.title && sub.products?.length
    );

       mobileHtml += `
      <div 
        class="swiper-slide sidebar-cat-name sidebar-cat-name-alacarte ${index === 0 ? "active" : ""}"
        data-section-type="${type}"
        data-target="${cat.title}">
        <span class="alacarte-sidebar-text lunch-sidebar-text" data-cat-name="${cat.title}"  data-target="${cat.title}">
          ${cat.title}
        </span>
      </div>
    `;

    html += `
      <div class="sidebar-group">
        <div 
          class="sidebar-cat-name sidebar-main ${index === 0 ? "active" : ""}" 
          data-section-type="${type}"
          data-target="${cat.title}">
          ${cat.title}

          ${
            hasSub
              ? `<span class="pantry-sidebar-arrow">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M4.66675 6.66699L8.00008 10.0003L11.3334 6.66699" stroke="#127E51" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                </span>`
              : ""
          }
        </div>

        ${
          hasSub
            ? `<div class="sidebar-sub-wrapper" style="display:none;">`
            : ""
        }
    `;

    cat.subcategories?.forEach((sub) => {
      if (!sub?.title || !sub.products?.length) return;

      html += `
        <div 
          class="sidebar-cat-name sidebar-sub" 
          data-section-type="${type}"
          data-target="${sub.title}">
          ${sub.title}
        </div>
      `;
    });

    if (hasSub) html += `</div>`;

    html += `</div>`;
  });

  if (sidebar) sidebar.innerHTML = html;

  if (mobileSidebarLunch) {
  mobileSidebarLunch.innerHTML = mobileHtml;

  setTimeout(() => {
    initPantrySwiper();
  }, 50);
}


  waitForElement(".pantry-sidebar-list", (mobileSidebar) => {
    mobileSidebar.innerHTML = html;

    const menudropdownel = document.querySelector(".ht-pantry-dropdown");

    if (menudropdownel) {
      menudropdownel.addEventListener("click", function () {
        const closesli = menudropdownel.closest(".t4s-menu-item");
        const pantrydropdown = closesli.querySelector(".pantry-sidebar-list");

        if (pantrydropdown) {
          pantrydropdown.classList.toggle("hidden");
        }
      });
    }

    attachSidebarEvents();
  });

  attachSidebarEvents();
}







/* =================================================
  PANTRY PRODUCT FETCH + STOCK HELPERS
================================================= */
const pantryProductDetailsCache = {};

function getPantryProductHandle(item) {
  return item?.handle || item?.p_handle || "";
}

function formatPantryCentsPrice(cents) {
  const amount = Number(cents || 0) / 100;
  return amount.toFixed(2);
}

function normalizePantryProductFromResponse(ref, data) {
  const variants = Array.isArray(data?.variants)
    ? data.variants.map((variant) => ({
        variant_id: variant.variant_id || variant.id,
        variant_title: variant.variant_title || variant.title || variant.public_title || "Default Title",
        variant_price: variant.variant_price || (variant.price ? formatPantryCentsPrice(variant.price) : data.price),
        available: variant.available,
        inventory_quantity: variant.inventory_quantity,
        inventory_policy: variant.inventory_policy,
        inventory_management: variant.inventory_management,
        max_qty: variant.max_qty
      }))
    : [];

  const selectedVariant = variants.find((variant) =>
    String(variant.variant_id) === String(data?.variant_id || ref?.variant_id)
  ) || variants.find((variant) => variant.available !== false) || variants[0] || {};

  return {
    ...ref,
    ...data,
    id: data?.id || ref?.id,
    title: data?.title || ref?.title || "",
    handle: data?.handle || ref?.handle || ref?.p_handle || "",
    p_handle: data?.p_handle || data?.handle || ref?.p_handle || ref?.handle || "",
    image: data?.image || ref?.image || FALLBACK_IMG_Lunch,
    price: data?.price || selectedVariant.variant_price || ref?.price || "0.00",
    tags: Array.isArray(data?.tags) ? data.tags : (Array.isArray(ref?.tags) ? ref.tags : []),
    short_description: data?.short_description || ref?.short_description || "",
    vendor: data?.vendor || ref?.vendor || "",
    variant_id: data?.variant_id || selectedVariant.variant_id || ref?.variant_id,
    weight_value: data?.weight_value ?? ref?.weight_value ?? "",
    portion_image: data?.portion_image || ref?.portion_image || "",
    available: data?.available !== undefined ? data.available : selectedVariant.available,
    inventory_quantity: data?.inventory_quantity !== undefined ? data.inventory_quantity : selectedVariant.inventory_quantity,
    inventory_policy: data?.inventory_policy !== undefined ? data.inventory_policy : selectedVariant.inventory_policy,
    inventory_management: data?.inventory_management !== undefined ? data.inventory_management : selectedVariant.inventory_management,
    max_qty: data?.max_qty !== undefined ? data.max_qty : selectedVariant.max_qty,
    variants
  };
}

function normalizePantryProductFromAjax(ref, data) {
  const selectedVariant = Array.isArray(data?.variants)
    ? (data.variants.find((variant) => String(variant.id) === String(ref?.variant_id)) || data.variants.find((variant) => variant.available) || data.variants[0])
    : null;

  const ajaxProduct = {
    id: data?.id || ref?.id,
    title: data?.title || ref?.title || "",
    handle: data?.handle || ref?.handle || ref?.p_handle || "",
    p_handle: data?.handle || ref?.p_handle || ref?.handle || "",
    image: data?.featured_image || data?.images?.[0] || ref?.image || FALLBACK_IMG_Lunch,
    price: selectedVariant?.price ? formatPantryCentsPrice(selectedVariant.price) : ref?.price,
    tags: Array.isArray(ref?.tags) ? ref.tags : [],
    variant_id: selectedVariant?.id || ref?.variant_id,
    available: selectedVariant?.available,
    variants: Array.isArray(data?.variants)
      ? data.variants.map((variant) => ({
          variant_id: variant.id,
          variant_title: variant.title || variant.public_title || "Default Title",
          variant_price: variant.price ? formatPantryCentsPrice(variant.price) : "0.00",
          available: variant.available,
          inventory_quantity: null,
          inventory_policy: null,
          inventory_management: null,
          max_qty: null
        }))
      : []
  };

  return normalizePantryProductFromResponse(ref, ajaxProduct);
}

async function fetchPantryProductDetails(ref) {
  const handle = getPantryProductHandle(ref);
  if (!handle) return ref;

  if (pantryProductDetailsCache[handle]) {
    return pantryProductDetailsCache[handle];
  }

  try {
    const response = await fetch(`/products/${encodeURIComponent(handle)}?view=pantry-json`, {
      credentials: "same-origin"
    });

    if (!response.ok) throw new Error(`Product view failed for ${handle}`);

    const text = await response.text();
    const data = JSON.parse(text);
    const product = normalizePantryProductFromResponse(ref, data);
    pantryProductDetailsCache[handle] = product;
    return product;
  } catch (error) {
    console.warn("Pantry custom product JSON failed, trying Shopify product JSON", handle, error);
  }

  try {
    const fallbackResponse = await fetch(`/products/${encodeURIComponent(handle)}.js`, {
      credentials: "same-origin"
    });

    if (!fallbackResponse.ok) throw new Error(`Product ajax failed for ${handle}`);

    const data = await fallbackResponse.json();
    const product = normalizePantryProductFromAjax(ref, data);
    pantryProductDetailsCache[handle] = product;
    return product;
  } catch (error) {
    console.warn("Pantry product fetch failed", handle, error);
    return ref;
  }
}

async function hydratePantryProducts(products = []) {
  const settled = await Promise.allSettled(
    products.map((item) => fetchPantryProductDetails(item))
  );

  return settled.map((result, index) => {
    if (result.status === "fulfilled") return result.value;
    console.warn("Pantry item failed to hydrate", products[index], result.reason);
    return products[index];
  }).filter(Boolean);
}

async function hydratePantryCategories(categories = []) {
  return Promise.all((categories || []).map(async (category) => ({
    ...category,
    products: await hydratePantryProducts(category.products || []),
    subcategories: await Promise.all((category.subcategories || []).map(async (subcategory) => ({
      ...subcategory,
      products: await hydratePantryProducts(subcategory.products || [])
    })))
  })));
}

function getPantryStockMax(item) {
  if (item?.max_qty === null || item?.max_qty === undefined || item?.max_qty === "") return null;
  const maxQty = Number(item.max_qty);
  return Number.isFinite(maxQty) ? maxQty : null;
}

function isPantryItemOutOfStock(item) {
  const maxQty = getPantryStockMax(item);
  return item?.available === false || (maxQty !== null && maxQty <= 0);
}

function getPantryStockMessage(item) {
  return isPantryItemOutOfStock(item) ? "Out of stock" : "";
}

function getPantryStockDataAttrs(item) {
  const maxQty = getPantryStockMax(item);
  return `data-available="${item?.available === false ? "false" : "true"}"
          data-inventory-quantity="${item?.inventory_quantity ?? ""}"
          data-inventory-policy="${item?.inventory_policy || ""}"
          data-inventory-management="${item?.inventory_management || ""}"
          data-max-qty="${maxQty === null ? "" : maxQty}"`;
}

function getPantryStockInfoFromWrapper(wrapper) {
  const maxQtyRaw = wrapper?.dataset?.maxQty;
  const maxQty = maxQtyRaw === undefined || maxQtyRaw === "" ? null : Number(maxQtyRaw);
  const inventoryQtyRaw = wrapper?.dataset?.inventoryQuantity;
  const inventoryQty = inventoryQtyRaw === undefined || inventoryQtyRaw === "" ? null : Number(inventoryQtyRaw);
  const available = wrapper?.dataset?.available !== "false";
  const isOutOfStock = !available || (maxQty !== null && maxQty <= 0);

  return {
    available,
    maxQty: Number.isFinite(maxQty) ? maxQty : null,
    inventoryQty: Number.isFinite(inventoryQty) ? inventoryQty : null,
    isOutOfStock
  };
}

function showPantryStockToast(message = "") {
  if (!message) return;

  let toast = document.querySelector(".pantry-stock-toast");
  if (!toast) {
    toast = document.createElement("div");
    toast.className = "pantry-stock-toast";
    toast.setAttribute("role", "status");
    toast.setAttribute("aria-live", "polite");
    document.body.appendChild(toast);
  }

  toast.textContent = message;
  toast.classList.add("show");

  clearTimeout(toast._hideTimer);
  toast._hideTimer = setTimeout(() => {
    toast.classList.remove("show");
  }, 3200);
}

function setPantryStockMessage(wrapper, message = "") {
  const productItem = wrapper?.closest(".pantrycategory-product-li");
  const messageEl = productItem?.querySelector("[data-pantry-stock-message]");

  if (message && message !== "Out of stock") {
    if (messageEl) {
      messageEl.textContent = "";
      messageEl.style.display = "none";
    }
    showPantryStockToast(message);
    return;
  }

  if (!message) {
    const toast = document.querySelector(".pantry-stock-toast");
    if (toast) toast.classList.remove("show");
  }

  if (!messageEl) return;
  messageEl.textContent = message;
  messageEl.style.display = message ? "block" : "none";
}

function applyPantryStockState(wrapper) {
  if (!wrapper) return;
  const stock = getPantryStockInfoFromWrapper(wrapper);
  wrapper.dataset.outOfStock = stock.isOutOfStock ? "true" : "false";

  if (stock.isOutOfStock) {
    setPantryStockMessage(wrapper, "Out of stock");
  }
}

function updatePantryStockDataFromDropdown(wrapper, dataset) {
  if (!wrapper || !dataset) return;

  wrapper.dataset.available = dataset.available || "true";
  wrapper.dataset.inventoryQuantity = dataset.inventoryQuantity || "";
  wrapper.dataset.inventoryPolicy = dataset.inventoryPolicy || "";
  wrapper.dataset.inventoryManagement = dataset.inventoryManagement || "";
  wrapper.dataset.maxQty = dataset.maxQty || "";

  applyPantryStockState(wrapper);
}

function getSelectedPantryQtyAcrossDays(variantId) {
  let total = 0;

  Object.values(selectedTiffins?.days || {}).forEach((dayData) => {
    Object.values(dayData?.pantry || {}).forEach((categoryProducts) => {
      const item = categoryProducts?.[variantId];
      if (item) total += Number(item.quantity || 0);
    });
  });

  return total;
}

function validatePantryInventoryAcrossDays(wrapper, variantId, addQty) {
  const stockInfo = getPantryStockInfoFromWrapper(wrapper);

  if (stockInfo.isOutOfStock) {
    return {
      valid: false,
      message: "Out of stock"
    };
  }

  if (stockInfo.maxQty === null) {
    return {
      valid: true,
      message: ""
    };
  }

  const alreadySelectedQty = getSelectedPantryQtyAcrossDays(variantId);
  const requestedTotalQty = alreadySelectedQty + Number(addQty || 0);

  if (requestedTotalQty > stockInfo.maxQty) {
    const remainingQty = Math.max(stockInfo.maxQty - alreadySelectedQty, 0);

    return {
      valid: false,
      message: remainingQty > 0
        ? `Only ${remainingQty} more can be added for this product`
        : "All available stock is already selected for this product"
    };
  }

  return {
    valid: true,
    message: ""
  };
}

/* =================================================
  RENDER PANTRY PRODUCTS
================================================= */
async function loadPantryProducts(dayObj) {
  const container = document.getElementById("pantryProductContainer");
  container.innerHTML = "";

  if (!dayObj || !dayObj.pantry || !dayObj.pantry.categories) {
    container.innerHTML = `<div class="no-items-message-products">No items available for this day.</div>`;
    return;
  }

  appcontextdata.menuType = 'pantry'
  container.innerHTML = `<div class="no-items-message-products">Loading pantry products...</div>`;

  const categories = await hydratePantryCategories(dayObj.pantry.categories);
  dayObj.pantry.categories = categories;


  let html = `<div class="pantrymainwrapper">`;

  categories.forEach((cat) => {
    if (!cat || (!cat.products?.length && !cat.subcategories?.length)) return;
    const hasProducts = cat.products && cat.products.length > 0;
    // =====================
    // CATEGORY TITLE
    // =====================
    if (cat.title) {
      html += `
        <div class='tiffin-prods-and-title-wrapper pantry-prods-and-title-wrapper' data-target='${cat.title}'>
      <div class='tiffin-accord-title pantry-tiff-type-cat-accord-tittle tiffin-accord-title' data-tiffin-cat="${cat.title}"> 
        <div class="tiffinday-selected-item-headers pantry-tiffday-selected-items"> 
          <div class='title-selected-items pantry-tiffday-title-selected-items'>
            <h3>${cat.title}</h3>
            <div class='selected-item-accordian'>          
                ${
          hasProducts
            ? `
          <span class='tiffinday-cat-accordian'> 
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M4.66675 6.66699L8.00008 10.0003L11.3334 6.66699"
                stroke="#127E51" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
        `
            : ""
        }
            </div>
          </div>
          <span class='tiffinday-selected-items-title pantrytiffin-selected-items-title'
            data-pantry
            data-selectedtitle-day='${dayObj.handle}'
            data-selectedtitle-name='${cat.title.toLowerCase()}'>
          </span>
        </div>
      </div>
      `;
    }

    // =====================
    // MAIN CATEGORY PRODUCTS
    // =====================
    if (cat.products?.length) {
      html += `<ul class="category-prdlist-wrapper pantry-category-prdlists" data-tiffin-cat='${cat.title}'>`;

      cat.products.forEach((item) => {
        html += renderPantryItem(item, cat.title,dayObj);
        setTimeout(() => {
       restorePantryPrices(cat.title,dayObj.handle,item.variant_id)   
        }, 2000);
      });

      html += `</ul> </div>`;
    }

    // =====================
    // SUBCATEGORIES
    // =====================
    cat.subcategories?.forEach((sub) => {
      if (!sub || !sub.products?.length) return;

      // Subcategory title
      if (sub.title) {
        html += `
        <div class='tiffin-prods-and-title-wrapper pantry-prods-and-title-wrapper' data-target='${sub.title}'>
        <div class='tiffin-accord-title pantry-tiff-type-cat-accord-tittle tiffin-accord-title'  data-tiffin-cat="${sub.title}"> 
          <div class="tiffinday-selected-item-headers pantry-tiffday-selected-items"> 
            <div class='title-selected-items pantry-tiffday-title-selected-items'>
              <h3>${sub.title}</h3>
              <div class='selected-item-accordian'>          
                <span class='tiffinday-cat-accordian'> 
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M4.66675 6.66699L8.00008 10.0003L11.3334 6.66699"
                      stroke="#127E51" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </span>
              </div>
            </div>
            <span class='tiffinday-selected-items-title pantrytiffin-selected-items-title'
              data-pantry
              data-selectedtitle-day='${dayObj.handle}'
              data-selectedtitle-name='${sub.title.toLowerCase()}'>
            </span>
          </div>
        </div>
        `;
      }

      // Subcategory products
      html += `<ul class="category-prdlist-wrapper pantry-category-prdlists" data-tiffin-cat='${sub.title}'>`;

      sub.products.forEach((item) => {
        html += renderPantryItem(item, sub.title || cat.title,dayObj);
        setTimeout(() => {
       restorePantryPrices(sub.title || cat.title,dayObj.handle,item.variant_id)   
        }, 2000);

      });



      html += `</ul> </div>`;
    });
  });

  html += `</div>`;
  container.innerHTML = html;
  document.querySelectorAll(".pantry-addto-cart").forEach(applyPantryStockState);
  pageLoaderChange()
    toggleNextDayButton(dayObj)
  renderPantrySidebar(categories)
  restorePantryData(dayObj.handle)

}


/* =================================================
  RENDER SINGLE PANTRY PRODUCT
================================================= */
function renderPantryItem(item, categoryName,dayObj) {
  return `
    <li class="category-product-detail pantrycategory-product-li"
      data-category-name="${categoryName.toLowerCase() || ''}"
      data-day-name='${dayObj.handle}'
      data-tags-list="${item.tags?.length > 0 ? item.tags.join(', ') : ''}"
      data-prod-real-id='${item.variant_id}'
       data-product-handle="${item.p_handle}"
      data-prod-name="${item.title}">

      <div class='category-prod-wrapper pantry-prod-wrapper'>
      <div class='category-prod-img-wrapper pantry-prod-img-wrapper'> 
      <div class='category-prod-img pantry-prod-img'>
          <img class='pantry-prod-img-main' src="${item.image || FALLBACK_IMG_Lunch}" alt="${item.title || ''}" />
           
        </div>
      <div class="addtocart-lunchpantry pantry-addto-cart"
          ${getPantryStockDataAttrs(item)}
          data-day-name="${dayObj.handle}"
          data-prod-title="${item.title}"
           data-prod-price="${item.price}"
           data-category-name="${categoryName.toLowerCase() || ''}"
              data-prod-date='${item.computedDate}'
              data-prod-img='${item.image}'
              data-main-prodid ='${item.variant_id}'
            data-prod-variant="${item.variant_id || ''}">

            <span class="lunchpantry-plusicon-main pantry-plus-icon-main lunch-plus-icon">+</span>
            <div class='lunchpantryquanitity-selector pantry-quantity-selector hidden'>
               <span class='lunchpantryminus-icon-wrap pantry-mius-icon-wrap'>
                 <span class='prod-dlt-icon pantry-delete-icon '> 
                   <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.5 3H3M13.5 3H3M4 1C6.34315 1 7.65685 1 10 1M3 3V13.5H11V3" stroke="#202020" stroke-width="1.1"></path>
                  </svg>
              </span>
              <span class='prod-minus-icon pantry-minus-icon hidden'>-</span>
            </span>
            <input class='prod-input-main pantry-prod-input' readonly  min='1' value='1'/>
            <span class='prod-plus-icon pantry-plus-icon'>
            plus
            </span>
          </div>
       </div>
           <div class="tiffindays-tags-container tiffindays-tags-container-main">
  ${Array.isArray(item.tags)
    ? item.tags
        .slice(0, 3)
        .map((t, i) =>
          `<span class="tiffin-day-tags tiffin-prod-tags-${i + 1} diet-tag" data-tag='${t.toLowerCase()}'>${t}</span>`
        )
        .join("")
    : ""}
</div>
         <span class="icon-hoveer-description icon-hover-pantry-desc">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
               <path d="M11.9999 21.594C17.3024 21.594 21.5999 17.2965 21.5999 11.994C21.5999 6.69154 17.3024 2.39404 11.9999 2.39404C6.6974 2.39404 2.3999 6.69154 2.3999 11.994C2.3999 17.2965 6.6974 21.594 11.9999 21.594ZM10.7999 8.39404C10.7999 7.73029 11.3362 7.19404 11.9999 7.19404C12.6637 7.19404 13.1999 7.73029 13.1999 8.39404C13.1999 9.05779 12.6637 9.59404 11.9999 9.59404C11.3362 9.59404 10.7999 9.05779 10.7999 8.39404ZM10.4999 10.794H12.2999C12.7987 10.794 13.1999 11.1953 13.1999 11.694V14.994H13.4999C13.9987 14.994 14.3999 15.3953 14.3999 15.894C14.3999 16.3928 13.9987 16.794 13.4999 16.794H10.4999C10.0012 16.794 9.5999 16.3928 9.5999 15.894C9.5999 15.3953 10.0012 14.994 10.4999 14.994H11.3999V12.594H10.4999C10.0012 12.594 9.5999 12.1928 9.5999 11.694C9.5999 11.1953 10.0012 10.794 10.4999 10.794Z" fill="white"></path>
              </svg>
            </span>
      </div>
        
        <div class="category-prod-content pantry-prod-content">
          <div class="pantry-card-meta-row">
            ${item.vendor ? `<span class='category-prod-vendor'>${item.vendor}</span>` : `<span class='category-prod-vendor'></span>`}

            <div class="category-prod-wtprice pantry-card-price-row">
              ${
                item.variants && item.variants.length > 1
                  ? `
                  <div class="pantry-custom-dropdown" data-product-id="${item.id}">
                    <div class='dropdown-selected-wrapper'>
                      <div class="dropdown-selected">
                        ${item.variants.find(v => v.variant_id == item.variant_id)?.variant_title || ''}
                      </div>
                      <span class='pantry-dropdown-chev'>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path d="M4.66675 6.66699L8.00008 10.0003L11.3334 6.66699" stroke="#127E51" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                      </span>
                    </div>

                    <div class="dropdown-options">
                      ${item.variants.map(variant => `
                        <div 
                          class="dropdown-item ${variant.variant_id == item.variant_id ? 'active' : ''}"
                          data-day-name='${dayObj.handle}'
                          data-variant-id="${variant.variant_id}"
                          data-variant-title='${variant.variant_title}'
                          data-price="${variant.variant_price}"
                          ${getPantryStockDataAttrs(variant)}
                        >
                          ${variant.variant_title}
                        </div>
                      `).join('')}
                    </div>
                  </div>

                  <span class="category-prod-price pantry-prod-finalprice">$${item.price}</span>
                  `
                  : `
                  <span class="category-prod-price pantry-prod-finalprice">$${item.price}</span>
                  `
              }

              ${item.weight_value ? `
                <div class="pantry-custom-dropdown pantry-weight-display" data-product-id="${item.id}">
                  <div class="dropdown-selected-wrapper">
                    <div class="dropdown-selected">${item.weight_value}</div>
                  </div>
                </div>
              ` : ''}
            </div>
          </div>

          <div class='category-prod-desc-content pantry-desc-content'>
            <span class="category-prod-title pantry-prod-title">${item.title || ''}</span>
          </div>

          <span class="pantry-stock-message" data-pantry-stock-message style="${getPantryStockMessage(item) ? '' : 'display:none;'}">${getPantryStockMessage(item)}</span>
        </div>
      </div>
    </li>
  `;
}


document.addEventListener("click", function (e) {
  const dropdown = e.target.closest(".pantry-custom-dropdown");

  document.querySelectorAll(".pantry-custom-dropdown").forEach(el => {
    if (el !== dropdown) {
      el.classList.remove("opened");
      const opts = el.querySelector(".dropdown-options");
      if (opts) opts.style.display = "none";
    }
  });

  if (!dropdown) return;

  const options = dropdown.querySelector(".dropdown-options");
  if (!options) return;

  const isVisible = dropdown.classList.contains("opened");

  dropdown.classList.toggle("opened", !isVisible);
  options.style.display = isVisible ? "none" : "block";
});



document.addEventListener("click", function (e) {
  if (!e.target.classList.contains("dropdown-item")) return;

  const itemEl = e.target;
  const dropdown = itemEl.closest(".pantry-custom-dropdown");
  const wrapper = dropdown.closest(".pantrycategory-product-li");
  const addtobuttonpantry = wrapper.querySelector(".pantry-addto-cart");
  const pantryplusicon = addtobuttonpantry.querySelector('.pantry-plus-icon-main');
  const pantryquantitySelectorAll = document.querySelectorAll('.pantry-quantity-selector');
  const pantrymainPlusIconAll = document.querySelectorAll('.pantry-plus-icon-main ');

  const price = itemEl.dataset.price;
  const variantId = itemEl.dataset.variantId;
  const variantTitle = itemEl.dataset.variantTitle;
  const dayKey = itemEl.dataset.dayName;

  if(pantryquantitySelectorAll)
  { 
    pantryquantitySelectorAll.forEach(element => {
      element.classList.add('hidden')
    });
  }

   if(pantrymainPlusIconAll)
  { 
    pantrymainPlusIconAll.forEach(element => {
      element.classList.remove('hidden');

    });
  }
     document
      .querySelectorAll(`.pantry-addto-cart[data-day-name="${dayKey}"]`)
      .forEach((btn) => {
        const mainBtn = btn.querySelector(".pantry-plus-icon-main");
        const qtySelector = btn.querySelector(".pantry-quantity-selector");
        const btnVariantId = btn.dataset.prodVariant;

        mainBtn?.classList.remove("hidden");
        qtySelector?.classList.add("hidden");

        let matchedProduct = null;

        Object.values(selectedTiffins.days[dayKey]?.pantry || {}).forEach((categoryProducts) => {
          if (categoryProducts?.[btnVariantId]) {
            matchedProduct = categoryProducts[btnVariantId];
          }
        });

        if (mainBtn) {
          mainBtn.textContent = matchedProduct ? matchedProduct.quantity : "+";
        }
      });



  dropdown.querySelector(".dropdown-selected").textContent = itemEl.textContent;
  wrapper.querySelector(".pantry-prod-finalprice").textContent = `$${price}`;

  dropdown.querySelectorAll(".dropdown-item").forEach(el => el.classList.remove("active"));
  itemEl.classList.add("active");

  dropdown.dataset.selectedVariantId = variantId;

  if (addtobuttonpantry) {
    addtobuttonpantry.setAttribute("data-prod-variant", variantId);
    addtobuttonpantry.setAttribute("data-variant-title", variantTitle);
        addtobuttonpantry.setAttribute("data-prod-price", price);
    updatePantryStockDataFromDropdown(addtobuttonpantry, itemEl.dataset);


  }

  // check pantry item quantity
  const currentDay = selectedTiffins.currentDay;
  const categoryName = wrapper.dataset.categoryName; 
  // example: data-category="Pasta & Noodles"

  const pantryItem = selectedTiffins?.days?.[currentDay]?.pantry?.[categoryName]?.[variantId];
  if (pantryItem && pantryItem.quantity > 0) {
  if(pantryplusicon) pantryplusicon.textContent = pantryItem.quantity
  } else {
      if(pantryplusicon) pantryplusicon.textContent = '+'
  }

  dropdown.querySelector(".dropdown-options").style.display = "none";
      // if(dropdown) dropdown.classList.toggle('opened')

});







function waitForElement(selector, callback) {
  const el = document.querySelector(selector);
  if (el) return callback(el);

  const observer = new MutationObserver(() => {
    const el = document.querySelector(selector);
    if (el) {
      observer.disconnect();
      callback(el);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}


function getDataSetInformation(wrapper) {
  return {
    dayKey: wrapper.dataset.dayName,
    variantId: wrapper.dataset.prodVariant,
    img: wrapper.dataset.prodImg,
    title: wrapper?.dataset.prodTitle || "",
    price: wrapper?.dataset.prodPrice || 0,
    category: wrapper.dataset.categoryName || "general", 
    qtyInput: null,
    varianttitle : wrapper.dataset.variantTitle || '',
    mainvariant : wrapper.dataset.mainProdid || ''
  };
}



function closeMobileMenu()
{ 
  
  const menuClose = document.querySelector('.t4s-drawer-menu__close');
  if(menuClose) menuClose.click()
}


// update header function
function updatePantryHeader(day, cat,variant ,fromdelete ) {
  const wrapper = document.querySelector(
    `.pantry-prods-and-title-wrapper[data-target="${cat}"]`
  );

  if (!wrapper) return;
  const header = wrapper.querySelector(
    `.pantrytiffin-selected-items-title[data-selectedtitle-day="${day}"][data-selectedtitle-name="${cat}"]`
  );

  if (!header) return;

  const pantryData = selectedTiffins?.days?.[day]?.pantry?.[cat] || {};
  const titles = Object.values(pantryData)
    .map(item => item.title)
    .filter(Boolean);

  header.innerHTML = titles.length ? titles.join(", ") : "";

  const pantryaddtocartwrapper = document.querySelector(`.pantry-addto-cart[data-day-name='${day}'][data-category-name='${cat}'][data-prod-variant='${variant}']`);
  if(pantryaddtocartwrapper && fromdelete)
  { 
    const inputpantry = pantryaddtocartwrapper.querySelector('.pantry-prod-input');
    if(inputpantry)  inputpantry.value=1;
  }
}

function attachSidebarEvents() {
  const mainItems = document.querySelectorAll(".sidebar-main");
  const allItems = document.querySelectorAll(".sidebar-cat-name");
  const lunchMobileSidebar = document.querySelectorAll('.lunch-sidebar-text')
  mainItems.forEach(item => {
    item.addEventListener("click", () => {

      const parent = item.closest(".sidebar-group");
      const subWrapper = parent.querySelector(".sidebar-sub-wrapper");
      const arrow = item.querySelector(".arrow");

      const isOpen = parent.classList.contains("open");

      // CLOSE ALL
      document.querySelectorAll(".sidebar-group").forEach(g => {
        g.classList.remove("open");

        const sub = g.querySelector(".sidebar-sub-wrapper");
        const arr = g.querySelector(".arrow");

        if (sub) sub.style.display = "none";
        if (arr) arr.classList.remove("rotate");
      });

      // OPEN CURRENT (toggle)
      if (!isOpen) {
        parent.classList.add("open");

        if (subWrapper) subWrapper.style.display = "block";
        if (arrow) arrow.classList.add("rotate");
      }

      // ACTIVE STATE
      allItems.forEach(i => i.classList.remove("active"));
      closeMobileMenu()
      item.classList.add("active");
      scrollToSection(item.dataset.target);
    });
  });



  // SUBCATEGORY CLICK
  document.querySelectorAll(".sidebar-sub").forEach(item => {
    item.addEventListener("click", (e) => {
      e.stopPropagation();

      allItems.forEach(i => i.classList.remove("active"));
      item.classList.add("active");

      scrollToSection(item.dataset.target);
    });
  });

    // LUNCH MOBILE SIDEBAR ITEMS
  lunchMobileSidebar.forEach((item) => {
    item.addEventListener("click", () => {
      allItems.forEach((i) => i.classList.remove("active"));
      item.classList.add("active");

      closeMobileMenu();
      scrollToSection(item.dataset.target);
    });
  });
}

function scrollToSection(targetId) {
  const target = document.querySelector(
    `.tiffin-prods-and-title-wrapper[data-target="${targetId}"]`
  );

  if (target) {
    target.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }
}









// find product detail to show on popup / on cart summary
function findProductDetails(productId, dayHandle, category, type) {

  const dayObj = getDayObjByHandle(dayHandle);
  if (!dayObj) return null;

  const id = Number(productId);

  // Map "ala" → "ala_carte"
  const typeMap = {
    main_tiffin: "main_tiffin",
    ala: "ala_carte",
    pantry: "pantry",
    lunch:'lunch'
  };

  const actualType = typeMap[type];
  if (!actualType) return null;

  // ===========================
  // PANTRY (direct array)
  // ===========================
if (actualType === "pantry") {
  const categories = dayObj.pantry?.categories || [];

  for (const cat of categories) {

    // MAIN PRODUCTS
    if (cat.products?.length) {
      const found = cat.products.find(
        p => p.id === id || p.variant_id === id
      );
      if (found) return found;
    }

    // SUBCATEGORIES
    if (cat.subcategories?.length) {
      for (const sub of cat.subcategories) {
        const found = sub.products?.find(
          p => p.id === id || p.variant_id === id
        );
        if (found) return found;
      }
    }
  }

  return null;
}


  // ===========================
  // PANTRY (direct array)
  // ===========================
if (actualType === "lunch") {
  const categories = dayObj.lunch?.categories || [];

  for (const cat of categories) {

    // MAIN PRODUCTS
    if (cat.products?.length) {
      const found = cat.products.find(
        p => p.id === id || p.variant_id === id
      );
      if (found) return found;
    }
  }

  return null;
}

  // ===========================
  // MAIN TIFFIN / ALA CARTE
  // ===========================
  const typeObj = dayObj[actualType];
  if (!typeObj) return null;

  const productList = typeObj[category];
  if (!Array.isArray(productList)) return null;

  return productList.find(
    p => p.id === id || p.variant_id === id
  ) || null;
}






document.addEventListener('click',function(e){ 
  if(e.target.closest('.popupdata-close-icon'))
  { 
    closePopup()
  }
})



/* =================================================
   CALENDAR CLICK
================================================= */

document.addEventListener("click", function (e) {
  const btn = e.target.closest(".tiffin-calendar-day-btn");
  if (!btn) return;
  const clickedDay = btn.dataset.day;
  const clickeddaytype = btn.dataset.tiffinType
  // Update UI active state
  document
    .querySelectorAll(".tiffin-calendar-day-btn")
    .forEach(b => b.classList.remove("active-day"));
  btn.classList.add("active-day");
  window.activeDaysData.activeDay = clickedDay;
  renderProductData(clickeddaytype);
  updateNavigationButtons(); 
});

/* =================================================
   TYPE BUTTON  CLICK
================================================= */

document.querySelectorAll('.order-tiffin-type-btn').forEach(button => {
  button.addEventListener('click', function() {
    const value = this.getAttribute('data-value');
    const alacontainer = document.getElementById("alaProductContainer");
    const maincontainer = document.getElementById("mainProductContainer");
    document.querySelectorAll('.order-tiffin-type-btn').forEach(button => {
      button.classList.remove('active')
    })
       renderProductData(value) 
  });
});


document.addEventListener("click", function (e) {
  // 1. Icon hover description popup (FIRST priority)
  const prodEl = e.target.closest(".icon-hover-main-desc");
  if (prodEl) {
     e.stopPropagation(); 
       e.preventDefault(); 
    const prodEli = prodEl.closest('.category-product-detail');
    const dayDate = prodEli.getAttribute("data-day");
    const category = prodEli.getAttribute("data-main-category");
    const productId = prodEli.querySelector(".maintiffin-products-select").id.split("-")[2];
    const extrapriceEl = prodEli.querySelector('.product-price-threshold');
    const extraprice = extrapriceEl.getAttribute('data-threshold-diff');
    const productHandle = prodEli.dataset.productHandle;
    openProductPopup(productId, dayDate, category, 'main_tiffin',extraprice,productHandle);
    return; // stop here so other handlers don't run
  } else { 
 // 2. Maintiffin add-to-cart (SECOND priority)
  if (e.target.classList.contains("maintiffin-products-select")) {
    closePopup();
    handleProductSelect(e, e.target.getAttribute('data-category-name'));
    return;
  }
  }
});



if(addanothertiffinButton) addanothertiffinButton.addEventListener("click", addAnotherTiffin);


// function to close popup
function closePopup()
{ 
const desktoppopupholder = document.querySelector('.desktop-product-popup-holder');
  desktoppopupholder.innerHTML = '';
if(isMobile)
{ 
  document.querySelectorAll('.cart-summary-popover-info').forEach(d => d.style.display='block');
   document.body.classList.toggle('mobile-cart-summary');
    document.body.classList.remove('popup-description')
     document.body.classList.add('popup-validation');
} else { 
document.querySelectorAll('.cart-summary-popover-info').forEach(d => d.style.display='block');

}
}

/* =================================================
  Ala Carte button click - Event Delegation
================================================= */
document.addEventListener("click", function (e) {

  const addBtn = e.target.closest(".ala-addto-cart");
  if (addBtn) {
    const wrapper = addBtn.closest(".ala-cart-quanity-wrapper");
    if (!wrapper) return;
    addAddonProduct(wrapper);
    return;
  }

  const plusBtn = e.target.closest(".plus-quantity-selector-ala");
  if (plusBtn) {
    const wrapper = plusBtn.closest(".ala-cart-quanity-wrapper");
    if (!wrapper) return;
    increaseAddonQty(wrapper);
    return;
  }

  const minusBtn = e.target.closest(".minus-quanity-minus-ala");
  if (minusBtn) {
    const wrapper = minusBtn.closest(".ala-cart-quanity-wrapper");
    if (!wrapper) return;
    decreaseAddonQty(wrapper);
    return;
  }

  const deleteBtn = e.target.closest(".minus-quantity-remove");
  if (deleteBtn) {
    const wrapper = deleteBtn.closest(".ala-cart-quanity-wrapper");
    if (!wrapper) return;
    decreaseAddonQty(wrapper);
    return;
  }

});


document.addEventListener("click", function (e) {
  const prodEl = e.target.closest(".alacarte-prod-img-main");
  if (!prodEl) return;
  const prodEli = prodEl.closest('.category-product-detail')
  const dayDate = prodEli.getAttribute("data-date-name");
  const category = prodEli.getAttribute("data-addon-category");
  const productinput = prodEli.querySelector("input");
  const productId = productinput.getAttribute('data-prod-real-id');
  const productHandle = prodEli.dataset.productHandle;
  openProductPopup(productId, dayDate, category,'ala',0,productHandle);
});

document.addEventListener("click", function (e) {
  const prodEl = e.target.closest(".icon-hover-alacarte");
  if (!prodEl) return;
  const prodEli = prodEl.closest('.category-product-detail')
  const dayDate = prodEli.getAttribute("data-date-name");
  const category = prodEli.getAttribute("data-addon-category");
  const productinput = prodEli.querySelector("input");
  const productId = productinput.getAttribute('data-prod-real-id');
  const productHandle = prodEli.dataset.productHandle;
  openProductPopup(productId, dayDate, category,'ala',0,productHandle);
});

document.addEventListener("click", function (e) {
  const prodEl = e.target.closest(".pantry-prod-img-main");
  if (!prodEl) return;
  const prodEli = prodEl.closest('.category-product-detail')
  const dayDate = prodEli.getAttribute("data-day-name");
  const category = prodEli.getAttribute("data-category-name");
  const productId = prodEli.getAttribute('data-prod-real-id');
  const productHandle = prodEli.dataset.productHandle;
  openProductPopup(productId, dayDate, category,'pantry',0,productHandle);
});

document.addEventListener("click", function (e) {
  const prodEl = e.target.closest(".icon-hover-pantry-desc");
  if (!prodEl) return;
  const prodEli = prodEl.closest('.category-product-detail')
  const dayDate = prodEli.getAttribute("data-day-name");
  const category = prodEli.getAttribute("data-category-name");
  const productId = prodEli.getAttribute('data-prod-real-id');
  const productHandle = prodEli.dataset.productHandle;
  openProductPopup(productId, dayDate, category,'pantry',0,productHandle);
});

document.addEventListener("click", function (e) {
  const prodEl = e.target.closest(".icon-hover-lunch-desc");
  if (!prodEl) return;
  const prodEli = prodEl.closest('.category-product-detail')
  const dayDate = prodEli.getAttribute("data-day-name");
  const category = prodEli.getAttribute("data-category-name");
  const productId = prodEli.getAttribute('data-prod-real-id');
  const productHandle = prodEli.dataset.productHandle;
  openProductPopup(productId, dayDate, category,'lunch',0,productHandle);
});
document.addEventListener("click", function (e) {
  const prodEl = e.target.closest(".lunch-prod-img-main");
  if (!prodEl) return;
  const prodEli = prodEl.closest('.category-product-detail')
  const dayDate = prodEli.getAttribute("data-day-name");
  const category = prodEli.getAttribute("data-category-name");
  const productId = prodEli.getAttribute('data-prod-real-id')
    const productHandle = prodEli.dataset.productHandle;
  openProductPopup(productId, dayDate, category,'lunch',0,productHandle);
});


/* =================================================
 Pantry button click - Event Delegation

================================================= */

document.addEventListener("click", function (e) {

  const wrapper = e.target.closest(".pantry-addto-cart");
  if (!wrapper) return;

  if (e.target.closest(".pantry-plus-icon-main")) {
    addPantryProduct(wrapper,true);
  }

  if (e.target.closest(".pantry-plus-icon")) {
    addPantryProduct(wrapper);
  }

 
  if (e.target.closest(".pantry-minus-icon")) {
    decreasePantryProduct(wrapper);
  }

  if (e.target.closest(".pantry-delete-icon")) {
    decreasePantryProduct(wrapper);
  }
});



function updatePantryUI(dayKey, category, variantId,mainvariant) {
  const pantryAddtoCartWrapper = document.querySelector(
    `.pantry-addto-cart[data-day-name='${dayKey}'][data-category-name='${category}'][data-prod-variant='${variantId}']`
  );

   const pantryAddtoCartWrapperforHeader = document.querySelector(
    `.pantry-addto-cart[data-day-name='${dayKey}'][data-category-name='${category}'][data-prod-variant='${mainvariant}']`
  );


  if (!pantryAddtoCartWrapper) return;

  const mainAllproductWrapper = pantryAddtoCartWrapper.closest(".pantry-prods-and-title-wrapper");
    const mainAllproductWrapperHeader = pantryAddtoCartWrapper.closest(".pantry-prods-and-title-wrapper");
 
  if (!mainAllproductWrapper) return;

  const quantitySelectorWrapper = pantryAddtoCartWrapper.querySelector(".pantry-quantity-selector");
  const minusIcon = pantryAddtoCartWrapper.querySelector(".pantry-minus-icon");
  const deleteIcon = pantryAddtoCartWrapper.querySelector(".pantry-delete-icon");
  const plusIcon = pantryAddtoCartWrapper.querySelector(".pantry-plus-icon-main");
  const header = mainAllproductWrapperHeader.querySelector(".pantrytiffin-selected-items-title");
  const inputfield = pantryAddtoCartWrapper.querySelector('.pantry-prod-input')

  const item = selectedTiffins?.days?.[dayKey]?.pantry?.[category]?.[variantId];

  if (!item) {
    if (quantitySelectorWrapper) quantitySelectorWrapper.classList.add("hidden");
    if (plusIcon) { 
      plusIcon.textContent='+'
      plusIcon.classList.remove("hidden");
    } 

    if (header) {
      const pantryData = selectedTiffins?.days?.[dayKey]?.pantry?.[category] || {};
      const titles = Object.values(pantryData).map(item => item.title).filter(Boolean);
      header.innerHTML = titles.length ? titles.join(", ") : "";
    }

    return;
  }
   if(inputfield) inputfield.value = item.quantity;
  if (quantitySelectorWrapper) quantitySelectorWrapper.classList.remove("hidden");
  if (plusIcon) plusIcon.classList.add("hidden");

  if (item.quantity > 1) {
    if (minusIcon) minusIcon.classList.remove("hidden");
    if (deleteIcon) deleteIcon.classList.add("hidden");
  } else {
    if (minusIcon) minusIcon.classList.add("hidden");
    if (deleteIcon) deleteIcon.classList.remove("hidden");
  }

  if (header) {
    const pantryData = selectedTiffins?.days?.[dayKey]?.pantry?.[category] || {};
    const titles = Object.values(pantryData).map(item => item.title).filter(Boolean);
    header.innerHTML = titles.length ? titles.join(", ") : "";
  }
}


function addPantryProduct(wrapper, fromMainplusicon = false) {
  const { dayKey, variantId, img, title, price, category,varianttitle,mainvariant } = getDataSetInformation(wrapper);
  const category_updated = category.toLowerCase()
  if (!dayKey || !variantId || !category) return;

  if (!selectedTiffins.days) {
    selectedTiffins.days = {};
  }

  if (!selectedTiffins.days[dayKey]) {
    selectedTiffins.days[dayKey] = {
      tiffins: {},
      ala: {},
      pantry: {},
      lunch: {}
    };
  }
const product_variant_title = varianttitle ? `${title} - ${varianttitle}` : title;


  if (!selectedTiffins.days[dayKey].pantry) {
    selectedTiffins.days[dayKey].pantry = {};
  }

  if (!selectedTiffins.days[dayKey].pantry[category_updated]) {
    selectedTiffins.days[dayKey].pantry[category_updated] = {};
  }

  const pantryItems = selectedTiffins.days[dayKey].pantry[category_updated];
  const existing = pantryItems[variantId];
  const addQty = existing ? (fromMainplusicon ? 0 : 1) : 1;
  const inventoryCheck = validatePantryInventoryAcrossDays(wrapper, variantId, addQty);

  if (!inventoryCheck.valid) {
    setPantryStockMessage(wrapper, inventoryCheck.message);
    return;
  }

  setPantryStockMessage(wrapper, "");

  let quantity = 1;

  if (existing) {
    if (fromMainplusicon) {
      quantity = existing.quantity;
    } else {
      existing.quantity += 1;
      quantity = existing.quantity;
    }
  } else {
    pantryItems[variantId] = {
       title : product_variant_title,
      price,
      img,
      quantity: 1,
      variantId,
      mainvariant
    };
    quantity = 1;
  }

  if (fromMainplusicon) {
    document
      .querySelectorAll(`.pantry-addto-cart[data-day-name="${dayKey}"]`)
      .forEach((btn) => {
        const mainBtn = btn.querySelector(".pantry-plus-icon-main");
        const qtySelector = btn.querySelector(".pantry-quantity-selector");
        const btnVariantId = btn.dataset.prodVariant;

        mainBtn?.classList.remove("hidden");
        qtySelector?.classList.add("hidden");

        let matchedProduct = null;

        Object.values(selectedTiffins.days[dayKey].pantry || {}).forEach((categoryProducts) => {
          if (categoryProducts?.[btnVariantId]) {
            matchedProduct = categoryProducts[btnVariantId];
          }
        });

        if (mainBtn) {
          mainBtn.textContent = matchedProduct ? matchedProduct.quantity : "+";
        }
      });
  }

  updatePantryUI(dayKey, category_updated, variantId,mainvariant);
  updateTiffinData();
  renderCartSummary("pantry");
  closePopup();
}




function decreasePantryProduct(wrapper) {
  const { dayKey, variantId, category,varianttitle,mainvariant } = getDataSetInformation(wrapper);
  if (!dayKey || !variantId) return;

  const item = selectedTiffins.days?.[dayKey]?.pantry?.[category]?.[variantId];
  if (!item) return;


  if (item.quantity > 1) {
    item.quantity -= 1;
  } else {
    delete selectedTiffins.days[dayKey].pantry[category][variantId];
    if (!Object.keys(selectedTiffins.days[dayKey].pantry[category]).length) {
      delete selectedTiffins.days[dayKey].pantry[category];
    }
  }

  updatePantryUI(dayKey, category, variantId,mainvariant);

  updateTiffinData();
  renderCartSummary("pantry");
}







/* =================================================
 lunch section event listeners
================================================= */

document.addEventListener('click', function (e) {
  const lunchMainAddToCart = e.target.closest('.lunch-plus-icon-main');
  if (lunchMainAddToCart) {
    const addToCartWrapper = lunchMainAddToCart.closest('.lunch-addto-cart');
    if (addToCartWrapper) addlunchProduct(addToCartWrapper,true);
  }

  const lunchPlusQuantitySelector = e.target.closest('.lunch-quantity-plus-icon');
  if (lunchPlusQuantitySelector) {
    const addToCartWrapper = lunchPlusQuantitySelector.closest('.lunch-addto-cart');
    if (addToCartWrapper) addlunchProduct(addToCartWrapper,false);
  }

  const lunchMinusQuantitySelector = e.target.closest('.lunch-quantity-minus-icon');
  if (lunchMinusQuantitySelector) {
    const addToCartWrapper = lunchMinusQuantitySelector.closest('.lunch-addto-cart');
    if (addToCartWrapper) decreaseLunchProduct(addToCartWrapper);
  }

   const lunchDeleteSelector = e.target.closest('.lunch-delete-icon');
  if (lunchDeleteSelector) {
    const addToCartWrapper = lunchDeleteSelector.closest('.lunch-addto-cart');
    if (addToCartWrapper) decreaseLunchProduct(addToCartWrapper);
  }
});



function updateLunchUI(dayKey, category, variantId) {
  const lunchAddtoCartWrapper = document.querySelector(
    `.lunch-addto-cart[data-day-name='${dayKey}'][data-category-name='${category}'][data-prod-variant='${variantId}']`
  );

  if (!lunchAddtoCartWrapper) return;
  const mainAllproductWrapper = lunchAddtoCartWrapper.closest(".lunch-prods-and-title-wrapper");
  if (!mainAllproductWrapper) return;
  const quantitySelectorWrapper = lunchAddtoCartWrapper.querySelector(".lunch-quantity-selector");
  const minusIcon = lunchAddtoCartWrapper.querySelector(".lunch-quantity-minus-icon");
  const deleteIcon = lunchAddtoCartWrapper.querySelector(".lunch-delete-icon");
  const plusIcon = lunchAddtoCartWrapper.querySelector(".lunch-plus-icon-main");
  const header = mainAllproductWrapper.querySelector(".lunchtiffin-selected-items-title");
  const inputfield = lunchAddtoCartWrapper.querySelector('.lunch-prod-input')

  const item = selectedTiffins?.days?.[dayKey]?.lunch?.[category]?.[variantId];

  if (!item) {
    if (quantitySelectorWrapper) quantitySelectorWrapper.classList.add("hidden");
    if (plusIcon) { 
      plusIcon.textContent='+'
      plusIcon.classList.remove("hidden");
    } 

    if (header) {
      const lunchData = selectedTiffins?.days?.[dayKey]?.lunch?.[category] || {};
      const titles = Object.values(lunchData).map(item => item.title).filter(Boolean);
      header.innerHTML = titles.length ? titles.join(", ") : "";
    }

    return;
  }
   if(inputfield) inputfield.value = item.quantity;
  if (quantitySelectorWrapper) quantitySelectorWrapper.classList.remove("hidden");
  if (plusIcon) plusIcon.classList.add("hidden");

  if (item.quantity > 1) {
    if (minusIcon) minusIcon.classList.remove("hidden");
    if (deleteIcon) deleteIcon.classList.add("hidden");
  } else {
    if (minusIcon) minusIcon.classList.add("hidden");
    if (deleteIcon) deleteIcon.classList.remove("hidden");
  }

  if (header) {
    const lunchData = selectedTiffins?.days?.[dayKey]?.lunch?.[category] || {};
    const titles = Object.values(lunchData).map(item => item.title).filter(Boolean);
    header.innerHTML = titles.length ? titles.join(", ") : "";
  }
}



function addlunchProduct(wrapper, fromMainplusicon = false) {
  const { dayKey, variantId, img, title, price, category } = getDataSetInformation(wrapper);
  const inputvalue = wrapper.querySelector('input');

  if (!dayKey || !variantId || !category) return;

  if (!selectedTiffins.days) {
    selectedTiffins.days = {};
  }

  if (!selectedTiffins.days[dayKey]) {
    selectedTiffins.days[dayKey] = {
      tiffins: {},
      ala: {},
      pantry: {},
      lunch: {}
    };
  }

  if (!selectedTiffins.days[dayKey].lunch) {
    selectedTiffins.days[dayKey].lunch = {};
  }

  if (!selectedTiffins.days[dayKey].lunch[category]) {
    selectedTiffins.days[dayKey].lunch[category] = {};
  }

  const lunchItems = selectedTiffins.days[dayKey].lunch[category];
  const existing = lunchItems[variantId];

  let quantity = 1;

  if (existing) {
    if (fromMainplusicon) {
      quantity = existing.quantity;
        inputvalue.value = existing.quantity
    } else {
      existing.quantity += 1;
      quantity = existing.quantity;
    }
  } else {
    lunchItems[variantId] = {
      title,
      price,
      img,
      quantity: 1,
      variantId
    };
    quantity = 1;
  }

  if (fromMainplusicon) {
    document
      .querySelectorAll(`.lunch-addto-cart[data-day-name="${dayKey}"]`)
      .forEach((btn) => {
        const mainBtn = btn.querySelector(".lunch-plus-icon-main");
        const qtySelector = btn.querySelector(".lunch-quantity-selector");
        const btnVariantId = btn.dataset.prodVariant;

        mainBtn?.classList.remove("hidden");
        qtySelector?.classList.add("hidden");

        let matchedProduct = null;

        Object.values(selectedTiffins.days[dayKey].lunch || {}).forEach((categoryProducts) => {
          if (categoryProducts?.[btnVariantId]) {
            matchedProduct = categoryProducts[btnVariantId];
          }
        });

        if (mainBtn) {
          mainBtn.textContent = matchedProduct ? matchedProduct.quantity : "+";
        }
      });
  }

  updateLunchUI(dayKey, category, variantId);
  updateTiffinData();
  renderCartSummary("lunch");
  closePopup();
}



function decreaseLunchProduct(wrapper) {
  const { dayKey, variantId, category } = getDataSetInformation(wrapper);
  if (!dayKey || !variantId) return;

  const item = selectedTiffins.days?.[dayKey]?.lunch?.[category]?.[variantId];
  if (!item) return;

  if (item.quantity > 1) {
    item.quantity -= 1;
  } else {
    delete selectedTiffins.days[dayKey].lunch[category][variantId];
    if (!Object.keys(selectedTiffins.days[dayKey].lunch[category]).length) {
      delete selectedTiffins.days[dayKey].lunch[category];
    }
  }

  updateLunchUI(dayKey, category, variantId);

  updateTiffinData();
  renderCartSummary("lunch");
}


const order_note = document.querySelector('.cart-note-header');
if(order_note)
{ 
  order_note.addEventListener('click',function(){ 
    const order_note_textarea = document.querySelector('.t4s-cart-note__input_custom');
    if(order_note_textarea) order_note_textarea.classList.toggle('hidden')
  })
}


  document.addEventListener("click", function (e) {
    const tiffinday_category_title = e.target.closest(
      ".tiffin-accord-title"
    );
    if (tiffinday_category_title) {
      const cat_title =
        tiffinday_category_title.getAttribute("data-tiffin-cat");
      const tiffinday_mainwrapper = tiffinday_category_title.closest(
        ".tiffin-prods-and-title-wrapper"
      );
      const productlist = tiffinday_mainwrapper.querySelector(
        `.category-prdlist-wrapper[data-tiffin-cat="${cat_title}"]`
      );
     if(productlist) productlist.classList.toggle("hidden");
     if(tiffinday_category_title)  tiffinday_category_title.classList.toggle("accord-active");
    }
  });



document.addEventListener("click", function (e) {
  // NEXT
  if (e.target.closest(".next-tiffin-day")) {
    goToNextDay();
  }

  // PREV
  if (e.target.closest(".tiffin-prev-tiffin-day")) {
    goToPrevDay();
  }

});
document.querySelector(".tiffin-goto-nextday-btn")?.addEventListener("click", goToNextDay);
 

// func
function removeFilterTags()
{ 
  document.querySelectorAll('.category-product-detail').forEach(li => {
      li.style.display = 'block';
    });
    document.querySelectorAll('.tiffin-prods-and-title-wrapper').forEach(w => {
      w.style.display = '';
    });
    document.querySelectorAll('.no-items-message').forEach(m => (m.style.display = 'none'));
    clear_filter_tag.style.display = 'none';
    global_filter_tagsAll.forEach(el => el.classList.remove('active'));
   clear_filter_tag.style.display = 'none';

}



// clear filter logic
if (clear_filter_tag) {
  clear_filter_tag.addEventListener('click', () => {
    removeFilterTags()
  });
}



// filter logic

if (global_filter_tagsAll.length) {
  global_filter_tagsAll.forEach(tag => {
    tag.addEventListener('click', () => {
      global_filter_tagsAll.forEach(el => el.classList.remove('active'));
      tag.classList.add('active');
      if (clear_filter_tag) clear_filter_tag.style.display = 'block';
      const clicked = tag.getAttribute('data-value')?.toLowerCase();

      // show/hide products by tag
      document.querySelectorAll('.category-product-detail').forEach(li => {
        const tags = (li.getAttribute('data-tags-list') || '')
          .toLowerCase()
          .split(',')
          .map(t => t.trim());
        li.style.display = !clicked || tags.includes(clicked) ? '' : 'none';
      });
      const currentDate = selectedTiffins.currentDay;

      // hide wrappers with all children hidden
      document.querySelectorAll('.tiffin-prods-and-title-wrapper').forEach(wrapper => {
        const items = wrapper.querySelectorAll('.category-product-detail');
        const visible = Array.from(items).some(li => li.style.display !== 'none');
        wrapper.style.display = visible ? '' : 'none';
      });

      // check if all wrappers for the visible day are hidden
      const selectedDay = document
        .querySelector('.tiffin-products-daywise-wrapper[style*="display: block"]')
        ?.getAttribute('data-daywise-category');

      if (currentDate) {
        const wrappersForDay = document.querySelectorAll(
          `.tiffin-prods-and-title-wrapper[data-day-name="${currentDate}"]`
        );
        const allHidden = Array.from(wrappersForDay).every(w => w.style.display === 'none');
        let msg = document.querySelector(
          `.no-items-message`
        );
        if (!msg) {
          msg = document.createElement('div');
          msg.className = 'no-items-message';
          msg.textContent = 'No items available';
          msg.style.textAlign = 'center';
          msg.style.padding = '1em';
          msg.style.display = 'none';
          const parent = document.querySelector(`.tiffin-products-daywise-wrapper`);
          if (parent) parent.appendChild(msg);
        }

        msg.style.display = allHidden ? 'block' : 'none';
      }
    });
  });
}




const mobileswipeup = document.querySelector('.mobile-cart-swipe');
const cartSummaryDetails = document.querySelector('.cart-summary-container');
const cartSummaryWrapper = document.querySelector('.cart-summary-wrapper');

if (mobileswipeup) {
  mobileswipeup.addEventListener('click', function (e) {
    e.stopPropagation(); // prevent bubbling to document
    const cartSummaryPopup = document.querySelector('.desktop-product-popup-holder');
    document.body.classList.toggle('mobile-cart-summary');
    document.body.classList.remove('popup-description')
     document.body.classList.add('popup-validation');
    cartSummaryDetails.classList.toggle('cart-summary-swipe');
    if (cartSummaryPopup) cartSummaryPopup.style.display = 'none';
  });
}

if(isMobile)
{ 
  const cartsummarytitle = document.querySelector('.cart-summary-title');

  if (cartsummarytitle) {
  cartsummarytitle.addEventListener('click', function (e) {
    e.stopPropagation(); // prevent bubbling to document
    const cartSummaryPopup = document.querySelector('.desktop-product-popup-holder');
    document.body.classList.toggle('mobile-cart-summary');
    document.body.classList.remove('popup-description')
     document.body.classList.add('popup-validation');
    cartSummaryDetails.classList.toggle('cart-summary-swipe');
    if (cartSummaryPopup) cartSummaryPopup.style.display = 'none';
  });
}
}



document.addEventListener('click', function (e) {
  // use composedPath to capture the full ancestry before removal
  const path = e.composedPath ? e.composedPath() : [];
  const insideCart = path.some(el => el.classList && el.classList.contains('cart-summary-wrapper'));
  const isCartOpen = document.body.classList.contains('mobile-cart-summary');
  const fromdescription_popup = document.body.classList.contains('popup-description');

  if(fromdescription_popup)
  { 
        document.body.classList.add('popup-validation');
         document.body.classList.remove('popup-description');

  }
  const testpopupclass = document.body.classList.contains('popup-validation');

  if (isCartOpen && !insideCart ) {
    if(!fromdescription_popup && testpopupclass){
    document.body.classList.remove('mobile-cart-summary');
    const container = document.querySelector('.cart-summary-container');
    const popupcontainer = document.querySelector('.desktop-product-popup-holder')
    const productcartsummary_container = document.querySelector('.cart-summary-popover-info')
    if (container) container.classList.remove('cart-summary-swipe');
    if(popupcontainer) popupcontainer.style.display='none'
        if(productcartsummary_container) productcartsummary_container.style.display='block'

     }
  }
});


async function cartHasGiftCardProduct() {
  const res = await fetch("/cart.js");

  if (!res.ok) {
    return false;
  }

  const cart = await res.json();

  return cart.items.some((item) => {
    const properties = item.properties || {};

    return (
      properties._gift_card === "true" ||
      properties.gift_card === true ||
      properties.GiftCard === "true" ||
      properties["Gift Card"] === "true"
    );
  });
}



async function getGiftCardItemsFromCart() {
  const res = await fetch("/cart.js");

  if (!res.ok) {
    return [];
  }

  const cart = await res.json();

  return cart.items
    .filter((item) => {
      const properties = item.properties || {};

      return (
        properties._gift_card === "true" ||
        properties.gift_card === true ||
        properties.GiftCard === "true" ||
        properties["Gift Card"] === "true"
      );
    })
    .map((item) => {
      const giftCardItem = {
        id: item.variant_id || item.id,
        quantity: item.quantity,
        properties: item.properties || {
          gift_card: "true",
        },
      };

      if (item.selling_plan_allocation?.selling_plan?.id) {
        giftCardItem.selling_plan = item.selling_plan_allocation.selling_plan.id;
      }

      return giftCardItem;
    });
}



document.addEventListener("click", async (e) => {
  const btn = e.target.closest(".t4s-btn__checkout_button");
  if (!btn) return;
   let warnings = getDayWarnings(selectedTiffins.days);
     if (warnings.length > 0) {
     console.log(warnings); 
      return;
     }
  const loader = document.querySelector(".loading-tiffin-checkout");

  if (loader) loader.classList.remove("hidden");
  btn.setAttribute("disabled", true);

  const californiaTime = new Date().toLocaleString("en-US", {
    timeZone: "America/Los_Angeles",
    hour12: false
  });

  try {
    const { items: newItems, uniqueDays } = buildCartFromLocalStorage(californiaTime);
    const hasGiftCard = await cartHasGiftCardProduct();
  

     if (!newItems.length && hasGiftCard) {
      if (loader) loader.classList.add("hidden");
      btn.removeAttribute("disabled");

      window.location.assign("/checkout");
      return;
    }


     if (!newItems.length && !hasGiftCard) {
      throw new Error("No items to add");
    }

    // 3. set cart attributes
    const updateRes = await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: { Daycount: uniqueDays }
      })
    });

    if (!updateRes.ok) {
      throw new Error("Failed to update cart attributes");
    }

    await updateCartCount();
    await new Promise(resolve => requestAnimationFrame(resolve));
    await new Promise(resolve => setTimeout(resolve, 120));

    if (loader) loader.classList.add("hidden");
    btn.removeAttribute("disabled");

    window.location.assign("/checkout");
  } catch (err) {
    console.error("Cart failed:", err);
    if (loader) loader.classList.add("hidden");
    btn.removeAttribute("disabled");
  }
});

function showCartWarningPopup(warnings) {
  if (!warnings?.length) return;

  document.querySelector(".cart-warning-overlay")?.remove();
  document.body.classList.add("cart-warning-open");
  const html = `
    <div class="cart-warning-overlay">
      <div class="cart-warning-popup">
        <button class="cart-warning-close">×</button>

        <div class="warning-icon">i</div>

        <h3>Almost there!</h3>
        <p class="warning-subtitle">
         Some days need your attention before checkout.
        </p>

        <div class='warning-days-wrapper'>

        <div class="warning-days">
          ${warnings.map(day => `
            <div class="warning-day-card">
              <div class="warning-day-header">
                <strong>${day.dayLabel}</strong>
                <span>${day.issueCount} issue${day.issueCount > 1 ? "s" : ""}</span>
              </div>

              <div class="warning-day-body">
                ${day.dinner?.length ? day.dinner.map(item => `
                  <div class="warning-row error">
                    <span class="warning-dot">!</span>
                    <div>
                      <strong>Dinner (${item.title}):</strong>
                      ${item.message}
                    </div>
                  </div>
                `).join("") : ""}

                ${day.lunch ? `
                  <div class="warning-row error">
                    <span class="warning-dot">!</span>
                    <div>
                      <strong>Lunch:</strong>
                      ${day.lunch.message}
                    </div>
                  </div>
                ` : ""}
              </div>
            </div>
          `).join("")}
        </div>

       <div class="warning-note">
      <div class="warning-note-icon">i</div>

       <div class="warning-note-content">
    <strong>Order requirements</strong>

    <div class="requirement-row">
      <span>Dinner</span>
      <p>Complete each selelcted tiffin with Proteins, Veggies, Sides and  Probiotics. <br>
       Ala Carte only requires $29 minimum.
      </p>
    </div>

    <div class="requirement-row">
      <span>Lunch</span>
      <p>Lunch requires $20 minimum per day.</p>
    </div>
    <div class="requirement-row">
      <span>Pantry</span>
     <p>$29 minimum applies to pantry-only orders.</p>
    </div>
  </div>
</div>
</div>

        <button class="warning-action-btn">Update & Continue</button>
      </div>
    </div>
  `;

  document.body.insertAdjacentHTML("beforeend", html);

  document.querySelector(".cart-warning-close").onclick = () => {
      document.body.classList.remove("cart-warning-open");
    document.querySelector(".cart-warning-overlay")?.remove();
  };

  document.querySelector(".warning-action-btn").onclick = () => {
      document.body.classList.remove("cart-warning-open");
    document.querySelector(".cart-warning-overlay")?.remove();
  };

  document.querySelector(".cart-warning-overlay").onclick = e => {
    if (e.target.classList.contains("cart-warning-overlay")) {
        document.body.classList.remove("cart-warning-open");
      e.target.remove();
    }
  };
}


document.addEventListener("click", async (e) => {
  const btn = e.target.closest(".warning-review-required");
  if (!btn) return;
   let warnings = getDayWarnings(selectedTiffins.days);
   
     if (warnings.length > 0) {
     console.log(warnings);
     showCartWarningPopup(warnings) 
     }

})


let isCheckoutProcessing = false;
//issue prone - kailash

document.addEventListener("click", async function (e) {
  const btn = e.target.closest(".tiffin-add-to-cart");
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  if (isCheckoutProcessing) return;
  isCheckoutProcessing = true;

  const loader = document.querySelector(".loading-tiffin-checkout");

  try {
    // ===========================
    // 1. Check warnings first
    // ===========================
    const warnings = getDayWarnings(selectedTiffins.days || {});

    if (warnings.length > 0) {
      console.log("Cart warnings:", warnings);
      showCartWarningPopup(warnings);
      isCheckoutProcessing = false;
      return;
    }

    // ===========================
    // 2. Disable button / show loader
    // ===========================
    if (loader) loader.classList.remove("hidden");
    btn.setAttribute("disabled", true);

    // Backup local data before touching Shopify cart
    const localBackup = localStorage.getItem("selectedTiffins");

    const californiaTime = new Date().toLocaleString("en-US", {
      timeZone: "America/Los_Angeles",
      hour12: false
    });

    // ===========================
    // 3. Build new cart items first
    // IMPORTANT: do this before clearing cart
    // ===========================
    const { items: newItems, uniqueDays } =
      buildCartFromLocalStorage(californiaTime);

    const giftCardItems = await getGiftCardItemsFromCart();

    const itemsToAdd = [
      ...(newItems || []),
      ...(giftCardItems || [])
    ];

    // ===========================
    // 4. Stop if nothing to add
    // IMPORTANT: cart is not cleared before this
    // ===========================
    if (!itemsToAdd.length) {
      throw new Error("No items to add. Cart was not cleared.");
    }

    console.log("Items ready to add:", itemsToAdd);

    // ===========================
    // 5. Clear old Shopify cart
    // ===========================
    const cleared = await clearCartCompletely();

    if (!cleared) {
      throw new Error("Cart clear failed.");
    }

    // ===========================
    // 6. Add rebuilt items
    // ===========================
    const addRes = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        items: itemsToAdd
      })
    });

    if (!addRes.ok) {
      const errorText = await addRes.text();
      console.error("Cart add failed:", errorText);

      // Restore localStorage UI state
      if (localBackup) {
        localStorage.setItem("selectedTiffins", localBackup);
        selectedTiffins = JSON.parse(localBackup);
        renderCartSummary();
      }

      throw new Error("Failed to add items to cart after clearing.");
    }

    const addedCart = await addRes.json();
    console.log("Cart add success:", addedCart);
    updateCartCount()

    // ===========================
    // 7. Update cart attributes
    // ===========================
    const updateRes = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        attributes: {
          Daycount: uniqueDays
        }
      })
    });

    if (!updateRes.ok) {
      const errorText = await updateRes.text();
      console.error("Cart attribute update failed:", errorText);
      throw new Error("Failed to update cart attributes.");
    }

    // ===========================
    // 8. Sync localStorage only after add succeeds
    // ===========================
    const synced = await syncCartToLocalStorage({
      allowEmptyCartSync: false
    });

    if (synced) {
      selectedTiffins = synced;
      localStorage.setItem("selectedTiffins", JSON.stringify(synced));
    }

    // ===========================
    // 9. Refresh UI
    // ===========================
    renderCartSummary();
    await updateCartCount();

    // Let browser update UI before redirect
    await new Promise(resolve => requestAnimationFrame(resolve));
    await new Promise(resolve => setTimeout(resolve, 120));

    // ===========================
    // 10. Redirect to checkout
    // ===========================
    window.location.assign("/checkout");

  } catch (err) {
    console.error("Cart failed:", err);

    if (loader) loader.classList.add("hidden");
    btn.removeAttribute("disabled");
    isCheckoutProcessing = false;
  }
});


async function clearCartCompletely() {
  await fetch("/cart/clear.js", { method: "POST" });

  let attempts = 0;

  while (attempts < 6) {
    const cart = await fetch("/cart.js").then(res => res.json());

    if (cart.item_count === 0) {
      return true;
    }

    await new Promise(res => setTimeout(res, 200));
    attempts++;
  }

  return false;
}

function getFormattedDateForDay(dayName) {
  const { nextweekday } = window.activeDaysData || {};

  const now = new Date();

  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Los_Angeles",
    year: "numeric",
    month: "numeric",
    day: "numeric",
    weekday: "long"
  }).formatToParts(now);

  const get = (type) => parts.find(p => p.type === type)?.value;

  const year = Number(get("year"));
  const month = Number(get("month")) - 1;
  const day = Number(get("day"));
  const weekday = get("weekday").toLowerCase();

  const today = new Date(year, month, day);

  const dayIndexMap = {
    sunday: 0,
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6
  };

  const currentIndex = dayIndexMap[weekday];
  const targetIndex = dayIndexMap[dayName.toLowerCase()];

  let diff = targetIndex - currentIndex;


if (nextweekday) {
  diff += 7;
}
  const targetDate = new Date(today);
  targetDate.setDate(today.getDate() + diff);

  const formattedDate = targetDate.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });

  return `${formattedDate} | ${dayName.charAt(0).toUpperCase() + dayName.slice(1)}`;
}


function getFormattedDateForDayCheckout(dayName) {
  const { nextweekday } = window.activeDaysData || {};

  const now = new Date();

  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Los_Angeles",
    year: "numeric",
    month: "numeric",
    day: "numeric",
    weekday: "long"
  }).formatToParts(now);

  const get = (type) => parts.find(p => p.type === type)?.value;

  const year = Number(get("year"));
  const month = Number(get("month")) - 1;
  const day = Number(get("day"));
  const weekday = get("weekday").toLowerCase();

  const today = new Date(year, month, day);

  const dayIndexMap = {
    sunday: 0,
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6
  };

  const currentIndex = dayIndexMap[weekday];
  const targetIndex = dayIndexMap[dayName.toLowerCase()];

  let diff = targetIndex - currentIndex;

  // let diff = (targetIndex - currentIndex + 7) % 7;

if (nextweekday) {
  diff += 7;
}
  const targetDate = new Date(today);
  targetDate.setDate(today.getDate() + diff);

  const formattedDate = targetDate.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });

   return formatDateToMDYNumeri(targetDate);
}







function formatDateToMDYNumeri(date) {
  const d = new Date(date);

  const month = d.getMonth() + 1;
  const day = d.getDate();
  const year = d.getFullYear();

  return `${month}/${day}/${year}`;
}

function mergeCartItems(existingCartItems, newItems) {

  // get days from new items
  const newDays = new Set(newItems.map(i => i.properties?._Day || i.properties?.Day));

  // keep only items NOT in newDays
  const filteredExisting = existingCartItems
    .filter(item => {
      const itemDay = item.properties?._Day || item.properties?.Day;
      return !newDays.has(itemDay);
    })
    .map(item => ({
      id: item.variant_id,
      quantity: item.quantity,
      properties: item.properties
    }));

  // merge
  return [...filteredExisting, ...newItems];
}

function dayHasItems(dayObj = {}) {
  const hasTiffins = Object.values(dayObj.tiffins || {}).some(tiffin =>
    Object.values(tiffin || {}).some(item => !!item)
  );

  const hasAla = Object.values(dayObj.ala || {}).some(category =>
    Object.keys(category || {}).length > 0
  );

  const hasPantry = Object.values(dayObj.pantry || {}).some(category =>
    Object.keys(category || {}).length > 0
  );

  const hasLunch = Object.values(dayObj.lunch || {}).some(category =>
    Object.keys(category || {}).length > 0
  );

  return hasTiffins || hasAla || hasPantry || hasLunch;
}

function buildCartFromLocalStorage(californiaTime) {
  const data = JSON.parse(localStorage.getItem("selectedTiffins") || "{}");
  const days = data.days || {};

  const items = [];
  const uniqueDays = new Set();
  const seen = new Set(); 

  Object.entries(days).forEach(([dayKey, dayObj]) => {

    const dayDateYear = getFormattedDateForDayCheckout(dayKey);
    if (dayHasItems(dayObj)) {
      uniqueDays.add(dayKey);
    }
    // uniqueDays.add(dayKey);

    // ===========================
    // MAIN TIFFIN
    // ===========================
    Object.entries(dayObj.tiffins || {}).forEach(([tt, tiffin]) => {
      Object.entries(tiffin || {}).forEach(([cat, item]) => {

        if (!item) return;

        const uniqueKey = `${dayKey}_${tt}_${cat}`;
        if (seen.has(uniqueKey)) return;
        seen.add(uniqueKey);

        items.push({
          id: Number(item.variantId),
          quantity: 1,
          properties: {
            _Day: dayKey,
            Day: dayKey,
            _DayDate: dayDateYear,
            Category: cat, 
            _Type: "main",
            _MainType:"Dinner",
            _fromtestlive:'true',
            _dl : `Dinner${dayKey}`,
            _TiffinPlan: tt,
            _image: item.img,
            _addedtime: californiaTime
          }
        });
      });
    });

    // ===========================
    // ALA
    // ===========================
    Object.entries(dayObj.ala || {}).forEach(([cat, variants]) => {
      Object.entries(variants || {}).forEach(([variantId, item]) => {

        const uniqueKey = `${dayKey}_ala_${variantId}`;
        if (seen.has(uniqueKey)) return;
        seen.add(uniqueKey);

        items.push({
          id: Number(variantId),
          quantity: item.quantity || 1,
          properties: {
            Day: dayKey,
            _Day: dayKey,
            DayDate: dayDateYear,
            Category: cat,
            Type: "addon",
            _MainType:"Dinner",
             _dl : `Dinner${dayKey}`,
            _addedtime: californiaTime
          }
        });
      });
    });

    // ===========================
    // PANTRY
    // ===========================
    Object.entries(dayObj.pantry || {}).forEach(([cat, variants]) => {
      Object.entries(variants || {}).forEach(([variantId, item]) => {

        const uniqueKey = `${dayKey}_pantry_${variantId}`;
        if (seen.has(uniqueKey)) return;
        seen.add(uniqueKey);

        items.push({
          id: Number(variantId),
          quantity: item.quantity || 1,
          properties: {
            Day: dayKey,
            _Day: dayKey,
            DayDate: dayDateYear,
             _dl : `Pantry${dayKey}`,
            Category:  cat,
            Type: "pantry",
             _MainType:"Pantry",
            _mainvariant:item.mainvariant ? item.mainvariant : '',
            _addedtime: californiaTime
          }
        });
      });
    });

      // ===========================
    // lunch
    // ===========================
    Object.entries(dayObj.lunch || {}).forEach(([cat, variants]) => {
      Object.entries(variants || {}).forEach(([variantId, item]) => {

        const uniqueKey = `${dayKey}_lunch_${variantId}`;
        if (seen.has(uniqueKey)) return;
        seen.add(uniqueKey);

        items.push({
          id: Number(variantId),
          quantity: item.quantity || 1,
          properties: {
            Day: dayKey,
            _Day: dayKey,
            DayDate: dayDateYear,
            Category:  cat,
             _dl : `Lunch${dayKey}`,
            Type: "lunch",
             _MainType:"Lunch",
            _addedtime: californiaTime
          }
        });
      });
    });

  });

  return { items, uniqueDays: uniqueDays.size };
}


// async function syncCartToLocalStorage() {
//   try {
//     const cart = await fetch("/cart.js").then(res => res.json());

//     const priceInfo = window.priceThresholdsAndTitles || {};

//     // const selectedTiffins = {
//     //   days: {},
//     //   currentDay: null,
//     //   currentTiffinSize: 1
//     // };

//     cart.items.forEach((item ,index) => {
//       const props = item.properties || {};
//      const cartKey = item.key; 
//        const cartLine = index + 1;
//       const day = (props._Day || props.Day || "").toLowerCase();
//       if (!day) return;

//       // ===========================
//       // INIT DAY
//       // ===========================
//       if (!selectedTiffins.days[day]) {
//         selectedTiffins.days[day] = {
//           dayName: day,
//           tiffins: {},
//           ala: {},
//           pantry: {},
//           lunch:{}
//         };
//       }


//       // ===========================
//       // MAIN TIFFIN (BUNDLE)
//       // ===========================
//       if (props._TiffinPlan && props._components) {

//         const tiffinNo = props._TiffinPlan;

//         let components = [];
//         try {
//           components = JSON.parse(props._components || "[]");
//         } catch (e) {
//           console.warn("Invalid components JSON");
//         }

//         if (!selectedTiffins.days[day].tiffins[tiffinNo]) {
//           selectedTiffins.days[day].tiffins[tiffinNo] = {};
//         }

//         components.forEach(comp => {

//           const categoryMap = {
//             proteins: "proteins",
//             veggies: "veggies",
//             sides: "sides",
//             probiotics: "probiotics"
//           };

//           const cat = categoryMap[comp.relatedCategory];
//           if (!cat) return;

//           // ===========================
//           // THRESHOLD LOGIC
//           // ===========================
//           const threshold = Number(priceInfo[cat] || 0);
//           const actualPrice = Number(comp.priceAmount?.amount || 0);

//              let extraPrice = 0;
//              if (actualPrice > threshold) {
//                extraPrice = actualPrice - threshold;
//                 }

//           const basePrice = actualPrice - extraPrice;

//           selectedTiffins.days[day].tiffins[tiffinNo][cat] = {
//             title: comp.title,
//             price: actualPrice.toFixed(2),
//             img: comp.image,
//             variantId: comp.productVariantId?.split("/").pop(),
//             extraprice: extraPrice.toFixed(2),
//             fromCartLine:true,
//             cartKey: cartKey,
//             cartLine: cartLine
//           };
//         });

//         // track max tiffin
//         selectedTiffins.days[day].currentTiffinSize = Math.max(
//           selectedTiffins.days[day].currentTiffinSize || 1,
//           Number(tiffinNo)
//         );
//       }

//       // ===========================
//       // ALA CARTE
//       // ===========================
//       if (props.Type === "addon") {

//         const cat = (props.Category || "").toLowerCase();
//         const variantId = item.variant_id;

//         if (!selectedTiffins.days[day].ala[cat]) {
//           selectedTiffins.days[day].ala[cat] = {};
//         }

//         selectedTiffins.days[day].ala[cat][variantId] = {
//           title: item.title,
//           price: (item.price / 100).toFixed(2),
//           img: item.image,
//           quantity: item.quantity,
//            cartKey: cartKey,
//             cartLine: cartLine,
//              fromCartLine:true,
//         };
//       }

//       // ===========================
//       // PANTRY
//       // ===========================
//       if (props.Type === "pantry") {

//         const cat = (props.Category || "").toLowerCase();
//         const variantId = item.variant_id;

//         if (!selectedTiffins.days[day].pantry[cat]) {
//           selectedTiffins.days[day].pantry[cat] = {};
//         }

//         selectedTiffins.days[day].pantry[cat][variantId] = {
//           title: item.title,
//           price: (item.price / 100).toFixed(2),
//           quantity: item.quantity,
//           variantId: variantId,
//            cartKey: cartKey,
//             cartLine: cartLine,
//              fromCartLine:true,
//              mainvariant:props._mainvariant
//         };
//       }

//            // ===========================
//       // LUNCH
//       // ===========================
//       if (props.Type === "lunch") {
//         const cat = (props.Category || "").toLowerCase();
//         const variantId = item.variant_id;

//         if (!selectedTiffins.days[day].lunch[cat]) {
//           selectedTiffins.days[day].lunch[cat] = {};
//         }

//         selectedTiffins.days[day].lunch[cat][variantId] = {
//           title: item.title,
//           img: item.image,
//           price: (item.price / 100).toFixed(2),
//           quantity: item.quantity,
//           variantId: variantId,
//            cartKey: cartKey,
//             cartLine: cartLine,
//              fromCartLine:true,
//         };
//       }

//     });

//     // ===========================
//     // SET CURRENT DAY
//     // ===========================
//     const dayKeys = Object.keys(selectedTiffins.days);
//     if (dayKeys.length) {
//       selectedTiffins.currentDay = dayKeys[0];
//     }
// updateTiffinData()
//     return selectedTiffins;

//   } catch (err) {
//     console.error("Cart sync failed", err);
//   }
// }


function ensureSelectedTiffinsBase() {
  if (!window.selectedTiffins) {
    window.selectedTiffins = {
      days: {},
      currentDay: null,
      currentTiffinSize: 1
    };
  }

  if (!selectedTiffins.days) selectedTiffins.days = {};
  if (!selectedTiffins.currentTiffinSize) selectedTiffins.currentTiffinSize = 1;

  return selectedTiffins;
}

function ensureDay(dayKey) {
  ensureSelectedTiffinsBase();

  if (!selectedTiffins.days[dayKey]) {
    selectedTiffins.days[dayKey] = {
      dayName: dayKey,
      currentTiffinSize: 1,
      tiffins: {},
      ala: {},
      pantry: {},
      lunch: {}
    };
  }

  const dayObj = selectedTiffins.days[dayKey];

  if (!dayObj.dayName) dayObj.dayName = dayKey;
  if (!dayObj.currentTiffinSize) dayObj.currentTiffinSize = 1;
  if (!dayObj.tiffins) dayObj.tiffins = {};
  if (!dayObj.ala) dayObj.ala = {};
  if (!dayObj.pantry) dayObj.pantry = {};
  if (!dayObj.lunch) dayObj.lunch = {};

  return dayObj;
}

function normalizeValue(value) {
  return String(value ?? "");
}

function isSameSelectedItem(localItem, cartItem) {
  if (!localItem || !cartItem) return false;

  return (
    normalizeValue(localItem.title) === normalizeValue(cartItem.title) &&
    normalizeValue(localItem.price) === normalizeValue(cartItem.price) &&
    normalizeValue(localItem.quantity || 1) === normalizeValue(cartItem.quantity || 1) &&
    normalizeValue(localItem.variantId || localItem.variant_id) === normalizeValue(cartItem.variantId || cartItem.variant_id) &&
    normalizeValue(localItem.cartKey) === normalizeValue(cartItem.cartKey)
  );
}

function setIfChanged(parentObj, key, cartItem) {
  const localItem = parentObj[key];

  if (isSameSelectedItem(localItem, cartItem)) {
    return false;
  }

  parentObj[key] = {
    ...(localItem || {}),
    ...cartItem
  };

  return true;
}

function pruneCartBackedItemsNotInCart(daysObj, validCartKeys) {
  Object.values(daysObj || {}).forEach(dayObj => {
    Object.values(dayObj.tiffins || {}).forEach(tiffin => {
      ["proteins", "veggies", "sides", "probiotics"].forEach(cat => {
        const item = tiffin?.[cat];

        if (item?.cartKey && !validCartKeys.has(item.cartKey)) {
          delete tiffin[cat];
        }
      });
    });

    ["ala", "pantry", "lunch"].forEach(sectionType => {
      Object.entries(dayObj[sectionType] || {}).forEach(([cat, items]) => {
        Object.entries(items || {}).forEach(([variantId, item]) => {
          if (item?.cartKey && !validCartKeys.has(item.cartKey)) {
            delete items[variantId];
          }
        });

        if (!Object.keys(items).length) {
          delete dayObj[sectionType][cat];
        }
      });
    });
  });
}

function buildCartSelectionFromCart(cart) {
  const priceInfo = window.priceThresholdsAndTitles || {};

  const cartSelection = {
    days: {},
    cartKeys: new Set()
  };

  (cart.items || []).forEach((item, index) => {
    const props = item.properties || {};
    const cartKey = item.key;
    const cartLine = index + 1;

    if (cartKey) {
      cartSelection.cartKeys.add(cartKey);
    }

    const day = (props._Day || props.Day || "").toLowerCase();
    if (!day) return;

    if (!cartSelection.days[day]) {
      cartSelection.days[day] = {
        dayName: day,
        currentTiffinSize: 1,
        tiffins: {},
        ala: {},
        pantry: {},
        lunch: {}
      };
    }

    const dayObj = cartSelection.days[day];

    // ===========================
    // MAIN TIFFIN
    // ===========================
    if (props._TiffinPlan && props._components) {
      const tiffinNo = String(props._TiffinPlan);

      let components = [];

      try {
        components = JSON.parse(props._components || "[]");
      } catch (e) {
        console.warn("Invalid components JSON", e);
      }

      if (!dayObj.tiffins[tiffinNo]) {
        dayObj.tiffins[tiffinNo] = {};
      }

      components.forEach(comp => {
        const categoryMap = {
          proteins: "proteins",
          veggies: "veggies",
          sides: "sides",
          probiotics: "probiotics"
        };

        const cat = categoryMap[comp.relatedCategory];
        if (!cat) return;

        const threshold = Number(priceInfo[cat] || 0);
        const actualPrice = Number(comp.priceAmount?.amount || 0);

        let extraPrice = 0;

        if (actualPrice > threshold) {
          extraPrice = actualPrice - threshold;
        }

        dayObj.tiffins[tiffinNo][cat] = {
          title: comp.title,
          price: actualPrice.toFixed(2),
          img: comp.image,
          variantId: comp.productVariantId?.split("/").pop(),
          extraprice: extraPrice.toFixed(2),
          fromCartLine: true,
          cartKey,
          cartLine
        };
      });

      dayObj.currentTiffinSize = Math.max(
        Number(dayObj.currentTiffinSize || 1),
        Number(tiffinNo)
      );
    }

    // ===========================
    // ALA CARTE
    // ===========================
    if (props.Type === "addon") {
      const cat = (props.Category || "").toLowerCase();
      const variantId = String(item.variant_id);

      if (!dayObj.ala[cat]) {
        dayObj.ala[cat] = {};
      }

      dayObj.ala[cat][variantId] = {
        title: item.title,
        price: (item.price / 100).toFixed(2),
        img: item.image,
        quantity: item.quantity,
        variantId,
        cartKey,
        cartLine,
        fromCartLine: true
      };
    }

    // ===========================
    // PANTRY
    // ===========================
    if (props.Type === "pantry") {
      const cat = (props.Category || "").toLowerCase();
      const variantId = String(item.variant_id);

      if (!dayObj.pantry[cat]) {
        dayObj.pantry[cat] = {};
      }

      dayObj.pantry[cat][variantId] = {
        title: item.title,
        price: (item.price / 100).toFixed(2),
        img: item.image,
        quantity: item.quantity,
        variantId,
        cartKey,
        cartLine,
        fromCartLine: true,
        mainvariant: props._mainvariant
      };
    }

    // ===========================
    // LUNCH
    // ===========================
    if (props.Type === "lunch") {
      const cat = (props.Category || "").toLowerCase();
      const variantId = String(item.variant_id);

      if (!dayObj.lunch[cat]) {
        dayObj.lunch[cat] = {};
      }

      dayObj.lunch[cat][variantId] = {
        title: item.title,
        img: item.image,
        price: (item.price / 100).toFixed(2),
        quantity: item.quantity,
        variantId,
        cartKey,
        cartLine,
        fromCartLine: true
      };
    }
  });

  return cartSelection;
}

function mergeCartSelectionIntoLocal(cartSelection) {
  ensureSelectedTiffinsBase();

  let changed = false;

  pruneCartBackedItemsNotInCart(selectedTiffins.days, cartSelection.cartKeys);

  Object.entries(cartSelection.days || {}).forEach(([dayKey, cartDay]) => {
    const localDay = ensureDay(dayKey);

    // ===========================
    // MAIN TIFFIN MERGE
    // ===========================
    Object.entries(cartDay.tiffins || {}).forEach(([tiffinNo, cartTiffin]) => {
      if (!localDay.tiffins[tiffinNo]) {
        localDay.tiffins[tiffinNo] = {};
      }

      Object.entries(cartTiffin || {}).forEach(([cat, cartItem]) => {
        const didChange = setIfChanged(localDay.tiffins[tiffinNo], cat, cartItem);
        if (didChange) changed = true;
      });

      localDay.currentTiffinSize = Math.max(
        Number(localDay.currentTiffinSize || 1),
        Number(tiffinNo)
      );
    });

    // ===========================
    // ALA / PANTRY / LUNCH MERGE
    // ===========================
    ["ala", "pantry", "lunch"].forEach(sectionType => {
      Object.entries(cartDay[sectionType] || {}).forEach(([cat, cartItems]) => {
        if (!localDay[sectionType][cat]) {
          localDay[sectionType][cat] = {};
        }

        Object.entries(cartItems || {}).forEach(([variantId, cartItem]) => {
          const didChange = setIfChanged(localDay[sectionType][cat], variantId, cartItem);
          if (didChange) changed = true;
        });
      });
    });
  });

  const dayKeys = Object.keys(selectedTiffins.days || {});

  if (!selectedTiffins.currentDay && dayKeys.length) {
    selectedTiffins.currentDay = dayKeys[0];
    changed = true;
  }

  return changed;
}

// async function syncCartToLocalStorage() {
//   try {
//     ensureSelectedTiffinsBase();

//     const cart = await fetch("/cart.js", {
//       cache: "no-store"
//     }).then(res => res.json());

//     const cartSelection = buildCartSelectionFromCart(cart);

//     const before = JSON.stringify(selectedTiffins);

//     mergeCartSelectionIntoLocal(cartSelection);

//     const after = JSON.stringify(selectedTiffins);

//     if (before !== after) {
//       updateTiffinData();
//     }

//     return selectedTiffins;
//   } catch (err) {
//     console.error("Cart sync failed", err);
//     return selectedTiffins;
//   }
// }

async function syncCartToLocalStorage(options = {}) {
  const { allowEmptyCartSync = false } = options;

  try {
    ensureSelectedTiffinsBase();

    const cart = await fetch("/cart.js", {
      cache: "no-store"
    }).then(res => res.json());

    const hasLocalItems = Object.keys(selectedTiffins.days || {}).length > 0;

    if (
      cart.item_count === 0 &&
      hasLocalItems &&
      !allowEmptyCartSync
    ) {
      console.warn("Skipped empty cart sync to protect local selections.");
      return selectedTiffins;
    }

    const cartSelection = buildCartSelectionFromCart(cart);

    const before = JSON.stringify(selectedTiffins);

    mergeCartSelectionIntoLocal(cartSelection);

    const after = JSON.stringify(selectedTiffins);

    if (before !== after) {
      updateTiffinData();
    }

    return selectedTiffins;
  } catch (err) {
    console.error("Cart sync failed", err);
    return selectedTiffins;
  }
}

function initializeActiveTiffinUI() {
  const dayKey = selectedTiffins.currentDay;
  if (!dayKey) return;

  const dayObj = selectedTiffins.days?.[dayKey];
  if (!dayObj) return;

  const tiffins = dayObj.tiffins || {};
  const requiredCats = ["proteins", "veggies", "sides", "probiotics"];

  let targetTiffin = 1;
  let found = false;

  const tiffinKeys = Object.keys(tiffins).sort((a, b) => Number(a) - Number(b));
  const dayLabel = dayKey.charAt(0).toUpperCase() + dayKey.slice(1);
  // STEP 1: incomplete
  for (let key of tiffinKeys) {
    const tiffin = tiffins[key];
    const hasAny = Object.values(tiffin || {}).some(v => v);

    if (hasAny) {
      const missing = requiredCats.filter(cat => !tiffin?.[cat]);
      if (missing.length) {
        targetTiffin = Number(key);
        found = true;
        showToast(`Switched to tiffin ${key} for ${dayLabel}`);
        break;
      }
    }
  }

  //  empty
  if (!found) {
    for (let i = 1; i <= (dayObj.currentTiffinSize || 1); i++) {
      const tiffin = tiffins[i] || {};
      const hasAny = Object.values(tiffin).some(v => v);
        selectedTiffins.currentTiffinSize = i;
        updateTiffinData()
      if (!hasAny) {
        targetTiffin = i;
        found = true;
        showToast(`You are on tiffin ${i} for ${dayLabel}`);
        break;
      }
    }
  }

  // next
  if (!found) {
    targetTiffin = (dayObj.currentTiffinSize || 1) + 1;
    showToast(`Switched to tiffin ${targetTiffin} for ${dayLabel}`);
  }

  selectedTiffins.currentTiffinSize = targetTiffin;
  updateTiffinSizeAttribute(targetTiffin);
  restoreTiffinUIFromState(); 
  toggleAddNextTiffinBtn();
}

 // ===========================
    // main restore function for main tiffin
  // ===========================
function restoreTiffinUIFromState() {
  const dayKey = selectedTiffins.currentDay;
  const tiffinId = selectedTiffins.currentTiffinSize;

  if (!dayKey) return;

  const tiffin = selectedTiffins.days?.[dayKey]?.tiffins?.[tiffinId] || {};
  const categories = ["proteins", "veggies", "sides", "probiotics"];

  categories.forEach(cat => {
    const product = tiffin?.[cat];
    // HEADER UPDATE
    const header = document.querySelector(
      `.maintiffin-selected-items-title[data-selectedtitle-name="${cat}"][data-day-name="${dayKey}"]`
    );

    const wrapper = header?.closest(".main-tiffday-selected-items");
    const selectMsg = wrapper?.querySelector(".select-item-message");
    const accordianIcon = wrapper?.querySelector(".tiffinday-cat-accordian");

    if (header) {
      header.innerHTML = product ? product.title : "";
    }

  
    if (product) {
      if (selectMsg) selectMsg.style.display = "none";
      if (accordianIcon) accordianIcon.style.display = "block";
    } else {
      if (selectMsg) selectMsg.style.display = "block";
      if (accordianIcon) accordianIcon.style.display = "none";
    }

    // RESET ALL LABELS
    document.querySelectorAll(
      `.maintiffin-products-select[data-category-name="${cat}"][data-day-date="${dayKey}"]`
    ).forEach(input => {
      input.checked = false;
      const lbl = document.querySelector(`label[for="${input.id}"]`);
      if (lbl) lbl.classList.remove("active");
    });

    // SET SELECTED PRODUCT
    if (product?.variantId) {
      const input = document.querySelector(
        `.maintiffin-products-select[data-prod-variant="${product.variantId}"][data-category-name="${cat}"][data-day-date="${dayKey}"]`
      );

      if (input) {
        input.checked = true;

        const lbl = document.querySelector(`label[for="${input.id}"]`);
        if (lbl) lbl.classList.add("active");
      }
    }
  });
}


function handleTiffinDeleteUI(category, variantId) {
  // remove header
  const header = document.querySelector(
    `.maintiffin-selected-items-title[data-selectedtitle-name="${category}"]`
  );
  if (header) header.innerHTML = "";

  // show select message
  const wrapper = header?.closest(".main-tiffday-selected-items");
  const msg = wrapper?.querySelector(".select-item-message");
  if (msg) msg.style.display = "block";

  // remove active label
  const input = document.querySelector(
    `.maintiffin-products-select[data-prod-variant="${variantId}"]`
  );

  if (input) {
    const label = document.querySelector(`label[for="${input.id}"]`);
    if (label) label.classList.remove("active");
    input.checked = false;
  }

  toggleAddNextTiffinBtn();
}


/* =================================================
   restore pantry 
================================================= */

function restorePantryData(dayName) {
  if (!selectedTiffins?.days?.[dayName]) return;
  const pantryData = selectedTiffins.days[dayName].pantry || {};
  document
    .querySelectorAll(`.pantry-addto-cart[data-day-name="${dayName}"]`)
    .forEach((btn) => {
      const mainBtn = btn.querySelector(".pantry-plus-icon-main");
      const qtySelector = btn.querySelector(".pantry-quantity-selector");
      mainBtn?.classList.remove("hidden");
      qtySelector?.classList.add("hidden");
    });


    Object.entries(pantryData).forEach(([category, categoryProducts]) => {
    Object.entries(categoryProducts).forEach(([variantId, product]) => {
      console.log('product checking',product)
      console.log('variant id data',category.toLowerCase(),dayName,product.mainvariant)
      const productli = document.querySelector(`.pantrycategory-product-li[data-category-name='${category.toLowerCase()}'][data-day-name='${dayName}'][data-prod-real-id='${product.mainvariant}']`)
      console.log('product li checking',productli)
      const btn = document.querySelector(`.pantry-addto-cart[data-day-name="${dayName}"][data-prod-variant="${product.mainvariant}"]`);
      const header = document.querySelector(`.pantrytiffin-selected-items-title[data-selectedtitle-day="${dayName}"][data-selectedtitle-name="${category}"]`);
      const selecteddropdown = productli.querySelector('.dropdown-selected');
      if(selecteddropdown)
      { 
        const firstTitle = selecteddropdown.textContent;

        btn.setAttribute('data-variant-title',firstTitle)
      }

      if (!btn) return;
      if (header) {
        const titles = Object.values(categoryProducts)
          .map((item) => item.title)
          .filter(Boolean);
        header.innerHTML = titles.length ? titles.join(", ") : "";
      }
    
    });
  });
}



function restorePantryPrices(category,dayName,variant)
{ 
  const productli = document.querySelector(`.pantrycategory-product-li[data-category-name='${category.toLowerCase()}'][data-day-name='${dayName}'][data-prod-real-id='${variant}']`);
  const btn = document.querySelector(`.pantry-addto-cart[data-day-name="${dayName}"][data-prod-variant="${variant}"]`);
       const selecteddropdown = productli?.querySelector('.dropdown-selected');
     if(selecteddropdown && btn)
      { 
        const firstTitle = selecteddropdown.textContent;
        btn.setAttribute('data-variant-title',firstTitle)
      }

}

/* =================================================
   restore lunch 
================================================= */

function restoreLunchData(dayName) {
  if (!selectedTiffins?.days?.[dayName]) return;
  const lunchData = selectedTiffins.days[dayName].lunch || {};
  console.log('restoring lunchhhhhhhhhhhhhhhhhh',lunchData)

  document
    .querySelectorAll(`.lunch-addto-cart[data-day-name="${dayName}"]`)
    .forEach((btn) => {
      const mainBtn = btn.querySelector(".lunch-plus-icon-main");
      const qtySelector = btn.querySelector(".lunch-quantity-selector");
      mainBtn?.classList.remove("hidden");
      qtySelector?.classList.add("hidden");
    });

    Object.entries(lunchData).forEach(([category, categoryProducts]) => {
    Object.entries(categoryProducts).forEach(([variantId, product]) => {
      const btn = document.querySelector(`.lunch-addto-cart[data-day-name="${dayName}"][data-prod-variant="${variantId}"]`);
      console.log('daynem and catetor fo restore',dayName,category)
      const header = document.querySelector(`.lunchtiffin-selected-items-title[data-selectedtitle-day="${dayName}"][data-selectedtitle-name="${category}"]`);
      console.log('header foundddddddddddd',header)

      if (!btn) return;

      const mainBtn = btn.querySelector(".lunch-plus-icon-main");
      const qtySelector = btn.querySelector(".lunch-quantity-selector");
      const quantityinput = btn.querySelector('input')

      mainBtn?.classList.remove("hidden");
      qtySelector?.classList.add("hidden");

      if (mainBtn) {
        mainBtn.textContent =  product.quantity;
        quantityinput.value=product.quantity;
      }
  
      if (header) {
        const titles = Object.values(categoryProducts)
          .map((item) => item.title)
          .filter(Boolean);

        header.innerHTML = titles.length ? titles.join(", ") : "";
      }
    
    });
  });
}





/* =================================================
   INIT
================================================= */
let appcontextdata = window.APP_CONTEXT;
console.log('app contxt data',appcontextdata)
let selectedTiffins = initializeTiffinData();
const activeDayData = computeActiveDaysData(window.menuData, window.menuCutOffData,appcontextdata?.menuType);
console.log('active day data',activeDayData)
scrollToTop()

  syncCartToLocalStorage().then(() => {
  initializeTiffinData()
   renderDays(appcontextdata);
    renderProductData(appcontextdata.menuType);
    renderCartSummary(appcontextdata.menuType); 
  });
  initializeTiffinData()
renderCartSummary(appcontextdata?.menuType); 


window.addEventListener("pageshow", function () {
  updateCartCount();
});

window.addEventListener("focus", function () {
  updateCartCount();
});


});



